// Generated from ./src/providers/syntax/lexer/FPlusParser.g4 by ANTLR 4.13.2
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols

import {
  ATN,
  ATNDeserializer,
  type DecisionState,
  DFA,
  FailedPredicateException,
  NoViableAltException,
  Parser,
  ParserATNSimulator,
  ParserRuleContext,
  PredictionContextCache,
  RecognitionException,
  TerminalNode,
  Token,
  type TokenStream,
} from 'antlr4'

import FPlusParserListener from './FPlusParserListener.js'
import FPlusParserVisitor from './FPlusParserVisitor.js'

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// oxlint-disable-next-line no-unused-vars
// type int = number - Manually commented out since it's not used and causes TS compile issues

export default class FPlusParser extends Parser {
  public static readonly BLOCK_EXPRESSION_ERROR_LABEL = 1
  public static readonly BLOCK_END = 2
  public static readonly WS = 3
  public static readonly COMMENT = 4
  public static readonly NL = 5
  public static readonly DOT = 6
  public static readonly COMMA = 7
  public static readonly LPAREN = 8
  public static readonly RPAREN = 9
  public static readonly LSQUARE = 10
  public static readonly RSQUARE = 11
  public static readonly LCURL = 12
  public static readonly RCURL = 13
  public static readonly MULT = 14
  public static readonly POW = 15
  public static readonly DIV = 16
  public static readonly ADD = 17
  public static readonly SUB = 18
  public static readonly XOR = 19
  public static readonly INCR = 20
  public static readonly DECR = 21
  public static readonly CONJ = 22
  public static readonly NOT = 23
  public static readonly MONEYDECIMAL = 24
  public static readonly MONEY = 25
  public static readonly DISJ = 26
  public static readonly PERCENT = 27
  public static readonly EXCL = 28
  public static readonly COLON = 29
  public static readonly SEMICOLON = 30
  public static readonly ASSIGNMENT = 31
  public static readonly ARROW = 32
  public static readonly DOUBLE_ARROW = 33
  public static readonly RANGE = 34
  public static readonly COLON_COLON = 35
  public static readonly DOUBLE_SEMICOLON = 36
  public static readonly QUEST = 37
  public static readonly QUEST_COLON = 38
  public static readonly LANGLE = 39
  public static readonly RANGLE = 40
  public static readonly LE = 41
  public static readonly GE = 42
  public static readonly EXCL_EQ = 43
  public static readonly AT = 44
  public static readonly UNDERSCORE = 45
  public static readonly POUND = 46
  public static readonly MAP = 47
  public static readonly FUN = 48
  public static readonly LET = 49
  public static readonly IMPORT = 50
  public static readonly ASSERT = 51
  public static readonly VAR = 52
  public static readonly WHERE = 53
  public static readonly IF = 54
  public static readonly THEN = 55
  public static readonly ELSE = 56
  public static readonly WHEN = 57
  public static readonly AS = 58
  public static readonly IS = 59
  public static readonly IN = 60
  public static readonly OUT = 61
  public static readonly USE = 62
  public static readonly NOT_IS = 63
  public static readonly NOT_IN = 64
  public static readonly IS_IN = 65
  public static readonly DecimalLiteral = 66
  public static readonly IntegerLiteral = 67
  public static readonly MoneyDecimalLiteral = 68
  public static readonly MoneyLiteral = 69
  public static readonly BooleanLiteral = 70
  public static readonly UndefinedLiteral = 71
  public static readonly DateLiteral = 72
  public static readonly Identifier = 73
  public static readonly IdentifierOrSoftKey = 74
  public static readonly SINGLE_QUOTE_OPEN = 75
  public static readonly QUOTE_OPEN = 76
  public static readonly TRIPLE_QUOTE_OPEN = 77
  public static readonly UNICODE_CLASS_LL = 78
  public static readonly UNICODE_CLASS_LM = 79
  public static readonly UNICODE_CLASS_LO = 80
  public static readonly UNICODE_CLASS_LT = 81
  public static readonly UNICODE_CLASS_LU = 82
  public static readonly UNICODE_CLASS_ND = 83
  public static readonly UNICODE_CLASS_NL = 84
  public static readonly QUOTE_CLOSE = 85
  public static readonly LineStrText = 86
  public static readonly LineStrEscapedChar = 87
  public static readonly LineStrExprStart = 88
  public static readonly SINGLE_QUOTE_CLOSE = 89
  public static readonly SingleLineStrText = 90
  public static readonly SingleLineStrEscapedChar = 91
  public static readonly SingleLineStrExprStart = 92
  public static readonly TRIPLE_QUOTE_CLOSE = 93
  public static readonly MultiLineStringQuote = 94
  public static readonly MultiLineStrText = 95
  public static readonly MultiLineStrEscapedChar = 96
  public static readonly MultiLineStrExprStart = 97
  public static readonly ErrorCharacter = 98
  public static override readonly EOF = Token.EOF
  public static readonly RULE_functionScript = 0
  public static readonly RULE_expressionScript = 1
  public static readonly RULE_typeParameters = 2
  public static readonly RULE_typeParameter = 3
  public static readonly RULE_functionValueParameters = 4
  public static readonly RULE_functionValueParameter = 5
  public static readonly RULE_functionValueParametersWithOptionalType = 6
  public static readonly RULE_deconstructuringDeclaration = 7
  public static readonly RULE_variableDeclaration = 8
  public static readonly RULE_commaOrSemicolon = 9
  public static readonly RULE_propertyInitializer = 10
  public static readonly RULE_assertInitializer = 11
  public static readonly RULE_importInitializer = 12
  public static readonly RULE_letInitializer = 13
  public static readonly RULE_propertyDeclaration = 14
  public static readonly RULE_parameterWithOptionalType = 15
  public static readonly RULE_parameter = 16
  public static readonly RULE_type = 17
  public static readonly RULE_tupleType = 18
  public static readonly RULE_userType = 19
  public static readonly RULE_functionType = 20
  public static readonly RULE_functionTypeParameters = 21
  public static readonly RULE_parenthesizedType = 22
  public static readonly RULE_receiverType = 23
  public static readonly RULE_semi = 24
  public static readonly RULE_expression = 25
  public static readonly RULE_expressionWithoutFunctionLiteral = 26
  public static readonly RULE_functionDefinition = 27
  public static readonly RULE_disjunction = 28
  public static readonly RULE_conjunction = 29
  public static readonly RULE_xor = 30
  public static readonly RULE_equality = 31
  public static readonly RULE_comparison = 32
  public static readonly RULE_infixOperation = 33
  public static readonly RULE_infixOperationEntry = 34
  public static readonly RULE_elvisExpression = 35
  public static readonly RULE_infixFunctionCall = 36
  public static readonly RULE_additiveExpression = 37
  public static readonly RULE_multiplicativeExpression = 38
  public static readonly RULE_powerExpression = 39
  public static readonly RULE_asExpression = 40
  public static readonly RULE_prefixUnaryExpression = 41
  public static readonly RULE_unaryPrefix = 42
  public static readonly RULE_postfixUnaryExpression = 43
  public static readonly RULE_postfixUnarySuffix = 44
  public static readonly RULE_isDefinedSuffix = 45
  public static readonly RULE_indexingSuffix = 46
  public static readonly RULE_notUndefinedAssertion = 47
  public static readonly RULE_percentOperator = 48
  public static readonly RULE_navigationSuffix = 49
  public static readonly RULE_callSuffix = 50
  public static readonly RULE_variance = 51
  public static readonly RULE_varianceType = 52
  public static readonly RULE_typeArguments = 53
  public static readonly RULE_typeArgumentsWithoutVariance = 54
  public static readonly RULE_valueArguments = 55
  public static readonly RULE_valueArgument = 56
  public static readonly RULE_primaryExpression = 57
  public static readonly RULE_parenthesizedExpression = 58
  public static readonly RULE_mapPair = 59
  public static readonly RULE_mapLiteral = 60
  public static readonly RULE_setLiteral = 61
  public static readonly RULE_listLiteral = 62
  public static readonly RULE_rangeLiteral = 63
  public static readonly RULE_tupleLiteral = 64
  public static readonly RULE_implicitVariableLiteral = 65
  public static readonly RULE_implicitNavigation = 66
  public static readonly RULE_literalConstant = 67
  public static readonly RULE_stringLiteral = 68
  public static readonly RULE_singleQuoteStringLiteral = 69
  public static readonly RULE_singleLineStringLiteralEntry = 70
  public static readonly RULE_singleLineStringContent = 71
  public static readonly RULE_singleLineStringExpression = 72
  public static readonly RULE_lineStringLiteral = 73
  public static readonly RULE_lineStringLiteralEntry = 74
  public static readonly RULE_lineStringContent = 75
  public static readonly RULE_lineStringExpression = 76
  public static readonly RULE_multiLineStringLiteral = 77
  public static readonly RULE_multiLineStringLiteralEntry = 78
  public static readonly RULE_multiLineStringContent = 79
  public static readonly RULE_multiLineStringExpression = 80
  public static readonly RULE_lambdaLiteral = 81
  public static readonly RULE_anonymousFunction = 82
  public static readonly RULE_functionLiteral = 83
  public static readonly RULE_ifExpression = 84
  public static readonly RULE_whenSubject = 85
  public static readonly RULE_whenExpression = 86
  public static readonly RULE_whenArrowBody = 87
  public static readonly RULE_whenArrowEntry = 88
  public static readonly RULE_whenColonBody = 89
  public static readonly RULE_whenColonEntry = 90
  public static readonly RULE_whenCondition = 91
  public static readonly RULE_tupleTestEntry = 92
  public static readonly RULE_tupleTest = 93
  public static readonly RULE_rangeTest = 94
  public static readonly RULE_typeTest = 95
  public static readonly RULE_equalityOperator = 96
  public static readonly RULE_comparisonOperator = 97
  public static readonly RULE_inOperator = 98
  public static readonly RULE_isOperator = 99
  public static readonly RULE_additiveOperator = 100
  public static readonly RULE_multiplicativeOperator = 101
  public static readonly RULE_powerOperator = 102
  public static readonly RULE_prefixUnaryOperator = 103
  public static readonly RULE_excl = 104
  public static readonly RULE_simpleIdentifier = 105
  public static readonly RULE_navigationIdentifier = 106
  public static readonly literalNames: (string | null)[] = [
    null,
    null,
    "'\\u00A7/BLOCK'",
    null,
    null,
    null,
    "'.'",
    "','",
    "'('",
    "')'",
    "'['",
    "']'",
    "'{'",
    "'}'",
    "'*'",
    "'^'",
    "'/'",
    "'+'",
    "'-'",
    "'xor'",
    "'++'",
    "'--'",
    "'and'",
    "'not'",
    null,
    null,
    "'or'",
    "'%'",
    "'!'",
    "':'",
    "';'",
    "'='",
    "'->'",
    "'=>'",
    "'..'",
    "'::'",
    "';;'",
    "'?'",
    "'?:'",
    "'<'",
    "'>'",
    "'<='",
    "'>='",
    "'!='",
    "'@'",
    "'_'",
    "'#'",
    "'map'",
    "'fun'",
    "'let'",
    "'import'",
    "'assert'",
    "'var'",
    "'where'",
    "'if'",
    "'then'",
    "'else'",
    "'when'",
    "'as'",
    "'is'",
    "'in'",
    "'out'",
    "'use'",
    "'isnot'",
    "'notin'",
    "'isin'",
    null,
    null,
    null,
    null,
    null,
    "'undefined'",
    null,
    null,
    null,
    null,
    null,
    '\'"""\'',
  ]
  public static readonly symbolicNames: (string | null)[] = [
    null,
    'BLOCK_EXPRESSION_ERROR_LABEL',
    'BLOCK_END',
    'WS',
    'COMMENT',
    'NL',
    'DOT',
    'COMMA',
    'LPAREN',
    'RPAREN',
    'LSQUARE',
    'RSQUARE',
    'LCURL',
    'RCURL',
    'MULT',
    'POW',
    'DIV',
    'ADD',
    'SUB',
    'XOR',
    'INCR',
    'DECR',
    'CONJ',
    'NOT',
    'MONEYDECIMAL',
    'MONEY',
    'DISJ',
    'PERCENT',
    'EXCL',
    'COLON',
    'SEMICOLON',
    'ASSIGNMENT',
    'ARROW',
    'DOUBLE_ARROW',
    'RANGE',
    'COLON_COLON',
    'DOUBLE_SEMICOLON',
    'QUEST',
    'QUEST_COLON',
    'LANGLE',
    'RANGLE',
    'LE',
    'GE',
    'EXCL_EQ',
    'AT',
    'UNDERSCORE',
    'POUND',
    'MAP',
    'FUN',
    'LET',
    'IMPORT',
    'ASSERT',
    'VAR',
    'WHERE',
    'IF',
    'THEN',
    'ELSE',
    'WHEN',
    'AS',
    'IS',
    'IN',
    'OUT',
    'USE',
    'NOT_IS',
    'NOT_IN',
    'IS_IN',
    'DecimalLiteral',
    'IntegerLiteral',
    'MoneyDecimalLiteral',
    'MoneyLiteral',
    'BooleanLiteral',
    'UndefinedLiteral',
    'DateLiteral',
    'Identifier',
    'IdentifierOrSoftKey',
    'SINGLE_QUOTE_OPEN',
    'QUOTE_OPEN',
    'TRIPLE_QUOTE_OPEN',
    'UNICODE_CLASS_LL',
    'UNICODE_CLASS_LM',
    'UNICODE_CLASS_LO',
    'UNICODE_CLASS_LT',
    'UNICODE_CLASS_LU',
    'UNICODE_CLASS_ND',
    'UNICODE_CLASS_NL',
    'QUOTE_CLOSE',
    'LineStrText',
    'LineStrEscapedChar',
    'LineStrExprStart',
    'SINGLE_QUOTE_CLOSE',
    'SingleLineStrText',
    'SingleLineStrEscapedChar',
    'SingleLineStrExprStart',
    'TRIPLE_QUOTE_CLOSE',
    'MultiLineStringQuote',
    'MultiLineStrText',
    'MultiLineStrEscapedChar',
    'MultiLineStrExprStart',
    'ErrorCharacter',
  ]
  // tslint:disable:no-trailing-whitespace
  public static readonly ruleNames: string[] = [
    'functionScript',
    'expressionScript',
    'typeParameters',
    'typeParameter',
    'functionValueParameters',
    'functionValueParameter',
    'functionValueParametersWithOptionalType',
    'deconstructuringDeclaration',
    'variableDeclaration',
    'commaOrSemicolon',
    'propertyInitializer',
    'assertInitializer',
    'importInitializer',
    'letInitializer',
    'propertyDeclaration',
    'parameterWithOptionalType',
    'parameter',
    'type',
    'tupleType',
    'userType',
    'functionType',
    'functionTypeParameters',
    'parenthesizedType',
    'receiverType',
    'semi',
    'expression',
    'expressionWithoutFunctionLiteral',
    'functionDefinition',
    'disjunction',
    'conjunction',
    'xor',
    'equality',
    'comparison',
    'infixOperation',
    'infixOperationEntry',
    'elvisExpression',
    'infixFunctionCall',
    'additiveExpression',
    'multiplicativeExpression',
    'powerExpression',
    'asExpression',
    'prefixUnaryExpression',
    'unaryPrefix',
    'postfixUnaryExpression',
    'postfixUnarySuffix',
    'isDefinedSuffix',
    'indexingSuffix',
    'notUndefinedAssertion',
    'percentOperator',
    'navigationSuffix',
    'callSuffix',
    'variance',
    'varianceType',
    'typeArguments',
    'typeArgumentsWithoutVariance',
    'valueArguments',
    'valueArgument',
    'primaryExpression',
    'parenthesizedExpression',
    'mapPair',
    'mapLiteral',
    'setLiteral',
    'listLiteral',
    'rangeLiteral',
    'tupleLiteral',
    'implicitVariableLiteral',
    'implicitNavigation',
    'literalConstant',
    'stringLiteral',
    'singleQuoteStringLiteral',
    'singleLineStringLiteralEntry',
    'singleLineStringContent',
    'singleLineStringExpression',
    'lineStringLiteral',
    'lineStringLiteralEntry',
    'lineStringContent',
    'lineStringExpression',
    'multiLineStringLiteral',
    'multiLineStringLiteralEntry',
    'multiLineStringContent',
    'multiLineStringExpression',
    'lambdaLiteral',
    'anonymousFunction',
    'functionLiteral',
    'ifExpression',
    'whenSubject',
    'whenExpression',
    'whenArrowBody',
    'whenArrowEntry',
    'whenColonBody',
    'whenColonEntry',
    'whenCondition',
    'tupleTestEntry',
    'tupleTest',
    'rangeTest',
    'typeTest',
    'equalityOperator',
    'comparisonOperator',
    'inOperator',
    'isOperator',
    'additiveOperator',
    'multiplicativeOperator',
    'powerOperator',
    'prefixUnaryOperator',
    'excl',
    'simpleIdentifier',
    'navigationIdentifier',
  ]
  public get grammarFileName(): string {
    return 'FPlusParser.g4'
  }
  public get literalNames(): (string | null)[] {
    return FPlusParser.literalNames
  }
  public get symbolicNames(): (string | null)[] {
    return FPlusParser.symbolicNames
  }
  public get ruleNames(): string[] {
    return FPlusParser.ruleNames
  }
  public get serializedATN(): number[] {
    return FPlusParser._serializedATN
  }

  protected createFailedPredicateException(
    predicate?: string,
    message?: string,
  ): FailedPredicateException {
    return new FailedPredicateException(this, predicate, message)
  }

  constructor(input: TokenStream) {
    super(input)
    this._interp = new ParserATNSimulator(
      this,
      FPlusParser._ATN,
      FPlusParser.DecisionsToDFA,
      new PredictionContextCache(),
    )
  }
  // @RuleVersion(0)
  public functionScript(): FunctionScriptContext {
    let localctx: FunctionScriptContext = new FunctionScriptContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 0, FPlusParser.RULE_functionScript)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 214
        this.functionDefinition()
        this.state = 215
        this.match(FPlusParser.ASSIGNMENT)
        this.state = 216
        localctx._body = this.expressionScript()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public expressionScript(): ExpressionScriptContext {
    let localctx: ExpressionScriptContext = new ExpressionScriptContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 2, FPlusParser.RULE_expressionScript)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 218
        this.expression()
        this.state = 219
        this.match(FPlusParser.EOF)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public typeParameters(): TypeParametersContext {
    let localctx: TypeParametersContext = new TypeParametersContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 4, FPlusParser.RULE_typeParameters)
    let _la: number
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 221
        this.match(FPlusParser.LANGLE)
        this.state = 222
        this.typeParameter()
        this.state = 227
        this._errHandler.sync(this)
        _alt = this._interp.adaptivePredict(this._input, 0, this._ctx)
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            {
              {
                this.state = 223
                this.match(FPlusParser.COMMA)
                this.state = 224
                this.typeParameter()
              }
            }
          }
          this.state = 229
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 0, this._ctx)
        }
        this.state = 231
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 7) {
          {
            this.state = 230
            this.match(FPlusParser.COMMA)
          }
        }

        this.state = 233
        this.match(FPlusParser.RANGLE)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public typeParameter(): TypeParameterContext {
    let localctx: TypeParameterContext = new TypeParameterContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 6, FPlusParser.RULE_typeParameter)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 235
        this.simpleIdentifier()
        this.state = 238
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 29) {
          {
            this.state = 236
            this.match(FPlusParser.COLON)
            this.state = 237
            this.type_()
          }
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public functionValueParameters(): FunctionValueParametersContext {
    let localctx: FunctionValueParametersContext =
      new FunctionValueParametersContext(this, this._ctx, this.state)
    this.enterRule(localctx, 8, FPlusParser.RULE_functionValueParameters)
    let _la: number
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 240
        this.match(FPlusParser.LPAREN)
        this.state = 252
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (
          ((_la - 47) & ~0x1f) === 0 &&
          ((1 << (_la - 47)) & 67502161) !== 0
        ) {
          {
            this.state = 241
            this.functionValueParameter()
            this.state = 246
            this._errHandler.sync(this)
            _alt = this._interp.adaptivePredict(this._input, 3, this._ctx)
            while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
              if (_alt === 1) {
                {
                  {
                    this.state = 242
                    this.match(FPlusParser.COMMA)
                    this.state = 243
                    this.functionValueParameter()
                  }
                }
              }
              this.state = 248
              this._errHandler.sync(this)
              _alt = this._interp.adaptivePredict(this._input, 3, this._ctx)
            }
            this.state = 250
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            if (_la === 7) {
              {
                this.state = 249
                this.match(FPlusParser.COMMA)
              }
            }
          }
        }

        this.state = 254
        this.match(FPlusParser.RPAREN)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public functionValueParameter(): FunctionValueParameterContext {
    let localctx: FunctionValueParameterContext =
      new FunctionValueParameterContext(this, this._ctx, this.state)
    this.enterRule(localctx, 10, FPlusParser.RULE_functionValueParameter)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 256
        this.parameter()
        this.state = 259
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 31) {
          {
            this.state = 257
            this.match(FPlusParser.ASSIGNMENT)
            this.state = 258
            this.expression()
          }
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public functionValueParametersWithOptionalType(): FunctionValueParametersWithOptionalTypeContext {
    let localctx: FunctionValueParametersWithOptionalTypeContext =
      new FunctionValueParametersWithOptionalTypeContext(
        this,
        this._ctx,
        this.state,
      )
    this.enterRule(
      localctx,
      12,
      FPlusParser.RULE_functionValueParametersWithOptionalType,
    )
    let _la: number
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 261
        this.match(FPlusParser.LPAREN)
        this.state = 273
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (
          ((_la - 47) & ~0x1f) === 0 &&
          ((1 << (_la - 47)) & 67502161) !== 0
        ) {
          {
            this.state = 262
            this.parameterWithOptionalType()
            this.state = 267
            this._errHandler.sync(this)
            _alt = this._interp.adaptivePredict(this._input, 7, this._ctx)
            while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
              if (_alt === 1) {
                {
                  {
                    this.state = 263
                    this.match(FPlusParser.COMMA)
                    this.state = 264
                    this.parameterWithOptionalType()
                  }
                }
              }
              this.state = 269
              this._errHandler.sync(this)
              _alt = this._interp.adaptivePredict(this._input, 7, this._ctx)
            }
            this.state = 271
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            if (_la === 7) {
              {
                this.state = 270
                this.match(FPlusParser.COMMA)
              }
            }
          }
        }

        this.state = 275
        this.match(FPlusParser.RPAREN)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public deconstructuringDeclaration(): DeconstructuringDeclarationContext {
    let localctx: DeconstructuringDeclarationContext =
      new DeconstructuringDeclarationContext(this, this._ctx, this.state)
    this.enterRule(localctx, 14, FPlusParser.RULE_deconstructuringDeclaration)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 277
        this.match(FPlusParser.LPAREN)
        this.state = 278
        this.simpleIdentifier()
        this.state = 281
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        do {
          {
            {
              this.state = 279
              this.match(FPlusParser.COMMA)
              this.state = 280
              this.simpleIdentifier()
            }
          }
          this.state = 283
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        } while (_la === 7)
        this.state = 285
        this.match(FPlusParser.RPAREN)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public variableDeclaration(): VariableDeclarationContext {
    let localctx: VariableDeclarationContext = new VariableDeclarationContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 16, FPlusParser.RULE_variableDeclaration)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 289
        this._errHandler.sync(this)
        switch (this._input.LA(1)) {
          case 47:
          case 51:
          case 53:
          case 64:
          case 65:
          case 73:
            {
              this.state = 287
              localctx._id = this.simpleIdentifier()
            }
            break
          case 8:
            {
              this.state = 288
              localctx._tupleId = this.deconstructuringDeclaration()
            }
            break
          default:
            throw new NoViableAltException(this)
        }
        this.state = 293
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 29) {
          {
            this.state = 291
            this.match(FPlusParser.COLON)
            this.state = 292
            this.type_()
          }
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public commaOrSemicolon(): CommaOrSemicolonContext {
    let localctx: CommaOrSemicolonContext = new CommaOrSemicolonContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 18, FPlusParser.RULE_commaOrSemicolon)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 295
        _la = this._input.LA(1)
        if (!(_la === 7 || _la === 30)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public propertyInitializer(): PropertyInitializerContext {
    let localctx: PropertyInitializerContext = new PropertyInitializerContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 20, FPlusParser.RULE_propertyInitializer)
    let _la: number
    try {
      let _alt: number
      this.state = 336
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 49:
          localctx = new LetDeclarationInitializerContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 297
            this.match(FPlusParser.LET)
            {
              this.state = 298
              this.letInitializer()
              this.state = 304
              this._errHandler.sync(this)
              _alt = this._interp.adaptivePredict(this._input, 13, this._ctx)
              while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                if (_alt === 1) {
                  {
                    {
                      this.state = 299
                      this.commaOrSemicolon()
                      this.state = 300
                      this.letInitializer()
                    }
                  }
                }
                this.state = 306
                this._errHandler.sync(this)
                _alt = this._interp.adaptivePredict(this._input, 13, this._ctx)
              }
            }
            this.state = 308
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            if (_la === 30) {
              {
                this.state = 307
                this.match(FPlusParser.SEMICOLON)
              }
            }
          }
          break
        case 51:
          localctx = new AssertDeclarationInitializerContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 310
            this.match(FPlusParser.ASSERT)
            {
              this.state = 311
              this.assertInitializer()
              this.state = 317
              this._errHandler.sync(this)
              _alt = this._interp.adaptivePredict(this._input, 15, this._ctx)
              while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                if (_alt === 1) {
                  {
                    {
                      this.state = 312
                      this.commaOrSemicolon()
                      this.state = 313
                      this.assertInitializer()
                    }
                  }
                }
                this.state = 319
                this._errHandler.sync(this)
                _alt = this._interp.adaptivePredict(this._input, 15, this._ctx)
              }
            }
            this.state = 321
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            if (_la === 30) {
              {
                this.state = 320
                this.match(FPlusParser.SEMICOLON)
              }
            }
          }
          break
        case 50:
          localctx = new ImportDeclarationInitializerContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 323
            this.match(FPlusParser.IMPORT)
            {
              this.state = 324
              this.importInitializer()
              this.state = 330
              this._errHandler.sync(this)
              _alt = this._interp.adaptivePredict(this._input, 17, this._ctx)
              while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                if (_alt === 1) {
                  {
                    {
                      this.state = 325
                      this.commaOrSemicolon()
                      this.state = 326
                      this.importInitializer()
                    }
                  }
                }
                this.state = 332
                this._errHandler.sync(this)
                _alt = this._interp.adaptivePredict(this._input, 17, this._ctx)
              }
            }
            this.state = 334
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            if (_la === 30) {
              {
                this.state = 333
                this.match(FPlusParser.SEMICOLON)
              }
            }
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public assertInitializer(): AssertInitializerContext {
    let localctx: AssertInitializerContext = new AssertInitializerContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 22, FPlusParser.RULE_assertInitializer)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 338
        this.match(FPlusParser.LPAREN)
        this.state = 339
        localctx._cond = this.expression()
        this.state = 340
        this.match(FPlusParser.RPAREN)
        this.state = 341
        localctx._error = this.expression()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public importInitializer(): ImportInitializerContext {
    let localctx: ImportInitializerContext = new ImportInitializerContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 24, FPlusParser.RULE_importInitializer)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 343
        this.simpleIdentifier()
        {
          this.state = 345
          this._errHandler.sync(this)
          _la = this._input.LA(1)
          if (_la === 8) {
            {
              this.state = 344
              this.valueArguments()
            }
          }
        }
        this.state = 348
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 6) {
          {
            this.state = 347
            this.navigationSuffix()
          }
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public letInitializer(): LetInitializerContext {
    let localctx: LetInitializerContext = new LetInitializerContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 26, FPlusParser.RULE_letInitializer)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 355
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 23, this._ctx)) {
          case 1:
            {
              this.state = 351
              this._errHandler.sync(this)
              _la = this._input.LA(1)
              if (_la === 52) {
                {
                  this.state = 350
                  this.match(FPlusParser.VAR)
                }
              }

              this.state = 353
              this.variableDeclaration()
            }
            break
          case 2:
            {
              this.state = 354
              this.functionDefinition()
            }
            break
        }
        {
          {
            this.state = 357
            this.match(FPlusParser.ASSIGNMENT)
            this.state = 358
            localctx._body = this.expression()
          }
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public propertyDeclaration(): PropertyDeclarationContext {
    let localctx: PropertyDeclarationContext = new PropertyDeclarationContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 28, FPlusParser.RULE_propertyDeclaration)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 361
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        do {
          {
            {
              this.state = 360
              this.propertyInitializer()
            }
          }
          this.state = 363
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        } while (((_la - 49) & ~0x1f) === 0 && ((1 << (_la - 49)) & 7) !== 0)
        this.state = 365
        this.match(FPlusParser.IN)
        this.state = 366
        localctx._in_ = this.expression()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public parameterWithOptionalType(): ParameterWithOptionalTypeContext {
    let localctx: ParameterWithOptionalTypeContext =
      new ParameterWithOptionalTypeContext(this, this._ctx, this.state)
    this.enterRule(localctx, 30, FPlusParser.RULE_parameterWithOptionalType)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 368
        this.simpleIdentifier()
        this.state = 370
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 28) {
          {
            this.state = 369
            this.match(FPlusParser.EXCL)
          }
        }

        this.state = 374
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 29) {
          {
            this.state = 372
            this.match(FPlusParser.COLON)
            this.state = 373
            this.type_()
          }
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public parameter(): ParameterContext {
    let localctx: ParameterContext = new ParameterContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 32, FPlusParser.RULE_parameter)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 376
        this.simpleIdentifier()
        this.state = 378
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 28) {
          {
            this.state = 377
            this.match(FPlusParser.EXCL)
          }
        }

        this.state = 380
        this.match(FPlusParser.COLON)
        this.state = 381
        this.type_()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public type_(): TypeContext {
    let localctx: TypeContext = new TypeContext(this, this._ctx, this.state)
    this.enterRule(localctx, 34, FPlusParser.RULE_type)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 387
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 28, this._ctx)) {
          case 1:
            {
              this.state = 383
              this.parenthesizedType()
            }
            break
          case 2:
            {
              this.state = 384
              this.userType()
            }
            break
          case 3:
            {
              this.state = 385
              this.functionType()
            }
            break
          case 4:
            {
              this.state = 386
              this.tupleType()
            }
            break
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public tupleType(): TupleTypeContext {
    let localctx: TupleTypeContext = new TupleTypeContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 36, FPlusParser.RULE_tupleType)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 389
        this.match(FPlusParser.LPAREN)
        this.state = 390
        this.type_()
        this.state = 393
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        do {
          {
            {
              this.state = 391
              this.match(FPlusParser.COMMA)
              this.state = 392
              this.type_()
            }
          }
          this.state = 395
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        } while (_la === 7)
        this.state = 397
        this.match(FPlusParser.RPAREN)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public userType(): UserTypeContext {
    let localctx: UserTypeContext = new UserTypeContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 38, FPlusParser.RULE_userType)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 399
        this.simpleIdentifier()
        this.state = 401
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 30, this._ctx)) {
          case 1:
            {
              this.state = 400
              this.typeArguments()
            }
            break
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public functionType(): FunctionTypeContext {
    let localctx: FunctionTypeContext = new FunctionTypeContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 40, FPlusParser.RULE_functionType)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 406
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 31, this._ctx)) {
          case 1:
            {
              this.state = 403
              this.receiverType()
              this.state = 404
              this.match(FPlusParser.DOT)
            }
            break
        }
        this.state = 408
        this.functionTypeParameters()
        this.state = 409
        this.match(FPlusParser.ARROW)
        this.state = 410
        this.type_()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public functionTypeParameters(): FunctionTypeParametersContext {
    let localctx: FunctionTypeParametersContext =
      new FunctionTypeParametersContext(this, this._ctx, this.state)
    this.enterRule(localctx, 42, FPlusParser.RULE_functionTypeParameters)
    let _la: number
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 412
        this.match(FPlusParser.LPAREN)
        this.state = 414
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (
          _la === 8 ||
          (((_la - 47) & ~0x1f) === 0 && ((1 << (_la - 47)) & 67502161) !== 0)
        ) {
          {
            this.state = 413
            this.type_()
          }
        }

        this.state = 420
        this._errHandler.sync(this)
        _alt = this._interp.adaptivePredict(this._input, 33, this._ctx)
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            {
              {
                this.state = 416
                this.match(FPlusParser.COMMA)
                {
                  this.state = 417
                  this.type_()
                }
              }
            }
          }
          this.state = 422
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 33, this._ctx)
        }
        this.state = 424
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 7) {
          {
            this.state = 423
            this.match(FPlusParser.COMMA)
          }
        }

        this.state = 426
        this.match(FPlusParser.RPAREN)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public parenthesizedType(): ParenthesizedTypeContext {
    let localctx: ParenthesizedTypeContext = new ParenthesizedTypeContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 44, FPlusParser.RULE_parenthesizedType)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 428
        this.match(FPlusParser.LPAREN)
        this.state = 429
        this.type_()
        this.state = 430
        this.match(FPlusParser.RPAREN)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public receiverType(): ReceiverTypeContext {
    let localctx: ReceiverTypeContext = new ReceiverTypeContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 46, FPlusParser.RULE_receiverType)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 434
        this._errHandler.sync(this)
        switch (this._input.LA(1)) {
          case 8:
            {
              this.state = 432
              this.parenthesizedType()
            }
            break
          case 47:
          case 51:
          case 53:
          case 64:
          case 65:
          case 73:
            {
              this.state = 433
              this.userType()
            }
            break
          default:
            throw new NoViableAltException(this)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public semi(): SemiContext {
    let localctx: SemiContext = new SemiContext(this, this._ctx, this.state)
    this.enterRule(localctx, 48, FPlusParser.RULE_semi)
    let _la: number
    try {
      this.state = 438
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 5:
        case 30:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 436
            _la = this._input.LA(1)
            if (!(_la === 5 || _la === 30)) {
              this._errHandler.recoverInline(this)
            } else {
              this._errHandler.reportMatch(this)
              this.consume()
            }
          }
          break
        case -1:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 437
            this.match(FPlusParser.EOF)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public expression(): ExpressionContext {
    let localctx: ExpressionContext = new ExpressionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 50, FPlusParser.RULE_expression)
    try {
      this.state = 442
      this._errHandler.sync(this)
      switch (this._interp.adaptivePredict(this._input, 37, this._ctx)) {
        case 1:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 440
            this.functionLiteral()
          }
          break
        case 2:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 441
            this.expressionWithoutFunctionLiteral()
          }
          break
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public expressionWithoutFunctionLiteral(): ExpressionWithoutFunctionLiteralContext {
    let localctx: ExpressionWithoutFunctionLiteralContext =
      new ExpressionWithoutFunctionLiteralContext(this, this._ctx, this.state)
    this.enterRule(
      localctx,
      52,
      FPlusParser.RULE_expressionWithoutFunctionLiteral,
    )
    try {
      this.state = 448
      this._errHandler.sync(this)
      switch (this._interp.adaptivePredict(this._input, 38, this._ctx)) {
        case 1:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 444
            this.propertyDeclaration()
          }
          break
        case 2:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 445
            this.ifExpression()
          }
          break
        case 3:
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 446
            this.whenExpression()
          }
          break
        case 4:
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 447
            this.disjunction()
          }
          break
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public functionDefinition(): FunctionDefinitionContext {
    let localctx: FunctionDefinitionContext = new FunctionDefinitionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 54, FPlusParser.RULE_functionDefinition)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 451
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 39) {
          {
            this.state = 450
            this.typeParameters()
          }
        }

        this.state = 456
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 40, this._ctx)) {
          case 1:
            {
              this.state = 453
              this.receiverType()
              this.state = 454
              this.match(FPlusParser.DOT)
            }
            break
        }
        this.state = 458
        this.simpleIdentifier()
        this.state = 459
        this.functionValueParameters()
        {
          this.state = 460
          this.match(FPlusParser.COLON)
          this.state = 461
          this.type_()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public disjunction(): DisjunctionContext {
    let localctx: DisjunctionContext = new DisjunctionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 56, FPlusParser.RULE_disjunction)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 463
        this.conjunction()
        this.state = 468
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 26) {
          {
            {
              this.state = 464
              this.match(FPlusParser.DISJ)
              this.state = 465
              this.conjunction()
            }
          }
          this.state = 470
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public conjunction(): ConjunctionContext {
    let localctx: ConjunctionContext = new ConjunctionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 58, FPlusParser.RULE_conjunction)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 471
        this.xor()
        this.state = 476
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 22) {
          {
            {
              this.state = 472
              this.match(FPlusParser.CONJ)
              this.state = 473
              this.xor()
            }
          }
          this.state = 478
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public xor(): XorContext {
    let localctx: XorContext = new XorContext(this, this._ctx, this.state)
    this.enterRule(localctx, 60, FPlusParser.RULE_xor)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 479
        this.equality()
        this.state = 484
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 19) {
          {
            {
              this.state = 480
              this.match(FPlusParser.XOR)
              this.state = 481
              this.equality()
            }
          }
          this.state = 486
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public equality(): EqualityContext {
    let localctx: EqualityContext = new EqualityContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 62, FPlusParser.RULE_equality)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 487
        this.comparison()
        this.state = 493
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 31 || _la === 43) {
          {
            {
              this.state = 488
              this.equalityOperator()
              this.state = 489
              this.comparison()
            }
          }
          this.state = 495
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public comparison(): ComparisonContext {
    let localctx: ComparisonContext = new ComparisonContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 64, FPlusParser.RULE_comparison)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 496
        this.infixOperation()
        this.state = 502
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (((_la - 39) & ~0x1f) === 0 && ((1 << (_la - 39)) & 15) !== 0) {
          {
            {
              this.state = 497
              this.comparisonOperator()
              this.state = 498
              this.infixOperation()
            }
          }
          this.state = 504
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public infixOperation(): InfixOperationContext {
    let localctx: InfixOperationContext = new InfixOperationContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 66, FPlusParser.RULE_infixOperation)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 505
        this.elvisExpression()
        this.state = 509
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (((_la - 59) & ~0x1f) === 0 && ((1 << (_la - 59)) & 113) !== 0) {
          {
            {
              this.state = 506
              this.infixOperationEntry()
            }
          }
          this.state = 511
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public infixOperationEntry(): InfixOperationEntryContext {
    let localctx: InfixOperationEntryContext = new InfixOperationEntryContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 68, FPlusParser.RULE_infixOperationEntry)
    try {
      this.state = 518
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 64:
        case 65:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 512
            this.inOperator()
            this.state = 513
            this.elvisExpression()
          }
          break
        case 59:
        case 63:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 515
            this.isOperator()
            this.state = 516
            this.type_()
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public elvisExpression(): ElvisExpressionContext {
    let localctx: ElvisExpressionContext = new ElvisExpressionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 70, FPlusParser.RULE_elvisExpression)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 520
        this.infixFunctionCall()
        this.state = 525
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 38) {
          {
            {
              this.state = 521
              this.match(FPlusParser.QUEST_COLON)
              this.state = 522
              this.infixFunctionCall()
            }
          }
          this.state = 527
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public infixFunctionCall(): InfixFunctionCallContext {
    let localctx: InfixFunctionCallContext = new InfixFunctionCallContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 72, FPlusParser.RULE_infixFunctionCall)
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 528
        this.additiveExpression()
        this.state = 534
        this._errHandler.sync(this)
        _alt = this._interp.adaptivePredict(this._input, 49, this._ctx)
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            {
              {
                this.state = 529
                this.simpleIdentifier()
                this.state = 530
                this.additiveExpression()
              }
            }
          }
          this.state = 536
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 49, this._ctx)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public additiveExpression(): AdditiveExpressionContext {
    let localctx: AdditiveExpressionContext = new AdditiveExpressionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 74, FPlusParser.RULE_additiveExpression)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 537
        this.multiplicativeExpression()
        this.state = 543
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 17 || _la === 18) {
          {
            {
              this.state = 538
              this.additiveOperator()
              this.state = 539
              this.multiplicativeExpression()
            }
          }
          this.state = 545
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public multiplicativeExpression(): MultiplicativeExpressionContext {
    let localctx: MultiplicativeExpressionContext =
      new MultiplicativeExpressionContext(this, this._ctx, this.state)
    this.enterRule(localctx, 76, FPlusParser.RULE_multiplicativeExpression)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 546
        this.powerExpression()
        this.state = 552
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 14 || _la === 16) {
          {
            {
              this.state = 547
              this.multiplicativeOperator()
              this.state = 548
              this.powerExpression()
            }
          }
          this.state = 554
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public powerExpression(): PowerExpressionContext {
    let localctx: PowerExpressionContext = new PowerExpressionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 78, FPlusParser.RULE_powerExpression)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 555
        this.asExpression()
        this.state = 561
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 15) {
          {
            {
              this.state = 556
              this.powerOperator()
              this.state = 557
              this.asExpression()
            }
          }
          this.state = 563
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public asExpression(): AsExpressionContext {
    let localctx: AsExpressionContext = new AsExpressionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 80, FPlusParser.RULE_asExpression)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 564
        this.prefixUnaryExpression()
        this.state = 569
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 58) {
          {
            {
              this.state = 565
              this.match(FPlusParser.AS)
              this.state = 566
              this.type_()
            }
          }
          this.state = 571
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public prefixUnaryExpression(): PrefixUnaryExpressionContext {
    let localctx: PrefixUnaryExpressionContext =
      new PrefixUnaryExpressionContext(this, this._ctx, this.state)
    this.enterRule(localctx, 82, FPlusParser.RULE_prefixUnaryExpression)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 575
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 18 || _la === 23) {
          {
            {
              this.state = 572
              this.unaryPrefix()
            }
          }
          this.state = 577
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
        this.state = 578
        this.postfixUnaryExpression()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public unaryPrefix(): UnaryPrefixContext {
    let localctx: UnaryPrefixContext = new UnaryPrefixContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 84, FPlusParser.RULE_unaryPrefix)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 580
        this.prefixUnaryOperator()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public postfixUnaryExpression(): PostfixUnaryExpressionContext {
    let localctx: PostfixUnaryExpressionContext =
      new PostfixUnaryExpressionContext(this, this._ctx, this.state)
    this.enterRule(localctx, 86, FPlusParser.RULE_postfixUnaryExpression)
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 582
        this.primaryExpression()
        this.state = 586
        this._errHandler.sync(this)
        _alt = this._interp.adaptivePredict(this._input, 55, this._ctx)
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            {
              {
                this.state = 583
                this.postfixUnarySuffix()
              }
            }
          }
          this.state = 588
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 55, this._ctx)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public postfixUnarySuffix(): PostfixUnarySuffixContext {
    let localctx: PostfixUnarySuffixContext = new PostfixUnarySuffixContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 88, FPlusParser.RULE_postfixUnarySuffix)
    try {
      this.state = 595
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 8:
        case 39:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 589
            this.callSuffix()
          }
          break
        case 10:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 590
            this.indexingSuffix()
          }
          break
        case 6:
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 591
            this.navigationSuffix()
          }
          break
        case 27:
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 592
            this.percentOperator()
          }
          break
        case 28:
          this.enterOuterAlt(localctx, 5)
          {
            this.state = 593
            this.notUndefinedAssertion()
          }
          break
        case 37:
          this.enterOuterAlt(localctx, 6)
          {
            this.state = 594
            this.isDefinedSuffix()
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public isDefinedSuffix(): IsDefinedSuffixContext {
    let localctx: IsDefinedSuffixContext = new IsDefinedSuffixContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 90, FPlusParser.RULE_isDefinedSuffix)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 597
        this.match(FPlusParser.QUEST)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public indexingSuffix(): IndexingSuffixContext {
    let localctx: IndexingSuffixContext = new IndexingSuffixContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 92, FPlusParser.RULE_indexingSuffix)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 599
        this.match(FPlusParser.LSQUARE)
        this.state = 600
        this.expression()
        this.state = 602
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 7) {
          {
            this.state = 601
            this.match(FPlusParser.COMMA)
          }
        }

        this.state = 604
        this.match(FPlusParser.RSQUARE)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public notUndefinedAssertion(): NotUndefinedAssertionContext {
    let localctx: NotUndefinedAssertionContext =
      new NotUndefinedAssertionContext(this, this._ctx, this.state)
    this.enterRule(localctx, 94, FPlusParser.RULE_notUndefinedAssertion)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 606
        this.match(FPlusParser.EXCL)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public percentOperator(): PercentOperatorContext {
    let localctx: PercentOperatorContext = new PercentOperatorContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 96, FPlusParser.RULE_percentOperator)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 608
        this.match(FPlusParser.PERCENT)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public navigationSuffix(): NavigationSuffixContext {
    let localctx: NavigationSuffixContext = new NavigationSuffixContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 98, FPlusParser.RULE_navigationSuffix)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 610
        this.match(FPlusParser.DOT)
        this.state = 611
        this.navigationIdentifier()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public callSuffix(): CallSuffixContext {
    let localctx: CallSuffixContext = new CallSuffixContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 100, FPlusParser.RULE_callSuffix)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 614
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 39) {
          {
            this.state = 613
            this.typeArgumentsWithoutVariance()
          }
        }

        {
          this.state = 616
          this.valueArguments()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public variance(): VarianceContext {
    let localctx: VarianceContext = new VarianceContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 102, FPlusParser.RULE_variance)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 618
        _la = this._input.LA(1)
        if (!(_la === 60 || _la === 61)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public varianceType(): VarianceTypeContext {
    let localctx: VarianceTypeContext = new VarianceTypeContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 104, FPlusParser.RULE_varianceType)
    let _la: number
    try {
      this.state = 625
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 8:
        case 47:
        case 51:
        case 53:
        case 60:
        case 61:
        case 64:
        case 65:
        case 73:
          this.enterOuterAlt(localctx, 1)
          {
            {
              this.state = 621
              this._errHandler.sync(this)
              _la = this._input.LA(1)
              if (_la === 60 || _la === 61) {
                {
                  this.state = 620
                  this.variance()
                }
              }

              this.state = 623
              this.type_()
            }
          }
          break
        case 14:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 624
            this.match(FPlusParser.MULT)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public typeArguments(): TypeArgumentsContext {
    let localctx: TypeArgumentsContext = new TypeArgumentsContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 106, FPlusParser.RULE_typeArguments)
    let _la: number
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 627
        this.match(FPlusParser.LANGLE)
        this.state = 628
        this.varianceType()
        this.state = 633
        this._errHandler.sync(this)
        _alt = this._interp.adaptivePredict(this._input, 61, this._ctx)
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            {
              {
                this.state = 629
                this.match(FPlusParser.COMMA)
                this.state = 630
                this.varianceType()
              }
            }
          }
          this.state = 635
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 61, this._ctx)
        }
        this.state = 637
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 7) {
          {
            this.state = 636
            this.match(FPlusParser.COMMA)
          }
        }

        this.state = 639
        this.match(FPlusParser.RANGLE)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public typeArgumentsWithoutVariance(): TypeArgumentsWithoutVarianceContext {
    let localctx: TypeArgumentsWithoutVarianceContext =
      new TypeArgumentsWithoutVarianceContext(this, this._ctx, this.state)
    this.enterRule(localctx, 108, FPlusParser.RULE_typeArgumentsWithoutVariance)
    let _la: number
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 641
        this.match(FPlusParser.LANGLE)
        this.state = 642
        this.type_()
        this.state = 647
        this._errHandler.sync(this)
        _alt = this._interp.adaptivePredict(this._input, 63, this._ctx)
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            {
              {
                this.state = 643
                this.match(FPlusParser.COMMA)
                this.state = 644
                this.type_()
              }
            }
          }
          this.state = 649
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 63, this._ctx)
        }
        this.state = 651
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 7) {
          {
            this.state = 650
            this.match(FPlusParser.COMMA)
          }
        }

        this.state = 653
        this.match(FPlusParser.RANGLE)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public valueArguments(): ValueArgumentsContext {
    let localctx: ValueArgumentsContext = new ValueArgumentsContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 110, FPlusParser.RULE_valueArguments)
    let _la: number
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 655
        this.match(FPlusParser.LPAREN)
        this.state = 667
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (
          ((_la & ~0x1f) === 0 && ((1 << _la) & 8658240) !== 0) ||
          (((_la - 45) & ~0x1f) === 0 &&
            ((1 << (_la - 45)) & 3757577085) !== 0) ||
          _la === 77
        ) {
          {
            this.state = 656
            this.valueArgument()
            this.state = 661
            this._errHandler.sync(this)
            _alt = this._interp.adaptivePredict(this._input, 65, this._ctx)
            while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
              if (_alt === 1) {
                {
                  {
                    this.state = 657
                    this.match(FPlusParser.COMMA)
                    this.state = 658
                    this.valueArgument()
                  }
                }
              }
              this.state = 663
              this._errHandler.sync(this)
              _alt = this._interp.adaptivePredict(this._input, 65, this._ctx)
            }
            this.state = 665
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            if (_la === 7) {
              {
                this.state = 664
                localctx._endingComma = this.match(FPlusParser.COMMA)
              }
            }
          }
        }

        this.state = 669
        this.match(FPlusParser.RPAREN)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public valueArgument(): ValueArgumentContext {
    let localctx: ValueArgumentContext = new ValueArgumentContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 112, FPlusParser.RULE_valueArgument)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 674
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 68, this._ctx)) {
          case 1:
            {
              this.state = 671
              this.simpleIdentifier()
              this.state = 672
              this.match(FPlusParser.ASSIGNMENT)
            }
            break
        }
        this.state = 676
        this.expression()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public primaryExpression(): PrimaryExpressionContext {
    let localctx: PrimaryExpressionContext = new PrimaryExpressionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 114, FPlusParser.RULE_primaryExpression)
    try {
      this.state = 689
      this._errHandler.sync(this)
      switch (this._interp.adaptivePredict(this._input, 69, this._ctx)) {
        case 1:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 678
            this.parenthesizedExpression()
          }
          break
        case 2:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 679
            this.simpleIdentifier()
          }
          break
        case 3:
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 680
            this.literalConstant()
          }
          break
        case 4:
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 681
            this.stringLiteral()
          }
          break
        case 5:
          this.enterOuterAlt(localctx, 5)
          {
            this.state = 682
            this.listLiteral()
          }
          break
        case 6:
          this.enterOuterAlt(localctx, 6)
          {
            this.state = 683
            this.setLiteral()
          }
          break
        case 7:
          this.enterOuterAlt(localctx, 7)
          {
            this.state = 684
            this.mapLiteral()
          }
          break
        case 8:
          this.enterOuterAlt(localctx, 8)
          {
            this.state = 685
            this.rangeLiteral()
          }
          break
        case 9:
          this.enterOuterAlt(localctx, 9)
          {
            this.state = 686
            this.tupleLiteral()
          }
          break
        case 10:
          this.enterOuterAlt(localctx, 10)
          {
            this.state = 687
            this.implicitVariableLiteral()
          }
          break
        case 11:
          this.enterOuterAlt(localctx, 11)
          {
            this.state = 688
            this.implicitNavigation()
          }
          break
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public parenthesizedExpression(): ParenthesizedExpressionContext {
    let localctx: ParenthesizedExpressionContext =
      new ParenthesizedExpressionContext(this, this._ctx, this.state)
    this.enterRule(localctx, 116, FPlusParser.RULE_parenthesizedExpression)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 691
        this.match(FPlusParser.LPAREN)
        this.state = 692
        this.expression()
        this.state = 693
        this.match(FPlusParser.RPAREN)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public mapPair(): MapPairContext {
    let localctx: MapPairContext = new MapPairContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 118, FPlusParser.RULE_mapPair)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 695
        localctx._key = this.expression()
        this.state = 696
        this.match(FPlusParser.COLON)
        this.state = 697
        localctx._value = this.expression()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public mapLiteral(): MapLiteralContext {
    let localctx: MapLiteralContext = new MapLiteralContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 120, FPlusParser.RULE_mapLiteral)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 699
        this.match(FPlusParser.MAP)
        this.state = 700
        this.match(FPlusParser.LCURL)
        this.state = 709
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (
          ((_la & ~0x1f) === 0 && ((1 << _la) & 8658240) !== 0) ||
          (((_la - 45) & ~0x1f) === 0 &&
            ((1 << (_la - 45)) & 3757577085) !== 0) ||
          _la === 77
        ) {
          {
            this.state = 701
            this.mapPair()
            this.state = 706
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            while (_la === 7) {
              {
                {
                  this.state = 702
                  this.match(FPlusParser.COMMA)
                  this.state = 703
                  this.mapPair()
                }
              }
              this.state = 708
              this._errHandler.sync(this)
              _la = this._input.LA(1)
            }
          }
        }

        this.state = 711
        this.match(FPlusParser.RCURL)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public setLiteral(): SetLiteralContext {
    let localctx: SetLiteralContext = new SetLiteralContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 122, FPlusParser.RULE_setLiteral)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 713
        this.match(FPlusParser.LCURL)
        this.state = 722
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (
          ((_la & ~0x1f) === 0 && ((1 << _la) & 8658240) !== 0) ||
          (((_la - 45) & ~0x1f) === 0 &&
            ((1 << (_la - 45)) & 3757577085) !== 0) ||
          _la === 77
        ) {
          {
            this.state = 714
            this.expression()
            this.state = 719
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            while (_la === 7) {
              {
                {
                  this.state = 715
                  this.match(FPlusParser.COMMA)
                  this.state = 716
                  this.expression()
                }
              }
              this.state = 721
              this._errHandler.sync(this)
              _la = this._input.LA(1)
            }
          }
        }

        this.state = 724
        this.match(FPlusParser.RCURL)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public listLiteral(): ListLiteralContext {
    let localctx: ListLiteralContext = new ListLiteralContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 124, FPlusParser.RULE_listLiteral)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 726
        this.match(FPlusParser.LSQUARE)
        this.state = 735
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 75, this._ctx)) {
          case 1:
            {
              this.state = 727
              this.expression()
              this.state = 732
              this._errHandler.sync(this)
              _la = this._input.LA(1)
              while (_la === 7) {
                {
                  {
                    this.state = 728
                    this.match(FPlusParser.COMMA)
                    this.state = 729
                    this.expression()
                  }
                }
                this.state = 734
                this._errHandler.sync(this)
                _la = this._input.LA(1)
              }
            }
            break
        }
        this.state = 737
        this.match(FPlusParser.RSQUARE)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public rangeLiteral(): RangeLiteralContext {
    let localctx: RangeLiteralContext = new RangeLiteralContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 126, FPlusParser.RULE_rangeLiteral)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 741
        this._errHandler.sync(this)
        switch (this._input.LA(1)) {
          case 10:
            {
              this.state = 739
              localctx._startInc = this.match(FPlusParser.LSQUARE)
            }
            break
          case 11:
            {
              this.state = 740
              this.match(FPlusParser.RSQUARE)
            }
            break
          default:
            throw new NoViableAltException(this)
        }
        this.state = 743
        localctx._min = this.expression()
        this.state = 744
        this.match(FPlusParser.RANGE)
        this.state = 745
        localctx._max = this.expression()
        this.state = 748
        this._errHandler.sync(this)
        switch (this._input.LA(1)) {
          case 10:
            {
              this.state = 746
              this.match(FPlusParser.LSQUARE)
            }
            break
          case 11:
            {
              this.state = 747
              localctx._endInc = this.match(FPlusParser.RSQUARE)
            }
            break
          default:
            throw new NoViableAltException(this)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public tupleLiteral(): TupleLiteralContext {
    let localctx: TupleLiteralContext = new TupleLiteralContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 128, FPlusParser.RULE_tupleLiteral)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 750
        this.match(FPlusParser.LPAREN)
        this.state = 751
        this.expression()
        this.state = 754
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        do {
          {
            {
              this.state = 752
              this.match(FPlusParser.COMMA)
              this.state = 753
              this.expression()
            }
          }
          this.state = 756
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        } while (_la === 7)
        this.state = 758
        this.match(FPlusParser.RPAREN)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public implicitVariableLiteral(): ImplicitVariableLiteralContext {
    let localctx: ImplicitVariableLiteralContext =
      new ImplicitVariableLiteralContext(this, this._ctx, this.state)
    this.enterRule(localctx, 130, FPlusParser.RULE_implicitVariableLiteral)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 760
        this.match(FPlusParser.UNDERSCORE)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public implicitNavigation(): ImplicitNavigationContext {
    let localctx: ImplicitNavigationContext = new ImplicitNavigationContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 132, FPlusParser.RULE_implicitNavigation)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 762
        this.match(FPlusParser.DOT)
        this.state = 763
        this.match(FPlusParser.Identifier)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public literalConstant(): LiteralConstantContext {
    let localctx: LiteralConstantContext = new LiteralConstantContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 134, FPlusParser.RULE_literalConstant)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 765
        _la = this._input.LA(1)
        if (!(((_la - 66) & ~0x1f) === 0 && ((1 << (_la - 66)) & 127) !== 0)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public stringLiteral(): StringLiteralContext {
    let localctx: StringLiteralContext = new StringLiteralContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 136, FPlusParser.RULE_stringLiteral)
    try {
      this.state = 770
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 76:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 767
            this.lineStringLiteral()
          }
          break
        case 77:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 768
            this.multiLineStringLiteral()
          }
          break
        case 75:
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 769
            this.singleQuoteStringLiteral()
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public singleQuoteStringLiteral(): SingleQuoteStringLiteralContext {
    let localctx: SingleQuoteStringLiteralContext =
      new SingleQuoteStringLiteralContext(this, this._ctx, this.state)
    this.enterRule(localctx, 138, FPlusParser.RULE_singleQuoteStringLiteral)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 772
        this.match(FPlusParser.SINGLE_QUOTE_OPEN)
        this.state = 776
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (((_la - 90) & ~0x1f) === 0 && ((1 << (_la - 90)) & 7) !== 0) {
          {
            {
              this.state = 773
              this.singleLineStringLiteralEntry()
            }
          }
          this.state = 778
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
        this.state = 779
        this.match(FPlusParser.SINGLE_QUOTE_CLOSE)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public singleLineStringLiteralEntry(): SingleLineStringLiteralEntryContext {
    let localctx: SingleLineStringLiteralEntryContext =
      new SingleLineStringLiteralEntryContext(this, this._ctx, this.state)
    this.enterRule(localctx, 140, FPlusParser.RULE_singleLineStringLiteralEntry)
    try {
      this.state = 783
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 90:
        case 91:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 781
            this.singleLineStringContent()
          }
          break
        case 92:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 782
            this.singleLineStringExpression()
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public singleLineStringContent(): SingleLineStringContentContext {
    let localctx: SingleLineStringContentContext =
      new SingleLineStringContentContext(this, this._ctx, this.state)
    this.enterRule(localctx, 142, FPlusParser.RULE_singleLineStringContent)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 785
        _la = this._input.LA(1)
        if (!(_la === 90 || _la === 91)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public singleLineStringExpression(): SingleLineStringExpressionContext {
    let localctx: SingleLineStringExpressionContext =
      new SingleLineStringExpressionContext(this, this._ctx, this.state)
    this.enterRule(localctx, 144, FPlusParser.RULE_singleLineStringExpression)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 787
        this.match(FPlusParser.SingleLineStrExprStart)
        this.state = 788
        this.expression()
        this.state = 789
        this.match(FPlusParser.RCURL)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public lineStringLiteral(): LineStringLiteralContext {
    let localctx: LineStringLiteralContext = new LineStringLiteralContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 146, FPlusParser.RULE_lineStringLiteral)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 791
        this.match(FPlusParser.QUOTE_OPEN)
        this.state = 795
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (((_la - 86) & ~0x1f) === 0 && ((1 << (_la - 86)) & 7) !== 0) {
          {
            {
              this.state = 792
              this.lineStringLiteralEntry()
            }
          }
          this.state = 797
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
        this.state = 798
        this.match(FPlusParser.QUOTE_CLOSE)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public lineStringLiteralEntry(): LineStringLiteralEntryContext {
    let localctx: LineStringLiteralEntryContext =
      new LineStringLiteralEntryContext(this, this._ctx, this.state)
    this.enterRule(localctx, 148, FPlusParser.RULE_lineStringLiteralEntry)
    try {
      this.state = 802
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 86:
        case 87:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 800
            this.lineStringContent()
          }
          break
        case 88:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 801
            this.lineStringExpression()
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public lineStringContent(): LineStringContentContext {
    let localctx: LineStringContentContext = new LineStringContentContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 150, FPlusParser.RULE_lineStringContent)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 804
        _la = this._input.LA(1)
        if (!(_la === 86 || _la === 87)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public lineStringExpression(): LineStringExpressionContext {
    let localctx: LineStringExpressionContext = new LineStringExpressionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 152, FPlusParser.RULE_lineStringExpression)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 806
        this.match(FPlusParser.LineStrExprStart)
        this.state = 807
        this.expression()
        this.state = 808
        this.match(FPlusParser.RCURL)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public multiLineStringLiteral(): MultiLineStringLiteralContext {
    let localctx: MultiLineStringLiteralContext =
      new MultiLineStringLiteralContext(this, this._ctx, this.state)
    this.enterRule(localctx, 154, FPlusParser.RULE_multiLineStringLiteral)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 810
        this.match(FPlusParser.TRIPLE_QUOTE_OPEN)
        this.state = 814
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (((_la - 94) & ~0x1f) === 0 && ((1 << (_la - 94)) & 15) !== 0) {
          {
            {
              this.state = 811
              this.multiLineStringLiteralEntry()
            }
          }
          this.state = 816
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
        this.state = 817
        this.match(FPlusParser.TRIPLE_QUOTE_CLOSE)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public multiLineStringLiteralEntry(): MultiLineStringLiteralEntryContext {
    let localctx: MultiLineStringLiteralEntryContext =
      new MultiLineStringLiteralEntryContext(this, this._ctx, this.state)
    this.enterRule(localctx, 156, FPlusParser.RULE_multiLineStringLiteralEntry)
    try {
      this.state = 821
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 94:
        case 95:
        case 96:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 819
            this.multiLineStringContent()
          }
          break
        case 97:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 820
            this.multiLineStringExpression()
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public multiLineStringContent(): MultiLineStringContentContext {
    let localctx: MultiLineStringContentContext =
      new MultiLineStringContentContext(this, this._ctx, this.state)
    this.enterRule(localctx, 158, FPlusParser.RULE_multiLineStringContent)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 823
        _la = this._input.LA(1)
        if (!(((_la - 94) & ~0x1f) === 0 && ((1 << (_la - 94)) & 7) !== 0)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public multiLineStringExpression(): MultiLineStringExpressionContext {
    let localctx: MultiLineStringExpressionContext =
      new MultiLineStringExpressionContext(this, this._ctx, this.state)
    this.enterRule(localctx, 160, FPlusParser.RULE_multiLineStringExpression)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 825
        this.match(FPlusParser.MultiLineStrExprStart)
        this.state = 826
        this.expression()
        this.state = 827
        this.match(FPlusParser.RCURL)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public lambdaLiteral(): LambdaLiteralContext {
    let localctx: LambdaLiteralContext = new LambdaLiteralContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 162, FPlusParser.RULE_lambdaLiteral)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        {
          this.state = 833
          this._errHandler.sync(this)
          switch (this._interp.adaptivePredict(this._input, 86, this._ctx)) {
            case 1:
              {
                this.state = 829
                this.functionValueParametersWithOptionalType()
              }
              break
            case 2:
              {
                {
                  this.state = 830
                  this.match(FPlusParser.LPAREN)
                  this.state = 831
                  this.match(FPlusParser.RPAREN)
                }
              }
              break
            case 3:
              {
                this.state = 832
                this.parameterWithOptionalType()
              }
              break
          }
          this.state = 835
          this.match(FPlusParser.ARROW)
        }
        this.state = 838
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 87, this._ctx)) {
          case 1:
            {
              this.state = 837
              this.expression()
            }
            break
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public anonymousFunction(): AnonymousFunctionContext {
    let localctx: AnonymousFunctionContext = new AnonymousFunctionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 164, FPlusParser.RULE_anonymousFunction)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 840
        this.match(FPlusParser.FUN)
        this.state = 844
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 88, this._ctx)) {
          case 1:
            {
              this.state = 841
              this.receiverType()
              this.state = 842
              this.match(FPlusParser.DOT)
            }
            break
        }
        this.state = 846
        this.functionValueParametersWithOptionalType()
        {
          this.state = 847
          this.match(FPlusParser.COLON)
          this.state = 848
          this.type_()
        }
        this.state = 852
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 33) {
          {
            this.state = 850
            this.match(FPlusParser.DOUBLE_ARROW)
            this.state = 851
            this.expression()
          }
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public functionLiteral(): FunctionLiteralContext {
    let localctx: FunctionLiteralContext = new FunctionLiteralContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 166, FPlusParser.RULE_functionLiteral)
    try {
      this.state = 856
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 8:
        case 47:
        case 51:
        case 53:
        case 64:
        case 65:
        case 73:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 854
            this.lambdaLiteral()
          }
          break
        case 48:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 855
            this.anonymousFunction()
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public ifExpression(): IfExpressionContext {
    let localctx: IfExpressionContext = new IfExpressionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 168, FPlusParser.RULE_ifExpression)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 858
        this.match(FPlusParser.IF)
        this.state = 859
        localctx._cond = this.expression()
        this.state = 860
        this.match(FPlusParser.THEN)
        this.state = 862
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (
          ((_la & ~0x1f) === 0 && ((1 << _la) & 8658240) !== 0) ||
          (((_la - 45) & ~0x1f) === 0 &&
            ((1 << (_la - 45)) & 3757577085) !== 0) ||
          _la === 77
        ) {
          {
            this.state = 861
            localctx._thenB = this.expression()
          }
        }

        this.state = 865
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 30) {
          {
            this.state = 864
            this.match(FPlusParser.SEMICOLON)
          }
        }

        this.state = 867
        this.match(FPlusParser.ELSE)
        this.state = 869
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 93, this._ctx)) {
          case 1:
            {
              this.state = 868
              localctx._elseB = this.expression()
            }
            break
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public whenSubject(): WhenSubjectContext {
    let localctx: WhenSubjectContext = new WhenSubjectContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 170, FPlusParser.RULE_whenSubject)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 875
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 52) {
          {
            this.state = 871
            this.match(FPlusParser.VAR)
            this.state = 872
            this.variableDeclaration()
            this.state = 873
            this.match(FPlusParser.ASSIGNMENT)
          }
        }

        this.state = 877
        this.expression()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public whenExpression(): WhenExpressionContext {
    let localctx: WhenExpressionContext = new WhenExpressionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 172, FPlusParser.RULE_whenExpression)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 879
        this.match(FPlusParser.WHEN)
        this.state = 881
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 95, this._ctx)) {
          case 1:
            {
              this.state = 880
              this.whenSubject()
            }
            break
        }
        this.state = 883
        this.match(FPlusParser.LCURL)
        this.state = 884
        this.whenArrowBody()
        this.state = 885
        this.match(FPlusParser.RCURL)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public whenArrowBody(): WhenArrowBodyContext {
    let localctx: WhenArrowBodyContext = new WhenArrowBodyContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 174, FPlusParser.RULE_whenArrowBody)
    let _la: number
    try {
      this.state = 902
      this._errHandler.sync(this)
      switch (this._interp.adaptivePredict(this._input, 98, this._ctx)) {
        case 1:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 892
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            while (
              ((_la & ~0x1f) === 0 && ((1 << _la) & 8658240) !== 0) ||
              (((_la - 45) & ~0x1f) === 0 &&
                ((1 << (_la - 45)) & 3757855605) !== 0) ||
              _la === 77
            ) {
              {
                {
                  this.state = 887
                  this.whenArrowEntry()
                  this.state = 888
                  this.commaOrSemicolon()
                }
              }
              this.state = 894
              this._errHandler.sync(this)
              _la = this._input.LA(1)
            }
            this.state = 895
            this.match(FPlusParser.ELSE)
            this.state = 896
            this.match(FPlusParser.ARROW)
            this.state = 897
            localctx._elseC = this.expression()
            this.state = 899
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            if (
              ((_la - -1) & ~0x1f) === 0 &&
              ((1 << (_la - -1)) & 2147483713) !== 0
            ) {
              {
                this.state = 898
                this.semi()
              }
            }
          }
          break
        case 2:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 901
            this.whenColonBody()
          }
          break
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public whenArrowEntry(): WhenArrowEntryContext {
    let localctx: WhenArrowEntryContext = new WhenArrowEntryContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 176, FPlusParser.RULE_whenArrowEntry)
    let _la: number
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 904
        this.whenCondition()
        this.state = 909
        this._errHandler.sync(this)
        _alt = this._interp.adaptivePredict(this._input, 99, this._ctx)
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            {
              {
                this.state = 905
                this.match(FPlusParser.COMMA)
                this.state = 906
                this.whenCondition()
              }
            }
          }
          this.state = 911
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 99, this._ctx)
        }
        this.state = 913
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 7) {
          {
            this.state = 912
            this.match(FPlusParser.COMMA)
          }
        }

        this.state = 915
        this.match(FPlusParser.ARROW)
        this.state = 916
        this.expression()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public whenColonBody(): WhenColonBodyContext {
    let localctx: WhenColonBodyContext = new WhenColonBodyContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 178, FPlusParser.RULE_whenColonBody)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 923
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (
          ((_la & ~0x1f) === 0 && ((1 << _la) & 8658240) !== 0) ||
          (((_la - 45) & ~0x1f) === 0 &&
            ((1 << (_la - 45)) & 3757855605) !== 0) ||
          _la === 77
        ) {
          {
            {
              this.state = 918
              this.whenColonEntry()
              this.state = 919
              this.commaOrSemicolon()
            }
          }
          this.state = 925
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
        this.state = 926
        this.match(FPlusParser.ELSE)
        this.state = 927
        this.match(FPlusParser.COLON)
        this.state = 928
        localctx._elseC = this.expression()
        this.state = 930
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (
          ((_la - -1) & ~0x1f) === 0 &&
          ((1 << (_la - -1)) & 2147483713) !== 0
        ) {
          {
            this.state = 929
            this.semi()
          }
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public whenColonEntry(): WhenColonEntryContext {
    let localctx: WhenColonEntryContext = new WhenColonEntryContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 180, FPlusParser.RULE_whenColonEntry)
    let _la: number
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 932
        this.whenCondition()
        this.state = 937
        this._errHandler.sync(this)
        _alt = this._interp.adaptivePredict(this._input, 103, this._ctx)
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            {
              {
                this.state = 933
                this.match(FPlusParser.COMMA)
                this.state = 934
                this.whenCondition()
              }
            }
          }
          this.state = 939
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 103, this._ctx)
        }
        this.state = 941
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        if (_la === 7) {
          {
            this.state = 940
            this.match(FPlusParser.COMMA)
          }
        }

        this.state = 943
        this.match(FPlusParser.COLON)
        this.state = 944
        this.expression()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public whenCondition(): WhenConditionContext {
    let localctx: WhenConditionContext = new WhenConditionContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 182, FPlusParser.RULE_whenCondition)
    try {
      this.state = 950
      this._errHandler.sync(this)
      switch (this._interp.adaptivePredict(this._input, 105, this._ctx)) {
        case 1:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 946
            this.tupleTest()
          }
          break
        case 2:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 947
            this.rangeTest()
          }
          break
        case 3:
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 948
            this.typeTest()
          }
          break
        case 4:
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 949
            this.expressionWithoutFunctionLiteral()
          }
          break
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public tupleTestEntry(): TupleTestEntryContext {
    let localctx: TupleTestEntryContext = new TupleTestEntryContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 184, FPlusParser.RULE_tupleTestEntry)
    try {
      this.state = 954
      this._errHandler.sync(this)
      switch (this._interp.adaptivePredict(this._input, 106, this._ctx)) {
        case 1:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 952
            this.match(FPlusParser.UNDERSCORE)
          }
          break
        case 2:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 953
            this.whenCondition()
          }
          break
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public tupleTest(): TupleTestContext {
    let localctx: TupleTestContext = new TupleTestContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 186, FPlusParser.RULE_tupleTest)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 956
        this.match(FPlusParser.LPAREN)
        this.state = 957
        this.tupleTestEntry()
        this.state = 960
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        do {
          {
            {
              this.state = 958
              this.match(FPlusParser.COMMA)
              this.state = 959
              this.tupleTestEntry()
            }
          }
          this.state = 962
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        } while (_la === 7)
        this.state = 964
        this.match(FPlusParser.RPAREN)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public rangeTest(): RangeTestContext {
    let localctx: RangeTestContext = new RangeTestContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 188, FPlusParser.RULE_rangeTest)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 966
        this.inOperator()
        this.state = 967
        this.expression()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public typeTest(): TypeTestContext {
    let localctx: TypeTestContext = new TypeTestContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 190, FPlusParser.RULE_typeTest)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 969
        this.isOperator()
        this.state = 970
        this.type_()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public equalityOperator(): EqualityOperatorContext {
    let localctx: EqualityOperatorContext = new EqualityOperatorContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 192, FPlusParser.RULE_equalityOperator)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 972
        _la = this._input.LA(1)
        if (!(_la === 31 || _la === 43)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public comparisonOperator(): ComparisonOperatorContext {
    let localctx: ComparisonOperatorContext = new ComparisonOperatorContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 194, FPlusParser.RULE_comparisonOperator)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 974
        _la = this._input.LA(1)
        if (!(((_la - 39) & ~0x1f) === 0 && ((1 << (_la - 39)) & 15) !== 0)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public inOperator(): InOperatorContext {
    let localctx: InOperatorContext = new InOperatorContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 196, FPlusParser.RULE_inOperator)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 976
        _la = this._input.LA(1)
        if (!(_la === 64 || _la === 65)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public isOperator(): IsOperatorContext {
    let localctx: IsOperatorContext = new IsOperatorContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 198, FPlusParser.RULE_isOperator)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 978
        _la = this._input.LA(1)
        if (!(_la === 59 || _la === 63)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public additiveOperator(): AdditiveOperatorContext {
    let localctx: AdditiveOperatorContext = new AdditiveOperatorContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 200, FPlusParser.RULE_additiveOperator)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 980
        _la = this._input.LA(1)
        if (!(_la === 17 || _la === 18)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public multiplicativeOperator(): MultiplicativeOperatorContext {
    let localctx: MultiplicativeOperatorContext =
      new MultiplicativeOperatorContext(this, this._ctx, this.state)
    this.enterRule(localctx, 202, FPlusParser.RULE_multiplicativeOperator)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 982
        _la = this._input.LA(1)
        if (!(_la === 14 || _la === 16)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public powerOperator(): PowerOperatorContext {
    let localctx: PowerOperatorContext = new PowerOperatorContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 204, FPlusParser.RULE_powerOperator)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 984
        this.match(FPlusParser.POW)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public prefixUnaryOperator(): PrefixUnaryOperatorContext {
    let localctx: PrefixUnaryOperatorContext = new PrefixUnaryOperatorContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 206, FPlusParser.RULE_prefixUnaryOperator)
    try {
      this.state = 988
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 18:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 986
            this.match(FPlusParser.SUB)
          }
          break
        case 23:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 987
            this.excl()
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public excl(): ExclContext {
    let localctx: ExclContext = new ExclContext(this, this._ctx, this.state)
    this.enterRule(localctx, 208, FPlusParser.RULE_excl)
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 990
        this.match(FPlusParser.NOT)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public simpleIdentifier(): SimpleIdentifierContext {
    let localctx: SimpleIdentifierContext = new SimpleIdentifierContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 210, FPlusParser.RULE_simpleIdentifier)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 992
        _la = this._input.LA(1)
        if (
          !(((_la - 47) & ~0x1f) === 0 && ((1 << (_la - 47)) & 67502161) !== 0)
        ) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public navigationIdentifier(): NavigationIdentifierContext {
    let localctx: NavigationIdentifierContext = new NavigationIdentifierContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 212, FPlusParser.RULE_navigationIdentifier)
    let _la: number
    try {
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 994
        _la = this._input.LA(1)
        if (
          !(((_la - 47) & ~0x1f) === 0 && ((1 << (_la - 47)) & 83886161) !== 0)
        ) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }

  public static readonly _serializedATN: number[] = [
    4, 1, 98, 997, 2, 0, 7, 0, 2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7, 4,
    2, 5, 7, 5, 2, 6, 7, 6, 2, 7, 7, 7, 2, 8, 7, 8, 2, 9, 7, 9, 2, 10, 7, 10, 2,
    11, 7, 11, 2, 12, 7, 12, 2, 13, 7, 13, 2, 14, 7, 14, 2, 15, 7, 15, 2, 16, 7,
    16, 2, 17, 7, 17, 2, 18, 7, 18, 2, 19, 7, 19, 2, 20, 7, 20, 2, 21, 7, 21, 2,
    22, 7, 22, 2, 23, 7, 23, 2, 24, 7, 24, 2, 25, 7, 25, 2, 26, 7, 26, 2, 27, 7,
    27, 2, 28, 7, 28, 2, 29, 7, 29, 2, 30, 7, 30, 2, 31, 7, 31, 2, 32, 7, 32, 2,
    33, 7, 33, 2, 34, 7, 34, 2, 35, 7, 35, 2, 36, 7, 36, 2, 37, 7, 37, 2, 38, 7,
    38, 2, 39, 7, 39, 2, 40, 7, 40, 2, 41, 7, 41, 2, 42, 7, 42, 2, 43, 7, 43, 2,
    44, 7, 44, 2, 45, 7, 45, 2, 46, 7, 46, 2, 47, 7, 47, 2, 48, 7, 48, 2, 49, 7,
    49, 2, 50, 7, 50, 2, 51, 7, 51, 2, 52, 7, 52, 2, 53, 7, 53, 2, 54, 7, 54, 2,
    55, 7, 55, 2, 56, 7, 56, 2, 57, 7, 57, 2, 58, 7, 58, 2, 59, 7, 59, 2, 60, 7,
    60, 2, 61, 7, 61, 2, 62, 7, 62, 2, 63, 7, 63, 2, 64, 7, 64, 2, 65, 7, 65, 2,
    66, 7, 66, 2, 67, 7, 67, 2, 68, 7, 68, 2, 69, 7, 69, 2, 70, 7, 70, 2, 71, 7,
    71, 2, 72, 7, 72, 2, 73, 7, 73, 2, 74, 7, 74, 2, 75, 7, 75, 2, 76, 7, 76, 2,
    77, 7, 77, 2, 78, 7, 78, 2, 79, 7, 79, 2, 80, 7, 80, 2, 81, 7, 81, 2, 82, 7,
    82, 2, 83, 7, 83, 2, 84, 7, 84, 2, 85, 7, 85, 2, 86, 7, 86, 2, 87, 7, 87, 2,
    88, 7, 88, 2, 89, 7, 89, 2, 90, 7, 90, 2, 91, 7, 91, 2, 92, 7, 92, 2, 93, 7,
    93, 2, 94, 7, 94, 2, 95, 7, 95, 2, 96, 7, 96, 2, 97, 7, 97, 2, 98, 7, 98, 2,
    99, 7, 99, 2, 100, 7, 100, 2, 101, 7, 101, 2, 102, 7, 102, 2, 103, 7, 103,
    2, 104, 7, 104, 2, 105, 7, 105, 2, 106, 7, 106, 1, 0, 1, 0, 1, 0, 1, 0, 1,
    1, 1, 1, 1, 1, 1, 2, 1, 2, 1, 2, 1, 2, 5, 2, 226, 8, 2, 10, 2, 12, 2, 229,
    9, 2, 1, 2, 3, 2, 232, 8, 2, 1, 2, 1, 2, 1, 3, 1, 3, 1, 3, 3, 3, 239, 8, 3,
    1, 4, 1, 4, 1, 4, 1, 4, 5, 4, 245, 8, 4, 10, 4, 12, 4, 248, 9, 4, 1, 4, 3,
    4, 251, 8, 4, 3, 4, 253, 8, 4, 1, 4, 1, 4, 1, 5, 1, 5, 1, 5, 3, 5, 260, 8,
    5, 1, 6, 1, 6, 1, 6, 1, 6, 5, 6, 266, 8, 6, 10, 6, 12, 6, 269, 9, 6, 1, 6,
    3, 6, 272, 8, 6, 3, 6, 274, 8, 6, 1, 6, 1, 6, 1, 7, 1, 7, 1, 7, 1, 7, 4, 7,
    282, 8, 7, 11, 7, 12, 7, 283, 1, 7, 1, 7, 1, 8, 1, 8, 3, 8, 290, 8, 8, 1, 8,
    1, 8, 3, 8, 294, 8, 8, 1, 9, 1, 9, 1, 10, 1, 10, 1, 10, 1, 10, 1, 10, 5, 10,
    303, 8, 10, 10, 10, 12, 10, 306, 9, 10, 1, 10, 3, 10, 309, 8, 10, 1, 10, 1,
    10, 1, 10, 1, 10, 1, 10, 5, 10, 316, 8, 10, 10, 10, 12, 10, 319, 9, 10, 1,
    10, 3, 10, 322, 8, 10, 1, 10, 1, 10, 1, 10, 1, 10, 1, 10, 5, 10, 329, 8, 10,
    10, 10, 12, 10, 332, 9, 10, 1, 10, 3, 10, 335, 8, 10, 3, 10, 337, 8, 10, 1,
    11, 1, 11, 1, 11, 1, 11, 1, 11, 1, 12, 1, 12, 3, 12, 346, 8, 12, 1, 12, 3,
    12, 349, 8, 12, 1, 13, 3, 13, 352, 8, 13, 1, 13, 1, 13, 3, 13, 356, 8, 13,
    1, 13, 1, 13, 1, 13, 1, 14, 4, 14, 362, 8, 14, 11, 14, 12, 14, 363, 1, 14,
    1, 14, 1, 14, 1, 15, 1, 15, 3, 15, 371, 8, 15, 1, 15, 1, 15, 3, 15, 375, 8,
    15, 1, 16, 1, 16, 3, 16, 379, 8, 16, 1, 16, 1, 16, 1, 16, 1, 17, 1, 17, 1,
    17, 1, 17, 3, 17, 388, 8, 17, 1, 18, 1, 18, 1, 18, 1, 18, 4, 18, 394, 8, 18,
    11, 18, 12, 18, 395, 1, 18, 1, 18, 1, 19, 1, 19, 3, 19, 402, 8, 19, 1, 20,
    1, 20, 1, 20, 3, 20, 407, 8, 20, 1, 20, 1, 20, 1, 20, 1, 20, 1, 21, 1, 21,
    3, 21, 415, 8, 21, 1, 21, 1, 21, 5, 21, 419, 8, 21, 10, 21, 12, 21, 422, 9,
    21, 1, 21, 3, 21, 425, 8, 21, 1, 21, 1, 21, 1, 22, 1, 22, 1, 22, 1, 22, 1,
    23, 1, 23, 3, 23, 435, 8, 23, 1, 24, 1, 24, 3, 24, 439, 8, 24, 1, 25, 1, 25,
    3, 25, 443, 8, 25, 1, 26, 1, 26, 1, 26, 1, 26, 3, 26, 449, 8, 26, 1, 27, 3,
    27, 452, 8, 27, 1, 27, 1, 27, 1, 27, 3, 27, 457, 8, 27, 1, 27, 1, 27, 1, 27,
    1, 27, 1, 27, 1, 28, 1, 28, 1, 28, 5, 28, 467, 8, 28, 10, 28, 12, 28, 470,
    9, 28, 1, 29, 1, 29, 1, 29, 5, 29, 475, 8, 29, 10, 29, 12, 29, 478, 9, 29,
    1, 30, 1, 30, 1, 30, 5, 30, 483, 8, 30, 10, 30, 12, 30, 486, 9, 30, 1, 31,
    1, 31, 1, 31, 1, 31, 5, 31, 492, 8, 31, 10, 31, 12, 31, 495, 9, 31, 1, 32,
    1, 32, 1, 32, 1, 32, 5, 32, 501, 8, 32, 10, 32, 12, 32, 504, 9, 32, 1, 33,
    1, 33, 5, 33, 508, 8, 33, 10, 33, 12, 33, 511, 9, 33, 1, 34, 1, 34, 1, 34,
    1, 34, 1, 34, 1, 34, 3, 34, 519, 8, 34, 1, 35, 1, 35, 1, 35, 5, 35, 524, 8,
    35, 10, 35, 12, 35, 527, 9, 35, 1, 36, 1, 36, 1, 36, 1, 36, 5, 36, 533, 8,
    36, 10, 36, 12, 36, 536, 9, 36, 1, 37, 1, 37, 1, 37, 1, 37, 5, 37, 542, 8,
    37, 10, 37, 12, 37, 545, 9, 37, 1, 38, 1, 38, 1, 38, 1, 38, 5, 38, 551, 8,
    38, 10, 38, 12, 38, 554, 9, 38, 1, 39, 1, 39, 1, 39, 1, 39, 5, 39, 560, 8,
    39, 10, 39, 12, 39, 563, 9, 39, 1, 40, 1, 40, 1, 40, 5, 40, 568, 8, 40, 10,
    40, 12, 40, 571, 9, 40, 1, 41, 5, 41, 574, 8, 41, 10, 41, 12, 41, 577, 9,
    41, 1, 41, 1, 41, 1, 42, 1, 42, 1, 43, 1, 43, 5, 43, 585, 8, 43, 10, 43, 12,
    43, 588, 9, 43, 1, 44, 1, 44, 1, 44, 1, 44, 1, 44, 1, 44, 3, 44, 596, 8, 44,
    1, 45, 1, 45, 1, 46, 1, 46, 1, 46, 3, 46, 603, 8, 46, 1, 46, 1, 46, 1, 47,
    1, 47, 1, 48, 1, 48, 1, 49, 1, 49, 1, 49, 1, 50, 3, 50, 615, 8, 50, 1, 50,
    1, 50, 1, 51, 1, 51, 1, 52, 3, 52, 622, 8, 52, 1, 52, 1, 52, 3, 52, 626, 8,
    52, 1, 53, 1, 53, 1, 53, 1, 53, 5, 53, 632, 8, 53, 10, 53, 12, 53, 635, 9,
    53, 1, 53, 3, 53, 638, 8, 53, 1, 53, 1, 53, 1, 54, 1, 54, 1, 54, 1, 54, 5,
    54, 646, 8, 54, 10, 54, 12, 54, 649, 9, 54, 1, 54, 3, 54, 652, 8, 54, 1, 54,
    1, 54, 1, 55, 1, 55, 1, 55, 1, 55, 5, 55, 660, 8, 55, 10, 55, 12, 55, 663,
    9, 55, 1, 55, 3, 55, 666, 8, 55, 3, 55, 668, 8, 55, 1, 55, 1, 55, 1, 56, 1,
    56, 1, 56, 3, 56, 675, 8, 56, 1, 56, 1, 56, 1, 57, 1, 57, 1, 57, 1, 57, 1,
    57, 1, 57, 1, 57, 1, 57, 1, 57, 1, 57, 1, 57, 3, 57, 690, 8, 57, 1, 58, 1,
    58, 1, 58, 1, 58, 1, 59, 1, 59, 1, 59, 1, 59, 1, 60, 1, 60, 1, 60, 1, 60, 1,
    60, 5, 60, 705, 8, 60, 10, 60, 12, 60, 708, 9, 60, 3, 60, 710, 8, 60, 1, 60,
    1, 60, 1, 61, 1, 61, 1, 61, 1, 61, 5, 61, 718, 8, 61, 10, 61, 12, 61, 721,
    9, 61, 3, 61, 723, 8, 61, 1, 61, 1, 61, 1, 62, 1, 62, 1, 62, 1, 62, 5, 62,
    731, 8, 62, 10, 62, 12, 62, 734, 9, 62, 3, 62, 736, 8, 62, 1, 62, 1, 62, 1,
    63, 1, 63, 3, 63, 742, 8, 63, 1, 63, 1, 63, 1, 63, 1, 63, 1, 63, 3, 63, 749,
    8, 63, 1, 64, 1, 64, 1, 64, 1, 64, 4, 64, 755, 8, 64, 11, 64, 12, 64, 756,
    1, 64, 1, 64, 1, 65, 1, 65, 1, 66, 1, 66, 1, 66, 1, 67, 1, 67, 1, 68, 1, 68,
    1, 68, 3, 68, 771, 8, 68, 1, 69, 1, 69, 5, 69, 775, 8, 69, 10, 69, 12, 69,
    778, 9, 69, 1, 69, 1, 69, 1, 70, 1, 70, 3, 70, 784, 8, 70, 1, 71, 1, 71, 1,
    72, 1, 72, 1, 72, 1, 72, 1, 73, 1, 73, 5, 73, 794, 8, 73, 10, 73, 12, 73,
    797, 9, 73, 1, 73, 1, 73, 1, 74, 1, 74, 3, 74, 803, 8, 74, 1, 75, 1, 75, 1,
    76, 1, 76, 1, 76, 1, 76, 1, 77, 1, 77, 5, 77, 813, 8, 77, 10, 77, 12, 77,
    816, 9, 77, 1, 77, 1, 77, 1, 78, 1, 78, 3, 78, 822, 8, 78, 1, 79, 1, 79, 1,
    80, 1, 80, 1, 80, 1, 80, 1, 81, 1, 81, 1, 81, 1, 81, 3, 81, 834, 8, 81, 1,
    81, 1, 81, 1, 81, 3, 81, 839, 8, 81, 1, 82, 1, 82, 1, 82, 1, 82, 3, 82, 845,
    8, 82, 1, 82, 1, 82, 1, 82, 1, 82, 1, 82, 1, 82, 3, 82, 853, 8, 82, 1, 83,
    1, 83, 3, 83, 857, 8, 83, 1, 84, 1, 84, 1, 84, 1, 84, 3, 84, 863, 8, 84, 1,
    84, 3, 84, 866, 8, 84, 1, 84, 1, 84, 3, 84, 870, 8, 84, 1, 85, 1, 85, 1, 85,
    1, 85, 3, 85, 876, 8, 85, 1, 85, 1, 85, 1, 86, 1, 86, 3, 86, 882, 8, 86, 1,
    86, 1, 86, 1, 86, 1, 86, 1, 87, 1, 87, 1, 87, 5, 87, 891, 8, 87, 10, 87, 12,
    87, 894, 9, 87, 1, 87, 1, 87, 1, 87, 1, 87, 3, 87, 900, 8, 87, 1, 87, 3, 87,
    903, 8, 87, 1, 88, 1, 88, 1, 88, 5, 88, 908, 8, 88, 10, 88, 12, 88, 911, 9,
    88, 1, 88, 3, 88, 914, 8, 88, 1, 88, 1, 88, 1, 88, 1, 89, 1, 89, 1, 89, 5,
    89, 922, 8, 89, 10, 89, 12, 89, 925, 9, 89, 1, 89, 1, 89, 1, 89, 1, 89, 3,
    89, 931, 8, 89, 1, 90, 1, 90, 1, 90, 5, 90, 936, 8, 90, 10, 90, 12, 90, 939,
    9, 90, 1, 90, 3, 90, 942, 8, 90, 1, 90, 1, 90, 1, 90, 1, 91, 1, 91, 1, 91,
    1, 91, 3, 91, 951, 8, 91, 1, 92, 1, 92, 3, 92, 955, 8, 92, 1, 93, 1, 93, 1,
    93, 1, 93, 4, 93, 961, 8, 93, 11, 93, 12, 93, 962, 1, 93, 1, 93, 1, 94, 1,
    94, 1, 94, 1, 95, 1, 95, 1, 95, 1, 96, 1, 96, 1, 97, 1, 97, 1, 98, 1, 98, 1,
    99, 1, 99, 1, 100, 1, 100, 1, 101, 1, 101, 1, 102, 1, 102, 1, 103, 1, 103,
    3, 103, 989, 8, 103, 1, 104, 1, 104, 1, 105, 1, 105, 1, 106, 1, 106, 1, 106,
    0, 0, 107, 0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32,
    34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68, 70,
    72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106,
    108, 110, 112, 114, 116, 118, 120, 122, 124, 126, 128, 130, 132, 134, 136,
    138, 140, 142, 144, 146, 148, 150, 152, 154, 156, 158, 160, 162, 164, 166,
    168, 170, 172, 174, 176, 178, 180, 182, 184, 186, 188, 190, 192, 194, 196,
    198, 200, 202, 204, 206, 208, 210, 212, 0, 15, 2, 0, 7, 7, 30, 30, 2, 0, 5,
    5, 30, 30, 1, 0, 60, 61, 1, 0, 66, 72, 1, 0, 90, 91, 1, 0, 86, 87, 1, 0, 94,
    96, 2, 0, 31, 31, 43, 43, 1, 0, 39, 42, 1, 0, 64, 65, 2, 0, 59, 59, 63, 63,
    1, 0, 17, 18, 2, 0, 14, 14, 16, 16, 5, 0, 47, 47, 51, 51, 53, 53, 64, 65,
    73, 73, 5, 0, 47, 47, 51, 51, 53, 53, 71, 71, 73, 73, 1020, 0, 214, 1, 0, 0,
    0, 2, 218, 1, 0, 0, 0, 4, 221, 1, 0, 0, 0, 6, 235, 1, 0, 0, 0, 8, 240, 1, 0,
    0, 0, 10, 256, 1, 0, 0, 0, 12, 261, 1, 0, 0, 0, 14, 277, 1, 0, 0, 0, 16,
    289, 1, 0, 0, 0, 18, 295, 1, 0, 0, 0, 20, 336, 1, 0, 0, 0, 22, 338, 1, 0, 0,
    0, 24, 343, 1, 0, 0, 0, 26, 355, 1, 0, 0, 0, 28, 361, 1, 0, 0, 0, 30, 368,
    1, 0, 0, 0, 32, 376, 1, 0, 0, 0, 34, 387, 1, 0, 0, 0, 36, 389, 1, 0, 0, 0,
    38, 399, 1, 0, 0, 0, 40, 406, 1, 0, 0, 0, 42, 412, 1, 0, 0, 0, 44, 428, 1,
    0, 0, 0, 46, 434, 1, 0, 0, 0, 48, 438, 1, 0, 0, 0, 50, 442, 1, 0, 0, 0, 52,
    448, 1, 0, 0, 0, 54, 451, 1, 0, 0, 0, 56, 463, 1, 0, 0, 0, 58, 471, 1, 0, 0,
    0, 60, 479, 1, 0, 0, 0, 62, 487, 1, 0, 0, 0, 64, 496, 1, 0, 0, 0, 66, 505,
    1, 0, 0, 0, 68, 518, 1, 0, 0, 0, 70, 520, 1, 0, 0, 0, 72, 528, 1, 0, 0, 0,
    74, 537, 1, 0, 0, 0, 76, 546, 1, 0, 0, 0, 78, 555, 1, 0, 0, 0, 80, 564, 1,
    0, 0, 0, 82, 575, 1, 0, 0, 0, 84, 580, 1, 0, 0, 0, 86, 582, 1, 0, 0, 0, 88,
    595, 1, 0, 0, 0, 90, 597, 1, 0, 0, 0, 92, 599, 1, 0, 0, 0, 94, 606, 1, 0, 0,
    0, 96, 608, 1, 0, 0, 0, 98, 610, 1, 0, 0, 0, 100, 614, 1, 0, 0, 0, 102, 618,
    1, 0, 0, 0, 104, 625, 1, 0, 0, 0, 106, 627, 1, 0, 0, 0, 108, 641, 1, 0, 0,
    0, 110, 655, 1, 0, 0, 0, 112, 674, 1, 0, 0, 0, 114, 689, 1, 0, 0, 0, 116,
    691, 1, 0, 0, 0, 118, 695, 1, 0, 0, 0, 120, 699, 1, 0, 0, 0, 122, 713, 1, 0,
    0, 0, 124, 726, 1, 0, 0, 0, 126, 741, 1, 0, 0, 0, 128, 750, 1, 0, 0, 0, 130,
    760, 1, 0, 0, 0, 132, 762, 1, 0, 0, 0, 134, 765, 1, 0, 0, 0, 136, 770, 1, 0,
    0, 0, 138, 772, 1, 0, 0, 0, 140, 783, 1, 0, 0, 0, 142, 785, 1, 0, 0, 0, 144,
    787, 1, 0, 0, 0, 146, 791, 1, 0, 0, 0, 148, 802, 1, 0, 0, 0, 150, 804, 1, 0,
    0, 0, 152, 806, 1, 0, 0, 0, 154, 810, 1, 0, 0, 0, 156, 821, 1, 0, 0, 0, 158,
    823, 1, 0, 0, 0, 160, 825, 1, 0, 0, 0, 162, 833, 1, 0, 0, 0, 164, 840, 1, 0,
    0, 0, 166, 856, 1, 0, 0, 0, 168, 858, 1, 0, 0, 0, 170, 875, 1, 0, 0, 0, 172,
    879, 1, 0, 0, 0, 174, 902, 1, 0, 0, 0, 176, 904, 1, 0, 0, 0, 178, 923, 1, 0,
    0, 0, 180, 932, 1, 0, 0, 0, 182, 950, 1, 0, 0, 0, 184, 954, 1, 0, 0, 0, 186,
    956, 1, 0, 0, 0, 188, 966, 1, 0, 0, 0, 190, 969, 1, 0, 0, 0, 192, 972, 1, 0,
    0, 0, 194, 974, 1, 0, 0, 0, 196, 976, 1, 0, 0, 0, 198, 978, 1, 0, 0, 0, 200,
    980, 1, 0, 0, 0, 202, 982, 1, 0, 0, 0, 204, 984, 1, 0, 0, 0, 206, 988, 1, 0,
    0, 0, 208, 990, 1, 0, 0, 0, 210, 992, 1, 0, 0, 0, 212, 994, 1, 0, 0, 0, 214,
    215, 3, 54, 27, 0, 215, 216, 5, 31, 0, 0, 216, 217, 3, 2, 1, 0, 217, 1, 1,
    0, 0, 0, 218, 219, 3, 50, 25, 0, 219, 220, 5, 0, 0, 1, 220, 3, 1, 0, 0, 0,
    221, 222, 5, 39, 0, 0, 222, 227, 3, 6, 3, 0, 223, 224, 5, 7, 0, 0, 224, 226,
    3, 6, 3, 0, 225, 223, 1, 0, 0, 0, 226, 229, 1, 0, 0, 0, 227, 225, 1, 0, 0,
    0, 227, 228, 1, 0, 0, 0, 228, 231, 1, 0, 0, 0, 229, 227, 1, 0, 0, 0, 230,
    232, 5, 7, 0, 0, 231, 230, 1, 0, 0, 0, 231, 232, 1, 0, 0, 0, 232, 233, 1, 0,
    0, 0, 233, 234, 5, 40, 0, 0, 234, 5, 1, 0, 0, 0, 235, 238, 3, 210, 105, 0,
    236, 237, 5, 29, 0, 0, 237, 239, 3, 34, 17, 0, 238, 236, 1, 0, 0, 0, 238,
    239, 1, 0, 0, 0, 239, 7, 1, 0, 0, 0, 240, 252, 5, 8, 0, 0, 241, 246, 3, 10,
    5, 0, 242, 243, 5, 7, 0, 0, 243, 245, 3, 10, 5, 0, 244, 242, 1, 0, 0, 0,
    245, 248, 1, 0, 0, 0, 246, 244, 1, 0, 0, 0, 246, 247, 1, 0, 0, 0, 247, 250,
    1, 0, 0, 0, 248, 246, 1, 0, 0, 0, 249, 251, 5, 7, 0, 0, 250, 249, 1, 0, 0,
    0, 250, 251, 1, 0, 0, 0, 251, 253, 1, 0, 0, 0, 252, 241, 1, 0, 0, 0, 252,
    253, 1, 0, 0, 0, 253, 254, 1, 0, 0, 0, 254, 255, 5, 9, 0, 0, 255, 9, 1, 0,
    0, 0, 256, 259, 3, 32, 16, 0, 257, 258, 5, 31, 0, 0, 258, 260, 3, 50, 25, 0,
    259, 257, 1, 0, 0, 0, 259, 260, 1, 0, 0, 0, 260, 11, 1, 0, 0, 0, 261, 273,
    5, 8, 0, 0, 262, 267, 3, 30, 15, 0, 263, 264, 5, 7, 0, 0, 264, 266, 3, 30,
    15, 0, 265, 263, 1, 0, 0, 0, 266, 269, 1, 0, 0, 0, 267, 265, 1, 0, 0, 0,
    267, 268, 1, 0, 0, 0, 268, 271, 1, 0, 0, 0, 269, 267, 1, 0, 0, 0, 270, 272,
    5, 7, 0, 0, 271, 270, 1, 0, 0, 0, 271, 272, 1, 0, 0, 0, 272, 274, 1, 0, 0,
    0, 273, 262, 1, 0, 0, 0, 273, 274, 1, 0, 0, 0, 274, 275, 1, 0, 0, 0, 275,
    276, 5, 9, 0, 0, 276, 13, 1, 0, 0, 0, 277, 278, 5, 8, 0, 0, 278, 281, 3,
    210, 105, 0, 279, 280, 5, 7, 0, 0, 280, 282, 3, 210, 105, 0, 281, 279, 1, 0,
    0, 0, 282, 283, 1, 0, 0, 0, 283, 281, 1, 0, 0, 0, 283, 284, 1, 0, 0, 0, 284,
    285, 1, 0, 0, 0, 285, 286, 5, 9, 0, 0, 286, 15, 1, 0, 0, 0, 287, 290, 3,
    210, 105, 0, 288, 290, 3, 14, 7, 0, 289, 287, 1, 0, 0, 0, 289, 288, 1, 0, 0,
    0, 290, 293, 1, 0, 0, 0, 291, 292, 5, 29, 0, 0, 292, 294, 3, 34, 17, 0, 293,
    291, 1, 0, 0, 0, 293, 294, 1, 0, 0, 0, 294, 17, 1, 0, 0, 0, 295, 296, 7, 0,
    0, 0, 296, 19, 1, 0, 0, 0, 297, 298, 5, 49, 0, 0, 298, 304, 3, 26, 13, 0,
    299, 300, 3, 18, 9, 0, 300, 301, 3, 26, 13, 0, 301, 303, 1, 0, 0, 0, 302,
    299, 1, 0, 0, 0, 303, 306, 1, 0, 0, 0, 304, 302, 1, 0, 0, 0, 304, 305, 1, 0,
    0, 0, 305, 308, 1, 0, 0, 0, 306, 304, 1, 0, 0, 0, 307, 309, 5, 30, 0, 0,
    308, 307, 1, 0, 0, 0, 308, 309, 1, 0, 0, 0, 309, 337, 1, 0, 0, 0, 310, 311,
    5, 51, 0, 0, 311, 317, 3, 22, 11, 0, 312, 313, 3, 18, 9, 0, 313, 314, 3, 22,
    11, 0, 314, 316, 1, 0, 0, 0, 315, 312, 1, 0, 0, 0, 316, 319, 1, 0, 0, 0,
    317, 315, 1, 0, 0, 0, 317, 318, 1, 0, 0, 0, 318, 321, 1, 0, 0, 0, 319, 317,
    1, 0, 0, 0, 320, 322, 5, 30, 0, 0, 321, 320, 1, 0, 0, 0, 321, 322, 1, 0, 0,
    0, 322, 337, 1, 0, 0, 0, 323, 324, 5, 50, 0, 0, 324, 330, 3, 24, 12, 0, 325,
    326, 3, 18, 9, 0, 326, 327, 3, 24, 12, 0, 327, 329, 1, 0, 0, 0, 328, 325, 1,
    0, 0, 0, 329, 332, 1, 0, 0, 0, 330, 328, 1, 0, 0, 0, 330, 331, 1, 0, 0, 0,
    331, 334, 1, 0, 0, 0, 332, 330, 1, 0, 0, 0, 333, 335, 5, 30, 0, 0, 334, 333,
    1, 0, 0, 0, 334, 335, 1, 0, 0, 0, 335, 337, 1, 0, 0, 0, 336, 297, 1, 0, 0,
    0, 336, 310, 1, 0, 0, 0, 336, 323, 1, 0, 0, 0, 337, 21, 1, 0, 0, 0, 338,
    339, 5, 8, 0, 0, 339, 340, 3, 50, 25, 0, 340, 341, 5, 9, 0, 0, 341, 342, 3,
    50, 25, 0, 342, 23, 1, 0, 0, 0, 343, 345, 3, 210, 105, 0, 344, 346, 3, 110,
    55, 0, 345, 344, 1, 0, 0, 0, 345, 346, 1, 0, 0, 0, 346, 348, 1, 0, 0, 0,
    347, 349, 3, 98, 49, 0, 348, 347, 1, 0, 0, 0, 348, 349, 1, 0, 0, 0, 349, 25,
    1, 0, 0, 0, 350, 352, 5, 52, 0, 0, 351, 350, 1, 0, 0, 0, 351, 352, 1, 0, 0,
    0, 352, 353, 1, 0, 0, 0, 353, 356, 3, 16, 8, 0, 354, 356, 3, 54, 27, 0, 355,
    351, 1, 0, 0, 0, 355, 354, 1, 0, 0, 0, 356, 357, 1, 0, 0, 0, 357, 358, 5,
    31, 0, 0, 358, 359, 3, 50, 25, 0, 359, 27, 1, 0, 0, 0, 360, 362, 3, 20, 10,
    0, 361, 360, 1, 0, 0, 0, 362, 363, 1, 0, 0, 0, 363, 361, 1, 0, 0, 0, 363,
    364, 1, 0, 0, 0, 364, 365, 1, 0, 0, 0, 365, 366, 5, 60, 0, 0, 366, 367, 3,
    50, 25, 0, 367, 29, 1, 0, 0, 0, 368, 370, 3, 210, 105, 0, 369, 371, 5, 28,
    0, 0, 370, 369, 1, 0, 0, 0, 370, 371, 1, 0, 0, 0, 371, 374, 1, 0, 0, 0, 372,
    373, 5, 29, 0, 0, 373, 375, 3, 34, 17, 0, 374, 372, 1, 0, 0, 0, 374, 375, 1,
    0, 0, 0, 375, 31, 1, 0, 0, 0, 376, 378, 3, 210, 105, 0, 377, 379, 5, 28, 0,
    0, 378, 377, 1, 0, 0, 0, 378, 379, 1, 0, 0, 0, 379, 380, 1, 0, 0, 0, 380,
    381, 5, 29, 0, 0, 381, 382, 3, 34, 17, 0, 382, 33, 1, 0, 0, 0, 383, 388, 3,
    44, 22, 0, 384, 388, 3, 38, 19, 0, 385, 388, 3, 40, 20, 0, 386, 388, 3, 36,
    18, 0, 387, 383, 1, 0, 0, 0, 387, 384, 1, 0, 0, 0, 387, 385, 1, 0, 0, 0,
    387, 386, 1, 0, 0, 0, 388, 35, 1, 0, 0, 0, 389, 390, 5, 8, 0, 0, 390, 393,
    3, 34, 17, 0, 391, 392, 5, 7, 0, 0, 392, 394, 3, 34, 17, 0, 393, 391, 1, 0,
    0, 0, 394, 395, 1, 0, 0, 0, 395, 393, 1, 0, 0, 0, 395, 396, 1, 0, 0, 0, 396,
    397, 1, 0, 0, 0, 397, 398, 5, 9, 0, 0, 398, 37, 1, 0, 0, 0, 399, 401, 3,
    210, 105, 0, 400, 402, 3, 106, 53, 0, 401, 400, 1, 0, 0, 0, 401, 402, 1, 0,
    0, 0, 402, 39, 1, 0, 0, 0, 403, 404, 3, 46, 23, 0, 404, 405, 5, 6, 0, 0,
    405, 407, 1, 0, 0, 0, 406, 403, 1, 0, 0, 0, 406, 407, 1, 0, 0, 0, 407, 408,
    1, 0, 0, 0, 408, 409, 3, 42, 21, 0, 409, 410, 5, 32, 0, 0, 410, 411, 3, 34,
    17, 0, 411, 41, 1, 0, 0, 0, 412, 414, 5, 8, 0, 0, 413, 415, 3, 34, 17, 0,
    414, 413, 1, 0, 0, 0, 414, 415, 1, 0, 0, 0, 415, 420, 1, 0, 0, 0, 416, 417,
    5, 7, 0, 0, 417, 419, 3, 34, 17, 0, 418, 416, 1, 0, 0, 0, 419, 422, 1, 0, 0,
    0, 420, 418, 1, 0, 0, 0, 420, 421, 1, 0, 0, 0, 421, 424, 1, 0, 0, 0, 422,
    420, 1, 0, 0, 0, 423, 425, 5, 7, 0, 0, 424, 423, 1, 0, 0, 0, 424, 425, 1, 0,
    0, 0, 425, 426, 1, 0, 0, 0, 426, 427, 5, 9, 0, 0, 427, 43, 1, 0, 0, 0, 428,
    429, 5, 8, 0, 0, 429, 430, 3, 34, 17, 0, 430, 431, 5, 9, 0, 0, 431, 45, 1,
    0, 0, 0, 432, 435, 3, 44, 22, 0, 433, 435, 3, 38, 19, 0, 434, 432, 1, 0, 0,
    0, 434, 433, 1, 0, 0, 0, 435, 47, 1, 0, 0, 0, 436, 439, 7, 1, 0, 0, 437,
    439, 5, 0, 0, 1, 438, 436, 1, 0, 0, 0, 438, 437, 1, 0, 0, 0, 439, 49, 1, 0,
    0, 0, 440, 443, 3, 166, 83, 0, 441, 443, 3, 52, 26, 0, 442, 440, 1, 0, 0, 0,
    442, 441, 1, 0, 0, 0, 443, 51, 1, 0, 0, 0, 444, 449, 3, 28, 14, 0, 445, 449,
    3, 168, 84, 0, 446, 449, 3, 172, 86, 0, 447, 449, 3, 56, 28, 0, 448, 444, 1,
    0, 0, 0, 448, 445, 1, 0, 0, 0, 448, 446, 1, 0, 0, 0, 448, 447, 1, 0, 0, 0,
    449, 53, 1, 0, 0, 0, 450, 452, 3, 4, 2, 0, 451, 450, 1, 0, 0, 0, 451, 452,
    1, 0, 0, 0, 452, 456, 1, 0, 0, 0, 453, 454, 3, 46, 23, 0, 454, 455, 5, 6, 0,
    0, 455, 457, 1, 0, 0, 0, 456, 453, 1, 0, 0, 0, 456, 457, 1, 0, 0, 0, 457,
    458, 1, 0, 0, 0, 458, 459, 3, 210, 105, 0, 459, 460, 3, 8, 4, 0, 460, 461,
    5, 29, 0, 0, 461, 462, 3, 34, 17, 0, 462, 55, 1, 0, 0, 0, 463, 468, 3, 58,
    29, 0, 464, 465, 5, 26, 0, 0, 465, 467, 3, 58, 29, 0, 466, 464, 1, 0, 0, 0,
    467, 470, 1, 0, 0, 0, 468, 466, 1, 0, 0, 0, 468, 469, 1, 0, 0, 0, 469, 57,
    1, 0, 0, 0, 470, 468, 1, 0, 0, 0, 471, 476, 3, 60, 30, 0, 472, 473, 5, 22,
    0, 0, 473, 475, 3, 60, 30, 0, 474, 472, 1, 0, 0, 0, 475, 478, 1, 0, 0, 0,
    476, 474, 1, 0, 0, 0, 476, 477, 1, 0, 0, 0, 477, 59, 1, 0, 0, 0, 478, 476,
    1, 0, 0, 0, 479, 484, 3, 62, 31, 0, 480, 481, 5, 19, 0, 0, 481, 483, 3, 62,
    31, 0, 482, 480, 1, 0, 0, 0, 483, 486, 1, 0, 0, 0, 484, 482, 1, 0, 0, 0,
    484, 485, 1, 0, 0, 0, 485, 61, 1, 0, 0, 0, 486, 484, 1, 0, 0, 0, 487, 493,
    3, 64, 32, 0, 488, 489, 3, 192, 96, 0, 489, 490, 3, 64, 32, 0, 490, 492, 1,
    0, 0, 0, 491, 488, 1, 0, 0, 0, 492, 495, 1, 0, 0, 0, 493, 491, 1, 0, 0, 0,
    493, 494, 1, 0, 0, 0, 494, 63, 1, 0, 0, 0, 495, 493, 1, 0, 0, 0, 496, 502,
    3, 66, 33, 0, 497, 498, 3, 194, 97, 0, 498, 499, 3, 66, 33, 0, 499, 501, 1,
    0, 0, 0, 500, 497, 1, 0, 0, 0, 501, 504, 1, 0, 0, 0, 502, 500, 1, 0, 0, 0,
    502, 503, 1, 0, 0, 0, 503, 65, 1, 0, 0, 0, 504, 502, 1, 0, 0, 0, 505, 509,
    3, 70, 35, 0, 506, 508, 3, 68, 34, 0, 507, 506, 1, 0, 0, 0, 508, 511, 1, 0,
    0, 0, 509, 507, 1, 0, 0, 0, 509, 510, 1, 0, 0, 0, 510, 67, 1, 0, 0, 0, 511,
    509, 1, 0, 0, 0, 512, 513, 3, 196, 98, 0, 513, 514, 3, 70, 35, 0, 514, 519,
    1, 0, 0, 0, 515, 516, 3, 198, 99, 0, 516, 517, 3, 34, 17, 0, 517, 519, 1, 0,
    0, 0, 518, 512, 1, 0, 0, 0, 518, 515, 1, 0, 0, 0, 519, 69, 1, 0, 0, 0, 520,
    525, 3, 72, 36, 0, 521, 522, 5, 38, 0, 0, 522, 524, 3, 72, 36, 0, 523, 521,
    1, 0, 0, 0, 524, 527, 1, 0, 0, 0, 525, 523, 1, 0, 0, 0, 525, 526, 1, 0, 0,
    0, 526, 71, 1, 0, 0, 0, 527, 525, 1, 0, 0, 0, 528, 534, 3, 74, 37, 0, 529,
    530, 3, 210, 105, 0, 530, 531, 3, 74, 37, 0, 531, 533, 1, 0, 0, 0, 532, 529,
    1, 0, 0, 0, 533, 536, 1, 0, 0, 0, 534, 532, 1, 0, 0, 0, 534, 535, 1, 0, 0,
    0, 535, 73, 1, 0, 0, 0, 536, 534, 1, 0, 0, 0, 537, 543, 3, 76, 38, 0, 538,
    539, 3, 200, 100, 0, 539, 540, 3, 76, 38, 0, 540, 542, 1, 0, 0, 0, 541, 538,
    1, 0, 0, 0, 542, 545, 1, 0, 0, 0, 543, 541, 1, 0, 0, 0, 543, 544, 1, 0, 0,
    0, 544, 75, 1, 0, 0, 0, 545, 543, 1, 0, 0, 0, 546, 552, 3, 78, 39, 0, 547,
    548, 3, 202, 101, 0, 548, 549, 3, 78, 39, 0, 549, 551, 1, 0, 0, 0, 550, 547,
    1, 0, 0, 0, 551, 554, 1, 0, 0, 0, 552, 550, 1, 0, 0, 0, 552, 553, 1, 0, 0,
    0, 553, 77, 1, 0, 0, 0, 554, 552, 1, 0, 0, 0, 555, 561, 3, 80, 40, 0, 556,
    557, 3, 204, 102, 0, 557, 558, 3, 80, 40, 0, 558, 560, 1, 0, 0, 0, 559, 556,
    1, 0, 0, 0, 560, 563, 1, 0, 0, 0, 561, 559, 1, 0, 0, 0, 561, 562, 1, 0, 0,
    0, 562, 79, 1, 0, 0, 0, 563, 561, 1, 0, 0, 0, 564, 569, 3, 82, 41, 0, 565,
    566, 5, 58, 0, 0, 566, 568, 3, 34, 17, 0, 567, 565, 1, 0, 0, 0, 568, 571, 1,
    0, 0, 0, 569, 567, 1, 0, 0, 0, 569, 570, 1, 0, 0, 0, 570, 81, 1, 0, 0, 0,
    571, 569, 1, 0, 0, 0, 572, 574, 3, 84, 42, 0, 573, 572, 1, 0, 0, 0, 574,
    577, 1, 0, 0, 0, 575, 573, 1, 0, 0, 0, 575, 576, 1, 0, 0, 0, 576, 578, 1, 0,
    0, 0, 577, 575, 1, 0, 0, 0, 578, 579, 3, 86, 43, 0, 579, 83, 1, 0, 0, 0,
    580, 581, 3, 206, 103, 0, 581, 85, 1, 0, 0, 0, 582, 586, 3, 114, 57, 0, 583,
    585, 3, 88, 44, 0, 584, 583, 1, 0, 0, 0, 585, 588, 1, 0, 0, 0, 586, 584, 1,
    0, 0, 0, 586, 587, 1, 0, 0, 0, 587, 87, 1, 0, 0, 0, 588, 586, 1, 0, 0, 0,
    589, 596, 3, 100, 50, 0, 590, 596, 3, 92, 46, 0, 591, 596, 3, 98, 49, 0,
    592, 596, 3, 96, 48, 0, 593, 596, 3, 94, 47, 0, 594, 596, 3, 90, 45, 0, 595,
    589, 1, 0, 0, 0, 595, 590, 1, 0, 0, 0, 595, 591, 1, 0, 0, 0, 595, 592, 1, 0,
    0, 0, 595, 593, 1, 0, 0, 0, 595, 594, 1, 0, 0, 0, 596, 89, 1, 0, 0, 0, 597,
    598, 5, 37, 0, 0, 598, 91, 1, 0, 0, 0, 599, 600, 5, 10, 0, 0, 600, 602, 3,
    50, 25, 0, 601, 603, 5, 7, 0, 0, 602, 601, 1, 0, 0, 0, 602, 603, 1, 0, 0, 0,
    603, 604, 1, 0, 0, 0, 604, 605, 5, 11, 0, 0, 605, 93, 1, 0, 0, 0, 606, 607,
    5, 28, 0, 0, 607, 95, 1, 0, 0, 0, 608, 609, 5, 27, 0, 0, 609, 97, 1, 0, 0,
    0, 610, 611, 5, 6, 0, 0, 611, 612, 3, 212, 106, 0, 612, 99, 1, 0, 0, 0, 613,
    615, 3, 108, 54, 0, 614, 613, 1, 0, 0, 0, 614, 615, 1, 0, 0, 0, 615, 616, 1,
    0, 0, 0, 616, 617, 3, 110, 55, 0, 617, 101, 1, 0, 0, 0, 618, 619, 7, 2, 0,
    0, 619, 103, 1, 0, 0, 0, 620, 622, 3, 102, 51, 0, 621, 620, 1, 0, 0, 0, 621,
    622, 1, 0, 0, 0, 622, 623, 1, 0, 0, 0, 623, 626, 3, 34, 17, 0, 624, 626, 5,
    14, 0, 0, 625, 621, 1, 0, 0, 0, 625, 624, 1, 0, 0, 0, 626, 105, 1, 0, 0, 0,
    627, 628, 5, 39, 0, 0, 628, 633, 3, 104, 52, 0, 629, 630, 5, 7, 0, 0, 630,
    632, 3, 104, 52, 0, 631, 629, 1, 0, 0, 0, 632, 635, 1, 0, 0, 0, 633, 631, 1,
    0, 0, 0, 633, 634, 1, 0, 0, 0, 634, 637, 1, 0, 0, 0, 635, 633, 1, 0, 0, 0,
    636, 638, 5, 7, 0, 0, 637, 636, 1, 0, 0, 0, 637, 638, 1, 0, 0, 0, 638, 639,
    1, 0, 0, 0, 639, 640, 5, 40, 0, 0, 640, 107, 1, 0, 0, 0, 641, 642, 5, 39, 0,
    0, 642, 647, 3, 34, 17, 0, 643, 644, 5, 7, 0, 0, 644, 646, 3, 34, 17, 0,
    645, 643, 1, 0, 0, 0, 646, 649, 1, 0, 0, 0, 647, 645, 1, 0, 0, 0, 647, 648,
    1, 0, 0, 0, 648, 651, 1, 0, 0, 0, 649, 647, 1, 0, 0, 0, 650, 652, 5, 7, 0,
    0, 651, 650, 1, 0, 0, 0, 651, 652, 1, 0, 0, 0, 652, 653, 1, 0, 0, 0, 653,
    654, 5, 40, 0, 0, 654, 109, 1, 0, 0, 0, 655, 667, 5, 8, 0, 0, 656, 661, 3,
    112, 56, 0, 657, 658, 5, 7, 0, 0, 658, 660, 3, 112, 56, 0, 659, 657, 1, 0,
    0, 0, 660, 663, 1, 0, 0, 0, 661, 659, 1, 0, 0, 0, 661, 662, 1, 0, 0, 0, 662,
    665, 1, 0, 0, 0, 663, 661, 1, 0, 0, 0, 664, 666, 5, 7, 0, 0, 665, 664, 1, 0,
    0, 0, 665, 666, 1, 0, 0, 0, 666, 668, 1, 0, 0, 0, 667, 656, 1, 0, 0, 0, 667,
    668, 1, 0, 0, 0, 668, 669, 1, 0, 0, 0, 669, 670, 5, 9, 0, 0, 670, 111, 1, 0,
    0, 0, 671, 672, 3, 210, 105, 0, 672, 673, 5, 31, 0, 0, 673, 675, 1, 0, 0, 0,
    674, 671, 1, 0, 0, 0, 674, 675, 1, 0, 0, 0, 675, 676, 1, 0, 0, 0, 676, 677,
    3, 50, 25, 0, 677, 113, 1, 0, 0, 0, 678, 690, 3, 116, 58, 0, 679, 690, 3,
    210, 105, 0, 680, 690, 3, 134, 67, 0, 681, 690, 3, 136, 68, 0, 682, 690, 3,
    124, 62, 0, 683, 690, 3, 122, 61, 0, 684, 690, 3, 120, 60, 0, 685, 690, 3,
    126, 63, 0, 686, 690, 3, 128, 64, 0, 687, 690, 3, 130, 65, 0, 688, 690, 3,
    132, 66, 0, 689, 678, 1, 0, 0, 0, 689, 679, 1, 0, 0, 0, 689, 680, 1, 0, 0,
    0, 689, 681, 1, 0, 0, 0, 689, 682, 1, 0, 0, 0, 689, 683, 1, 0, 0, 0, 689,
    684, 1, 0, 0, 0, 689, 685, 1, 0, 0, 0, 689, 686, 1, 0, 0, 0, 689, 687, 1, 0,
    0, 0, 689, 688, 1, 0, 0, 0, 690, 115, 1, 0, 0, 0, 691, 692, 5, 8, 0, 0, 692,
    693, 3, 50, 25, 0, 693, 694, 5, 9, 0, 0, 694, 117, 1, 0, 0, 0, 695, 696, 3,
    50, 25, 0, 696, 697, 5, 29, 0, 0, 697, 698, 3, 50, 25, 0, 698, 119, 1, 0, 0,
    0, 699, 700, 5, 47, 0, 0, 700, 709, 5, 12, 0, 0, 701, 706, 3, 118, 59, 0,
    702, 703, 5, 7, 0, 0, 703, 705, 3, 118, 59, 0, 704, 702, 1, 0, 0, 0, 705,
    708, 1, 0, 0, 0, 706, 704, 1, 0, 0, 0, 706, 707, 1, 0, 0, 0, 707, 710, 1, 0,
    0, 0, 708, 706, 1, 0, 0, 0, 709, 701, 1, 0, 0, 0, 709, 710, 1, 0, 0, 0, 710,
    711, 1, 0, 0, 0, 711, 712, 5, 13, 0, 0, 712, 121, 1, 0, 0, 0, 713, 722, 5,
    12, 0, 0, 714, 719, 3, 50, 25, 0, 715, 716, 5, 7, 0, 0, 716, 718, 3, 50, 25,
    0, 717, 715, 1, 0, 0, 0, 718, 721, 1, 0, 0, 0, 719, 717, 1, 0, 0, 0, 719,
    720, 1, 0, 0, 0, 720, 723, 1, 0, 0, 0, 721, 719, 1, 0, 0, 0, 722, 714, 1, 0,
    0, 0, 722, 723, 1, 0, 0, 0, 723, 724, 1, 0, 0, 0, 724, 725, 5, 13, 0, 0,
    725, 123, 1, 0, 0, 0, 726, 735, 5, 10, 0, 0, 727, 732, 3, 50, 25, 0, 728,
    729, 5, 7, 0, 0, 729, 731, 3, 50, 25, 0, 730, 728, 1, 0, 0, 0, 731, 734, 1,
    0, 0, 0, 732, 730, 1, 0, 0, 0, 732, 733, 1, 0, 0, 0, 733, 736, 1, 0, 0, 0,
    734, 732, 1, 0, 0, 0, 735, 727, 1, 0, 0, 0, 735, 736, 1, 0, 0, 0, 736, 737,
    1, 0, 0, 0, 737, 738, 5, 11, 0, 0, 738, 125, 1, 0, 0, 0, 739, 742, 5, 10, 0,
    0, 740, 742, 5, 11, 0, 0, 741, 739, 1, 0, 0, 0, 741, 740, 1, 0, 0, 0, 742,
    743, 1, 0, 0, 0, 743, 744, 3, 50, 25, 0, 744, 745, 5, 34, 0, 0, 745, 748, 3,
    50, 25, 0, 746, 749, 5, 10, 0, 0, 747, 749, 5, 11, 0, 0, 748, 746, 1, 0, 0,
    0, 748, 747, 1, 0, 0, 0, 749, 127, 1, 0, 0, 0, 750, 751, 5, 8, 0, 0, 751,
    754, 3, 50, 25, 0, 752, 753, 5, 7, 0, 0, 753, 755, 3, 50, 25, 0, 754, 752,
    1, 0, 0, 0, 755, 756, 1, 0, 0, 0, 756, 754, 1, 0, 0, 0, 756, 757, 1, 0, 0,
    0, 757, 758, 1, 0, 0, 0, 758, 759, 5, 9, 0, 0, 759, 129, 1, 0, 0, 0, 760,
    761, 5, 45, 0, 0, 761, 131, 1, 0, 0, 0, 762, 763, 5, 6, 0, 0, 763, 764, 5,
    73, 0, 0, 764, 133, 1, 0, 0, 0, 765, 766, 7, 3, 0, 0, 766, 135, 1, 0, 0, 0,
    767, 771, 3, 146, 73, 0, 768, 771, 3, 154, 77, 0, 769, 771, 3, 138, 69, 0,
    770, 767, 1, 0, 0, 0, 770, 768, 1, 0, 0, 0, 770, 769, 1, 0, 0, 0, 771, 137,
    1, 0, 0, 0, 772, 776, 5, 75, 0, 0, 773, 775, 3, 140, 70, 0, 774, 773, 1, 0,
    0, 0, 775, 778, 1, 0, 0, 0, 776, 774, 1, 0, 0, 0, 776, 777, 1, 0, 0, 0, 777,
    779, 1, 0, 0, 0, 778, 776, 1, 0, 0, 0, 779, 780, 5, 89, 0, 0, 780, 139, 1,
    0, 0, 0, 781, 784, 3, 142, 71, 0, 782, 784, 3, 144, 72, 0, 783, 781, 1, 0,
    0, 0, 783, 782, 1, 0, 0, 0, 784, 141, 1, 0, 0, 0, 785, 786, 7, 4, 0, 0, 786,
    143, 1, 0, 0, 0, 787, 788, 5, 92, 0, 0, 788, 789, 3, 50, 25, 0, 789, 790, 5,
    13, 0, 0, 790, 145, 1, 0, 0, 0, 791, 795, 5, 76, 0, 0, 792, 794, 3, 148, 74,
    0, 793, 792, 1, 0, 0, 0, 794, 797, 1, 0, 0, 0, 795, 793, 1, 0, 0, 0, 795,
    796, 1, 0, 0, 0, 796, 798, 1, 0, 0, 0, 797, 795, 1, 0, 0, 0, 798, 799, 5,
    85, 0, 0, 799, 147, 1, 0, 0, 0, 800, 803, 3, 150, 75, 0, 801, 803, 3, 152,
    76, 0, 802, 800, 1, 0, 0, 0, 802, 801, 1, 0, 0, 0, 803, 149, 1, 0, 0, 0,
    804, 805, 7, 5, 0, 0, 805, 151, 1, 0, 0, 0, 806, 807, 5, 88, 0, 0, 807, 808,
    3, 50, 25, 0, 808, 809, 5, 13, 0, 0, 809, 153, 1, 0, 0, 0, 810, 814, 5, 77,
    0, 0, 811, 813, 3, 156, 78, 0, 812, 811, 1, 0, 0, 0, 813, 816, 1, 0, 0, 0,
    814, 812, 1, 0, 0, 0, 814, 815, 1, 0, 0, 0, 815, 817, 1, 0, 0, 0, 816, 814,
    1, 0, 0, 0, 817, 818, 5, 93, 0, 0, 818, 155, 1, 0, 0, 0, 819, 822, 3, 158,
    79, 0, 820, 822, 3, 160, 80, 0, 821, 819, 1, 0, 0, 0, 821, 820, 1, 0, 0, 0,
    822, 157, 1, 0, 0, 0, 823, 824, 7, 6, 0, 0, 824, 159, 1, 0, 0, 0, 825, 826,
    5, 97, 0, 0, 826, 827, 3, 50, 25, 0, 827, 828, 5, 13, 0, 0, 828, 161, 1, 0,
    0, 0, 829, 834, 3, 12, 6, 0, 830, 831, 5, 8, 0, 0, 831, 834, 5, 9, 0, 0,
    832, 834, 3, 30, 15, 0, 833, 829, 1, 0, 0, 0, 833, 830, 1, 0, 0, 0, 833,
    832, 1, 0, 0, 0, 834, 835, 1, 0, 0, 0, 835, 836, 5, 32, 0, 0, 836, 838, 1,
    0, 0, 0, 837, 839, 3, 50, 25, 0, 838, 837, 1, 0, 0, 0, 838, 839, 1, 0, 0, 0,
    839, 163, 1, 0, 0, 0, 840, 844, 5, 48, 0, 0, 841, 842, 3, 46, 23, 0, 842,
    843, 5, 6, 0, 0, 843, 845, 1, 0, 0, 0, 844, 841, 1, 0, 0, 0, 844, 845, 1, 0,
    0, 0, 845, 846, 1, 0, 0, 0, 846, 847, 3, 12, 6, 0, 847, 848, 5, 29, 0, 0,
    848, 849, 3, 34, 17, 0, 849, 852, 1, 0, 0, 0, 850, 851, 5, 33, 0, 0, 851,
    853, 3, 50, 25, 0, 852, 850, 1, 0, 0, 0, 852, 853, 1, 0, 0, 0, 853, 165, 1,
    0, 0, 0, 854, 857, 3, 162, 81, 0, 855, 857, 3, 164, 82, 0, 856, 854, 1, 0,
    0, 0, 856, 855, 1, 0, 0, 0, 857, 167, 1, 0, 0, 0, 858, 859, 5, 54, 0, 0,
    859, 860, 3, 50, 25, 0, 860, 862, 5, 55, 0, 0, 861, 863, 3, 50, 25, 0, 862,
    861, 1, 0, 0, 0, 862, 863, 1, 0, 0, 0, 863, 865, 1, 0, 0, 0, 864, 866, 5,
    30, 0, 0, 865, 864, 1, 0, 0, 0, 865, 866, 1, 0, 0, 0, 866, 867, 1, 0, 0, 0,
    867, 869, 5, 56, 0, 0, 868, 870, 3, 50, 25, 0, 869, 868, 1, 0, 0, 0, 869,
    870, 1, 0, 0, 0, 870, 169, 1, 0, 0, 0, 871, 872, 5, 52, 0, 0, 872, 873, 3,
    16, 8, 0, 873, 874, 5, 31, 0, 0, 874, 876, 1, 0, 0, 0, 875, 871, 1, 0, 0, 0,
    875, 876, 1, 0, 0, 0, 876, 877, 1, 0, 0, 0, 877, 878, 3, 50, 25, 0, 878,
    171, 1, 0, 0, 0, 879, 881, 5, 57, 0, 0, 880, 882, 3, 170, 85, 0, 881, 880,
    1, 0, 0, 0, 881, 882, 1, 0, 0, 0, 882, 883, 1, 0, 0, 0, 883, 884, 5, 12, 0,
    0, 884, 885, 3, 174, 87, 0, 885, 886, 5, 13, 0, 0, 886, 173, 1, 0, 0, 0,
    887, 888, 3, 176, 88, 0, 888, 889, 3, 18, 9, 0, 889, 891, 1, 0, 0, 0, 890,
    887, 1, 0, 0, 0, 891, 894, 1, 0, 0, 0, 892, 890, 1, 0, 0, 0, 892, 893, 1, 0,
    0, 0, 893, 895, 1, 0, 0, 0, 894, 892, 1, 0, 0, 0, 895, 896, 5, 56, 0, 0,
    896, 897, 5, 32, 0, 0, 897, 899, 3, 50, 25, 0, 898, 900, 3, 48, 24, 0, 899,
    898, 1, 0, 0, 0, 899, 900, 1, 0, 0, 0, 900, 903, 1, 0, 0, 0, 901, 903, 3,
    178, 89, 0, 902, 892, 1, 0, 0, 0, 902, 901, 1, 0, 0, 0, 903, 175, 1, 0, 0,
    0, 904, 909, 3, 182, 91, 0, 905, 906, 5, 7, 0, 0, 906, 908, 3, 182, 91, 0,
    907, 905, 1, 0, 0, 0, 908, 911, 1, 0, 0, 0, 909, 907, 1, 0, 0, 0, 909, 910,
    1, 0, 0, 0, 910, 913, 1, 0, 0, 0, 911, 909, 1, 0, 0, 0, 912, 914, 5, 7, 0,
    0, 913, 912, 1, 0, 0, 0, 913, 914, 1, 0, 0, 0, 914, 915, 1, 0, 0, 0, 915,
    916, 5, 32, 0, 0, 916, 917, 3, 50, 25, 0, 917, 177, 1, 0, 0, 0, 918, 919, 3,
    180, 90, 0, 919, 920, 3, 18, 9, 0, 920, 922, 1, 0, 0, 0, 921, 918, 1, 0, 0,
    0, 922, 925, 1, 0, 0, 0, 923, 921, 1, 0, 0, 0, 923, 924, 1, 0, 0, 0, 924,
    926, 1, 0, 0, 0, 925, 923, 1, 0, 0, 0, 926, 927, 5, 56, 0, 0, 927, 928, 5,
    29, 0, 0, 928, 930, 3, 50, 25, 0, 929, 931, 3, 48, 24, 0, 930, 929, 1, 0, 0,
    0, 930, 931, 1, 0, 0, 0, 931, 179, 1, 0, 0, 0, 932, 937, 3, 182, 91, 0, 933,
    934, 5, 7, 0, 0, 934, 936, 3, 182, 91, 0, 935, 933, 1, 0, 0, 0, 936, 939, 1,
    0, 0, 0, 937, 935, 1, 0, 0, 0, 937, 938, 1, 0, 0, 0, 938, 941, 1, 0, 0, 0,
    939, 937, 1, 0, 0, 0, 940, 942, 5, 7, 0, 0, 941, 940, 1, 0, 0, 0, 941, 942,
    1, 0, 0, 0, 942, 943, 1, 0, 0, 0, 943, 944, 5, 29, 0, 0, 944, 945, 3, 50,
    25, 0, 945, 181, 1, 0, 0, 0, 946, 951, 3, 186, 93, 0, 947, 951, 3, 188, 94,
    0, 948, 951, 3, 190, 95, 0, 949, 951, 3, 52, 26, 0, 950, 946, 1, 0, 0, 0,
    950, 947, 1, 0, 0, 0, 950, 948, 1, 0, 0, 0, 950, 949, 1, 0, 0, 0, 951, 183,
    1, 0, 0, 0, 952, 955, 5, 45, 0, 0, 953, 955, 3, 182, 91, 0, 954, 952, 1, 0,
    0, 0, 954, 953, 1, 0, 0, 0, 955, 185, 1, 0, 0, 0, 956, 957, 5, 8, 0, 0, 957,
    960, 3, 184, 92, 0, 958, 959, 5, 7, 0, 0, 959, 961, 3, 184, 92, 0, 960, 958,
    1, 0, 0, 0, 961, 962, 1, 0, 0, 0, 962, 960, 1, 0, 0, 0, 962, 963, 1, 0, 0,
    0, 963, 964, 1, 0, 0, 0, 964, 965, 5, 9, 0, 0, 965, 187, 1, 0, 0, 0, 966,
    967, 3, 196, 98, 0, 967, 968, 3, 50, 25, 0, 968, 189, 1, 0, 0, 0, 969, 970,
    3, 198, 99, 0, 970, 971, 3, 34, 17, 0, 971, 191, 1, 0, 0, 0, 972, 973, 7, 7,
    0, 0, 973, 193, 1, 0, 0, 0, 974, 975, 7, 8, 0, 0, 975, 195, 1, 0, 0, 0, 976,
    977, 7, 9, 0, 0, 977, 197, 1, 0, 0, 0, 978, 979, 7, 10, 0, 0, 979, 199, 1,
    0, 0, 0, 980, 981, 7, 11, 0, 0, 981, 201, 1, 0, 0, 0, 982, 983, 7, 12, 0, 0,
    983, 203, 1, 0, 0, 0, 984, 985, 5, 15, 0, 0, 985, 205, 1, 0, 0, 0, 986, 989,
    5, 18, 0, 0, 987, 989, 3, 208, 104, 0, 988, 986, 1, 0, 0, 0, 988, 987, 1, 0,
    0, 0, 989, 207, 1, 0, 0, 0, 990, 991, 5, 23, 0, 0, 991, 209, 1, 0, 0, 0,
    992, 993, 7, 13, 0, 0, 993, 211, 1, 0, 0, 0, 994, 995, 7, 14, 0, 0, 995,
    213, 1, 0, 0, 0, 109, 227, 231, 238, 246, 250, 252, 259, 267, 271, 273, 283,
    289, 293, 304, 308, 317, 321, 330, 334, 336, 345, 348, 351, 355, 363, 370,
    374, 378, 387, 395, 401, 406, 414, 420, 424, 434, 438, 442, 448, 451, 456,
    468, 476, 484, 493, 502, 509, 518, 525, 534, 543, 552, 561, 569, 575, 586,
    595, 602, 614, 621, 625, 633, 637, 647, 651, 661, 665, 667, 674, 689, 706,
    709, 719, 722, 732, 735, 741, 748, 756, 770, 776, 783, 795, 802, 814, 821,
    833, 838, 844, 852, 856, 862, 865, 869, 875, 881, 892, 899, 902, 909, 913,
    923, 930, 937, 941, 950, 954, 962, 988,
  ]

  private static __ATN: ATN
  public static get _ATN(): ATN {
    if (!FPlusParser.__ATN) {
      FPlusParser.__ATN = new ATNDeserializer().deserialize(
        FPlusParser._serializedATN,
      )
    }

    return FPlusParser.__ATN
  }

  static DecisionsToDFA = FPlusParser._ATN.decisionToState.map(
    (ds: DecisionState, index: number) => new DFA(ds, index),
  )
}

export class FunctionScriptContext extends ParserRuleContext {
  public _body!: ExpressionScriptContext
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public functionDefinition(): FunctionDefinitionContext {
    return this.getTypedRuleContext(
      FunctionDefinitionContext,
      0,
    ) as FunctionDefinitionContext
  }
  public ASSIGNMENT(): TerminalNode {
    return this.getToken(FPlusParser.ASSIGNMENT, 0)
  }
  public expressionScript(): ExpressionScriptContext {
    return this.getTypedRuleContext(
      ExpressionScriptContext,
      0,
    ) as ExpressionScriptContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_functionScript
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterFunctionScript) {
      listener.enterFunctionScript(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitFunctionScript) {
      listener.exitFunctionScript(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitFunctionScript) {
      return visitor.visitFunctionScript(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ExpressionScriptContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public EOF(): TerminalNode {
    return this.getToken(FPlusParser.EOF, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_expressionScript
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterExpressionScript) {
      listener.enterExpressionScript(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitExpressionScript) {
      listener.exitExpressionScript(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitExpressionScript) {
      return visitor.visitExpressionScript(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TypeParametersContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LANGLE(): TerminalNode {
    return this.getToken(FPlusParser.LANGLE, 0)
  }
  public typeParameter_list(): TypeParameterContext[] {
    return this.getTypedRuleContexts(
      TypeParameterContext,
    ) as TypeParameterContext[]
  }
  public typeParameter(i: number): TypeParameterContext {
    return this.getTypedRuleContext(
      TypeParameterContext,
      i,
    ) as TypeParameterContext
  }
  public RANGLE(): TerminalNode {
    return this.getToken(FPlusParser.RANGLE, 0)
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_typeParameters
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterTypeParameters) {
      listener.enterTypeParameters(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitTypeParameters) {
      listener.exitTypeParameters(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitTypeParameters) {
      return visitor.visitTypeParameters(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TypeParameterContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public simpleIdentifier(): SimpleIdentifierContext {
    return this.getTypedRuleContext(
      SimpleIdentifierContext,
      0,
    ) as SimpleIdentifierContext
  }
  public COLON(): TerminalNode {
    return this.getToken(FPlusParser.COLON, 0)
  }
  public type_(): TypeContext {
    return this.getTypedRuleContext(TypeContext, 0) as TypeContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_typeParameter
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterTypeParameter) {
      listener.enterTypeParameter(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitTypeParameter) {
      listener.exitTypeParameter(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitTypeParameter) {
      return visitor.visitTypeParameter(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class FunctionValueParametersContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public functionValueParameter_list(): FunctionValueParameterContext[] {
    return this.getTypedRuleContexts(
      FunctionValueParameterContext,
    ) as FunctionValueParameterContext[]
  }
  public functionValueParameter(i: number): FunctionValueParameterContext {
    return this.getTypedRuleContext(
      FunctionValueParameterContext,
      i,
    ) as FunctionValueParameterContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_functionValueParameters
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterFunctionValueParameters) {
      listener.enterFunctionValueParameters(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitFunctionValueParameters) {
      listener.exitFunctionValueParameters(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitFunctionValueParameters) {
      return visitor.visitFunctionValueParameters(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class FunctionValueParameterContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public parameter(): ParameterContext {
    return this.getTypedRuleContext(ParameterContext, 0) as ParameterContext
  }
  public ASSIGNMENT(): TerminalNode {
    return this.getToken(FPlusParser.ASSIGNMENT, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_functionValueParameter
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterFunctionValueParameter) {
      listener.enterFunctionValueParameter(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitFunctionValueParameter) {
      listener.exitFunctionValueParameter(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitFunctionValueParameter) {
      return visitor.visitFunctionValueParameter(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class FunctionValueParametersWithOptionalTypeContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public parameterWithOptionalType_list(): ParameterWithOptionalTypeContext[] {
    return this.getTypedRuleContexts(
      ParameterWithOptionalTypeContext,
    ) as ParameterWithOptionalTypeContext[]
  }
  public parameterWithOptionalType(
    i: number,
  ): ParameterWithOptionalTypeContext {
    return this.getTypedRuleContext(
      ParameterWithOptionalTypeContext,
      i,
    ) as ParameterWithOptionalTypeContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_functionValueParametersWithOptionalType
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterFunctionValueParametersWithOptionalType) {
      listener.enterFunctionValueParametersWithOptionalType(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitFunctionValueParametersWithOptionalType) {
      listener.exitFunctionValueParametersWithOptionalType(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitFunctionValueParametersWithOptionalType) {
      return visitor.visitFunctionValueParametersWithOptionalType(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class DeconstructuringDeclarationContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public simpleIdentifier_list(): SimpleIdentifierContext[] {
    return this.getTypedRuleContexts(
      SimpleIdentifierContext,
    ) as SimpleIdentifierContext[]
  }
  public simpleIdentifier(i: number): SimpleIdentifierContext {
    return this.getTypedRuleContext(
      SimpleIdentifierContext,
      i,
    ) as SimpleIdentifierContext
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_deconstructuringDeclaration
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterDeconstructuringDeclaration) {
      listener.enterDeconstructuringDeclaration(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitDeconstructuringDeclaration) {
      listener.exitDeconstructuringDeclaration(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitDeconstructuringDeclaration) {
      return visitor.visitDeconstructuringDeclaration(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class VariableDeclarationContext extends ParserRuleContext {
  public _id!: SimpleIdentifierContext
  public _tupleId!: DeconstructuringDeclarationContext
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public simpleIdentifier(): SimpleIdentifierContext {
    return this.getTypedRuleContext(
      SimpleIdentifierContext,
      0,
    ) as SimpleIdentifierContext
  }
  public deconstructuringDeclaration(): DeconstructuringDeclarationContext {
    return this.getTypedRuleContext(
      DeconstructuringDeclarationContext,
      0,
    ) as DeconstructuringDeclarationContext
  }
  public COLON(): TerminalNode {
    return this.getToken(FPlusParser.COLON, 0)
  }
  public type_(): TypeContext {
    return this.getTypedRuleContext(TypeContext, 0) as TypeContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_variableDeclaration
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterVariableDeclaration) {
      listener.enterVariableDeclaration(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitVariableDeclaration) {
      listener.exitVariableDeclaration(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitVariableDeclaration) {
      return visitor.visitVariableDeclaration(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class CommaOrSemicolonContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public COMMA(): TerminalNode {
    return this.getToken(FPlusParser.COMMA, 0)
  }
  public SEMICOLON(): TerminalNode {
    return this.getToken(FPlusParser.SEMICOLON, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_commaOrSemicolon
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterCommaOrSemicolon) {
      listener.enterCommaOrSemicolon(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitCommaOrSemicolon) {
      listener.exitCommaOrSemicolon(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitCommaOrSemicolon) {
      return visitor.visitCommaOrSemicolon(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class PropertyInitializerContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_propertyInitializer
  }
  public override copyFrom(ctx: PropertyInitializerContext): void {
    super.copyFrom(ctx)
  }
}
export class AssertDeclarationInitializerContext extends PropertyInitializerContext {
  constructor(parser: FPlusParser, ctx: PropertyInitializerContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public ASSERT(): TerminalNode {
    return this.getToken(FPlusParser.ASSERT, 0)
  }
  public assertInitializer_list(): AssertInitializerContext[] {
    return this.getTypedRuleContexts(
      AssertInitializerContext,
    ) as AssertInitializerContext[]
  }
  public assertInitializer(i: number): AssertInitializerContext {
    return this.getTypedRuleContext(
      AssertInitializerContext,
      i,
    ) as AssertInitializerContext
  }
  public SEMICOLON(): TerminalNode {
    return this.getToken(FPlusParser.SEMICOLON, 0)
  }
  public commaOrSemicolon_list(): CommaOrSemicolonContext[] {
    return this.getTypedRuleContexts(
      CommaOrSemicolonContext,
    ) as CommaOrSemicolonContext[]
  }
  public commaOrSemicolon(i: number): CommaOrSemicolonContext {
    return this.getTypedRuleContext(
      CommaOrSemicolonContext,
      i,
    ) as CommaOrSemicolonContext
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterAssertDeclarationInitializer) {
      listener.enterAssertDeclarationInitializer(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitAssertDeclarationInitializer) {
      listener.exitAssertDeclarationInitializer(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitAssertDeclarationInitializer) {
      return visitor.visitAssertDeclarationInitializer(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ImportDeclarationInitializerContext extends PropertyInitializerContext {
  constructor(parser: FPlusParser, ctx: PropertyInitializerContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public IMPORT(): TerminalNode {
    return this.getToken(FPlusParser.IMPORT, 0)
  }
  public importInitializer_list(): ImportInitializerContext[] {
    return this.getTypedRuleContexts(
      ImportInitializerContext,
    ) as ImportInitializerContext[]
  }
  public importInitializer(i: number): ImportInitializerContext {
    return this.getTypedRuleContext(
      ImportInitializerContext,
      i,
    ) as ImportInitializerContext
  }
  public SEMICOLON(): TerminalNode {
    return this.getToken(FPlusParser.SEMICOLON, 0)
  }
  public commaOrSemicolon_list(): CommaOrSemicolonContext[] {
    return this.getTypedRuleContexts(
      CommaOrSemicolonContext,
    ) as CommaOrSemicolonContext[]
  }
  public commaOrSemicolon(i: number): CommaOrSemicolonContext {
    return this.getTypedRuleContext(
      CommaOrSemicolonContext,
      i,
    ) as CommaOrSemicolonContext
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterImportDeclarationInitializer) {
      listener.enterImportDeclarationInitializer(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitImportDeclarationInitializer) {
      listener.exitImportDeclarationInitializer(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitImportDeclarationInitializer) {
      return visitor.visitImportDeclarationInitializer(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class LetDeclarationInitializerContext extends PropertyInitializerContext {
  constructor(parser: FPlusParser, ctx: PropertyInitializerContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LET(): TerminalNode {
    return this.getToken(FPlusParser.LET, 0)
  }
  public letInitializer_list(): LetInitializerContext[] {
    return this.getTypedRuleContexts(
      LetInitializerContext,
    ) as LetInitializerContext[]
  }
  public letInitializer(i: number): LetInitializerContext {
    return this.getTypedRuleContext(
      LetInitializerContext,
      i,
    ) as LetInitializerContext
  }
  public SEMICOLON(): TerminalNode {
    return this.getToken(FPlusParser.SEMICOLON, 0)
  }
  public commaOrSemicolon_list(): CommaOrSemicolonContext[] {
    return this.getTypedRuleContexts(
      CommaOrSemicolonContext,
    ) as CommaOrSemicolonContext[]
  }
  public commaOrSemicolon(i: number): CommaOrSemicolonContext {
    return this.getTypedRuleContext(
      CommaOrSemicolonContext,
      i,
    ) as CommaOrSemicolonContext
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterLetDeclarationInitializer) {
      listener.enterLetDeclarationInitializer(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitLetDeclarationInitializer) {
      listener.exitLetDeclarationInitializer(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitLetDeclarationInitializer) {
      return visitor.visitLetDeclarationInitializer(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class AssertInitializerContext extends ParserRuleContext {
  public _cond!: ExpressionContext
  public _error!: ExpressionContext
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public expression_list(): ExpressionContext[] {
    return this.getTypedRuleContexts(ExpressionContext) as ExpressionContext[]
  }
  public expression(i: number): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, i) as ExpressionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_assertInitializer
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterAssertInitializer) {
      listener.enterAssertInitializer(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitAssertInitializer) {
      listener.exitAssertInitializer(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitAssertInitializer) {
      return visitor.visitAssertInitializer(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ImportInitializerContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public simpleIdentifier(): SimpleIdentifierContext {
    return this.getTypedRuleContext(
      SimpleIdentifierContext,
      0,
    ) as SimpleIdentifierContext
  }
  public navigationSuffix(): NavigationSuffixContext {
    return this.getTypedRuleContext(
      NavigationSuffixContext,
      0,
    ) as NavigationSuffixContext
  }
  public valueArguments(): ValueArgumentsContext {
    return this.getTypedRuleContext(
      ValueArgumentsContext,
      0,
    ) as ValueArgumentsContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_importInitializer
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterImportInitializer) {
      listener.enterImportInitializer(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitImportInitializer) {
      listener.exitImportInitializer(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitImportInitializer) {
      return visitor.visitImportInitializer(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LetInitializerContext extends ParserRuleContext {
  public _body!: ExpressionContext
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public variableDeclaration(): VariableDeclarationContext {
    return this.getTypedRuleContext(
      VariableDeclarationContext,
      0,
    ) as VariableDeclarationContext
  }
  public functionDefinition(): FunctionDefinitionContext {
    return this.getTypedRuleContext(
      FunctionDefinitionContext,
      0,
    ) as FunctionDefinitionContext
  }
  public ASSIGNMENT(): TerminalNode {
    return this.getToken(FPlusParser.ASSIGNMENT, 0)
  }
  public VAR(): TerminalNode {
    return this.getToken(FPlusParser.VAR, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_letInitializer
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterLetInitializer) {
      listener.enterLetInitializer(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitLetInitializer) {
      listener.exitLetInitializer(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitLetInitializer) {
      return visitor.visitLetInitializer(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class PropertyDeclarationContext extends ParserRuleContext {
  public _in_!: ExpressionContext
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public IN(): TerminalNode {
    return this.getToken(FPlusParser.IN, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public propertyInitializer_list(): PropertyInitializerContext[] {
    return this.getTypedRuleContexts(
      PropertyInitializerContext,
    ) as PropertyInitializerContext[]
  }
  public propertyInitializer(i: number): PropertyInitializerContext {
    return this.getTypedRuleContext(
      PropertyInitializerContext,
      i,
    ) as PropertyInitializerContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_propertyDeclaration
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterPropertyDeclaration) {
      listener.enterPropertyDeclaration(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitPropertyDeclaration) {
      listener.exitPropertyDeclaration(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitPropertyDeclaration) {
      return visitor.visitPropertyDeclaration(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ParameterWithOptionalTypeContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public simpleIdentifier(): SimpleIdentifierContext {
    return this.getTypedRuleContext(
      SimpleIdentifierContext,
      0,
    ) as SimpleIdentifierContext
  }
  public EXCL(): TerminalNode {
    return this.getToken(FPlusParser.EXCL, 0)
  }
  public COLON(): TerminalNode {
    return this.getToken(FPlusParser.COLON, 0)
  }
  public type_(): TypeContext {
    return this.getTypedRuleContext(TypeContext, 0) as TypeContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_parameterWithOptionalType
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterParameterWithOptionalType) {
      listener.enterParameterWithOptionalType(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitParameterWithOptionalType) {
      listener.exitParameterWithOptionalType(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitParameterWithOptionalType) {
      return visitor.visitParameterWithOptionalType(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ParameterContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public simpleIdentifier(): SimpleIdentifierContext {
    return this.getTypedRuleContext(
      SimpleIdentifierContext,
      0,
    ) as SimpleIdentifierContext
  }
  public COLON(): TerminalNode {
    return this.getToken(FPlusParser.COLON, 0)
  }
  public type_(): TypeContext {
    return this.getTypedRuleContext(TypeContext, 0) as TypeContext
  }
  public EXCL(): TerminalNode {
    return this.getToken(FPlusParser.EXCL, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_parameter
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterParameter) {
      listener.enterParameter(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitParameter) {
      listener.exitParameter(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitParameter) {
      return visitor.visitParameter(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TypeContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public parenthesizedType(): ParenthesizedTypeContext {
    return this.getTypedRuleContext(
      ParenthesizedTypeContext,
      0,
    ) as ParenthesizedTypeContext
  }
  public userType(): UserTypeContext {
    return this.getTypedRuleContext(UserTypeContext, 0) as UserTypeContext
  }
  public functionType(): FunctionTypeContext {
    return this.getTypedRuleContext(
      FunctionTypeContext,
      0,
    ) as FunctionTypeContext
  }
  public tupleType(): TupleTypeContext {
    return this.getTypedRuleContext(TupleTypeContext, 0) as TupleTypeContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_type
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterType) {
      listener.enterType(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitType) {
      listener.exitType(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitType) {
      return visitor.visitType(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TupleTypeContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public type__list(): TypeContext[] {
    return this.getTypedRuleContexts(TypeContext) as TypeContext[]
  }
  public type_(i: number): TypeContext {
    return this.getTypedRuleContext(TypeContext, i) as TypeContext
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_tupleType
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterTupleType) {
      listener.enterTupleType(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitTupleType) {
      listener.exitTupleType(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitTupleType) {
      return visitor.visitTupleType(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class UserTypeContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public simpleIdentifier(): SimpleIdentifierContext {
    return this.getTypedRuleContext(
      SimpleIdentifierContext,
      0,
    ) as SimpleIdentifierContext
  }
  public typeArguments(): TypeArgumentsContext {
    return this.getTypedRuleContext(
      TypeArgumentsContext,
      0,
    ) as TypeArgumentsContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_userType
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterUserType) {
      listener.enterUserType(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitUserType) {
      listener.exitUserType(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitUserType) {
      return visitor.visitUserType(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class FunctionTypeContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public functionTypeParameters(): FunctionTypeParametersContext {
    return this.getTypedRuleContext(
      FunctionTypeParametersContext,
      0,
    ) as FunctionTypeParametersContext
  }
  public ARROW(): TerminalNode {
    return this.getToken(FPlusParser.ARROW, 0)
  }
  public type_(): TypeContext {
    return this.getTypedRuleContext(TypeContext, 0) as TypeContext
  }
  public receiverType(): ReceiverTypeContext {
    return this.getTypedRuleContext(
      ReceiverTypeContext,
      0,
    ) as ReceiverTypeContext
  }
  public DOT(): TerminalNode {
    return this.getToken(FPlusParser.DOT, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_functionType
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterFunctionType) {
      listener.enterFunctionType(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitFunctionType) {
      listener.exitFunctionType(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitFunctionType) {
      return visitor.visitFunctionType(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class FunctionTypeParametersContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public type__list(): TypeContext[] {
    return this.getTypedRuleContexts(TypeContext) as TypeContext[]
  }
  public type_(i: number): TypeContext {
    return this.getTypedRuleContext(TypeContext, i) as TypeContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_functionTypeParameters
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterFunctionTypeParameters) {
      listener.enterFunctionTypeParameters(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitFunctionTypeParameters) {
      listener.exitFunctionTypeParameters(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitFunctionTypeParameters) {
      return visitor.visitFunctionTypeParameters(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ParenthesizedTypeContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public type_(): TypeContext {
    return this.getTypedRuleContext(TypeContext, 0) as TypeContext
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_parenthesizedType
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterParenthesizedType) {
      listener.enterParenthesizedType(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitParenthesizedType) {
      listener.exitParenthesizedType(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitParenthesizedType) {
      return visitor.visitParenthesizedType(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ReceiverTypeContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public parenthesizedType(): ParenthesizedTypeContext {
    return this.getTypedRuleContext(
      ParenthesizedTypeContext,
      0,
    ) as ParenthesizedTypeContext
  }
  public userType(): UserTypeContext {
    return this.getTypedRuleContext(UserTypeContext, 0) as UserTypeContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_receiverType
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterReceiverType) {
      listener.enterReceiverType(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitReceiverType) {
      listener.exitReceiverType(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitReceiverType) {
      return visitor.visitReceiverType(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class SemiContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public SEMICOLON(): TerminalNode {
    return this.getToken(FPlusParser.SEMICOLON, 0)
  }
  public NL(): TerminalNode {
    return this.getToken(FPlusParser.NL, 0)
  }
  public EOF(): TerminalNode {
    return this.getToken(FPlusParser.EOF, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_semi
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterSemi) {
      listener.enterSemi(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitSemi) {
      listener.exitSemi(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitSemi) {
      return visitor.visitSemi(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public functionLiteral(): FunctionLiteralContext {
    return this.getTypedRuleContext(
      FunctionLiteralContext,
      0,
    ) as FunctionLiteralContext
  }
  public expressionWithoutFunctionLiteral(): ExpressionWithoutFunctionLiteralContext {
    return this.getTypedRuleContext(
      ExpressionWithoutFunctionLiteralContext,
      0,
    ) as ExpressionWithoutFunctionLiteralContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_expression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterExpression) {
      listener.enterExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitExpression) {
      listener.exitExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitExpression) {
      return visitor.visitExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ExpressionWithoutFunctionLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public propertyDeclaration(): PropertyDeclarationContext {
    return this.getTypedRuleContext(
      PropertyDeclarationContext,
      0,
    ) as PropertyDeclarationContext
  }
  public ifExpression(): IfExpressionContext {
    return this.getTypedRuleContext(
      IfExpressionContext,
      0,
    ) as IfExpressionContext
  }
  public whenExpression(): WhenExpressionContext {
    return this.getTypedRuleContext(
      WhenExpressionContext,
      0,
    ) as WhenExpressionContext
  }
  public disjunction(): DisjunctionContext {
    return this.getTypedRuleContext(DisjunctionContext, 0) as DisjunctionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_expressionWithoutFunctionLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterExpressionWithoutFunctionLiteral) {
      listener.enterExpressionWithoutFunctionLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitExpressionWithoutFunctionLiteral) {
      listener.exitExpressionWithoutFunctionLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitExpressionWithoutFunctionLiteral) {
      return visitor.visitExpressionWithoutFunctionLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class FunctionDefinitionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public simpleIdentifier(): SimpleIdentifierContext {
    return this.getTypedRuleContext(
      SimpleIdentifierContext,
      0,
    ) as SimpleIdentifierContext
  }
  public functionValueParameters(): FunctionValueParametersContext {
    return this.getTypedRuleContext(
      FunctionValueParametersContext,
      0,
    ) as FunctionValueParametersContext
  }
  public COLON(): TerminalNode {
    return this.getToken(FPlusParser.COLON, 0)
  }
  public type_(): TypeContext {
    return this.getTypedRuleContext(TypeContext, 0) as TypeContext
  }
  public typeParameters(): TypeParametersContext {
    return this.getTypedRuleContext(
      TypeParametersContext,
      0,
    ) as TypeParametersContext
  }
  public receiverType(): ReceiverTypeContext {
    return this.getTypedRuleContext(
      ReceiverTypeContext,
      0,
    ) as ReceiverTypeContext
  }
  public DOT(): TerminalNode {
    return this.getToken(FPlusParser.DOT, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_functionDefinition
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterFunctionDefinition) {
      listener.enterFunctionDefinition(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitFunctionDefinition) {
      listener.exitFunctionDefinition(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitFunctionDefinition) {
      return visitor.visitFunctionDefinition(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class DisjunctionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public conjunction_list(): ConjunctionContext[] {
    return this.getTypedRuleContexts(ConjunctionContext) as ConjunctionContext[]
  }
  public conjunction(i: number): ConjunctionContext {
    return this.getTypedRuleContext(ConjunctionContext, i) as ConjunctionContext
  }
  public DISJ_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.DISJ)
  }
  public DISJ(i: number): TerminalNode {
    return this.getToken(FPlusParser.DISJ, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_disjunction
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterDisjunction) {
      listener.enterDisjunction(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitDisjunction) {
      listener.exitDisjunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitDisjunction) {
      return visitor.visitDisjunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ConjunctionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public xor_list(): XorContext[] {
    return this.getTypedRuleContexts(XorContext) as XorContext[]
  }
  public xor(i: number): XorContext {
    return this.getTypedRuleContext(XorContext, i) as XorContext
  }
  public CONJ_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.CONJ)
  }
  public CONJ(i: number): TerminalNode {
    return this.getToken(FPlusParser.CONJ, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_conjunction
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterConjunction) {
      listener.enterConjunction(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitConjunction) {
      listener.exitConjunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitConjunction) {
      return visitor.visitConjunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class XorContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public equality_list(): EqualityContext[] {
    return this.getTypedRuleContexts(EqualityContext) as EqualityContext[]
  }
  public equality(i: number): EqualityContext {
    return this.getTypedRuleContext(EqualityContext, i) as EqualityContext
  }
  public XOR_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.XOR)
  }
  public XOR(i: number): TerminalNode {
    return this.getToken(FPlusParser.XOR, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_xor
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterXor) {
      listener.enterXor(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitXor) {
      listener.exitXor(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitXor) {
      return visitor.visitXor(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class EqualityContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public comparison_list(): ComparisonContext[] {
    return this.getTypedRuleContexts(ComparisonContext) as ComparisonContext[]
  }
  public comparison(i: number): ComparisonContext {
    return this.getTypedRuleContext(ComparisonContext, i) as ComparisonContext
  }
  public equalityOperator_list(): EqualityOperatorContext[] {
    return this.getTypedRuleContexts(
      EqualityOperatorContext,
    ) as EqualityOperatorContext[]
  }
  public equalityOperator(i: number): EqualityOperatorContext {
    return this.getTypedRuleContext(
      EqualityOperatorContext,
      i,
    ) as EqualityOperatorContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_equality
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterEquality) {
      listener.enterEquality(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitEquality) {
      listener.exitEquality(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitEquality) {
      return visitor.visitEquality(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ComparisonContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public infixOperation_list(): InfixOperationContext[] {
    return this.getTypedRuleContexts(
      InfixOperationContext,
    ) as InfixOperationContext[]
  }
  public infixOperation(i: number): InfixOperationContext {
    return this.getTypedRuleContext(
      InfixOperationContext,
      i,
    ) as InfixOperationContext
  }
  public comparisonOperator_list(): ComparisonOperatorContext[] {
    return this.getTypedRuleContexts(
      ComparisonOperatorContext,
    ) as ComparisonOperatorContext[]
  }
  public comparisonOperator(i: number): ComparisonOperatorContext {
    return this.getTypedRuleContext(
      ComparisonOperatorContext,
      i,
    ) as ComparisonOperatorContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_comparison
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterComparison) {
      listener.enterComparison(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitComparison) {
      listener.exitComparison(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitComparison) {
      return visitor.visitComparison(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class InfixOperationContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public elvisExpression(): ElvisExpressionContext {
    return this.getTypedRuleContext(
      ElvisExpressionContext,
      0,
    ) as ElvisExpressionContext
  }
  public infixOperationEntry_list(): InfixOperationEntryContext[] {
    return this.getTypedRuleContexts(
      InfixOperationEntryContext,
    ) as InfixOperationEntryContext[]
  }
  public infixOperationEntry(i: number): InfixOperationEntryContext {
    return this.getTypedRuleContext(
      InfixOperationEntryContext,
      i,
    ) as InfixOperationEntryContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_infixOperation
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterInfixOperation) {
      listener.enterInfixOperation(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitInfixOperation) {
      listener.exitInfixOperation(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitInfixOperation) {
      return visitor.visitInfixOperation(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class InfixOperationEntryContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public inOperator(): InOperatorContext {
    return this.getTypedRuleContext(InOperatorContext, 0) as InOperatorContext
  }
  public elvisExpression(): ElvisExpressionContext {
    return this.getTypedRuleContext(
      ElvisExpressionContext,
      0,
    ) as ElvisExpressionContext
  }
  public isOperator(): IsOperatorContext {
    return this.getTypedRuleContext(IsOperatorContext, 0) as IsOperatorContext
  }
  public type_(): TypeContext {
    return this.getTypedRuleContext(TypeContext, 0) as TypeContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_infixOperationEntry
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterInfixOperationEntry) {
      listener.enterInfixOperationEntry(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitInfixOperationEntry) {
      listener.exitInfixOperationEntry(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitInfixOperationEntry) {
      return visitor.visitInfixOperationEntry(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ElvisExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public infixFunctionCall_list(): InfixFunctionCallContext[] {
    return this.getTypedRuleContexts(
      InfixFunctionCallContext,
    ) as InfixFunctionCallContext[]
  }
  public infixFunctionCall(i: number): InfixFunctionCallContext {
    return this.getTypedRuleContext(
      InfixFunctionCallContext,
      i,
    ) as InfixFunctionCallContext
  }
  public QUEST_COLON_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.QUEST_COLON)
  }
  public QUEST_COLON(i: number): TerminalNode {
    return this.getToken(FPlusParser.QUEST_COLON, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_elvisExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterElvisExpression) {
      listener.enterElvisExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitElvisExpression) {
      listener.exitElvisExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitElvisExpression) {
      return visitor.visitElvisExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class InfixFunctionCallContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public additiveExpression_list(): AdditiveExpressionContext[] {
    return this.getTypedRuleContexts(
      AdditiveExpressionContext,
    ) as AdditiveExpressionContext[]
  }
  public additiveExpression(i: number): AdditiveExpressionContext {
    return this.getTypedRuleContext(
      AdditiveExpressionContext,
      i,
    ) as AdditiveExpressionContext
  }
  public simpleIdentifier_list(): SimpleIdentifierContext[] {
    return this.getTypedRuleContexts(
      SimpleIdentifierContext,
    ) as SimpleIdentifierContext[]
  }
  public simpleIdentifier(i: number): SimpleIdentifierContext {
    return this.getTypedRuleContext(
      SimpleIdentifierContext,
      i,
    ) as SimpleIdentifierContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_infixFunctionCall
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterInfixFunctionCall) {
      listener.enterInfixFunctionCall(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitInfixFunctionCall) {
      listener.exitInfixFunctionCall(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitInfixFunctionCall) {
      return visitor.visitInfixFunctionCall(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class AdditiveExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public multiplicativeExpression_list(): MultiplicativeExpressionContext[] {
    return this.getTypedRuleContexts(
      MultiplicativeExpressionContext,
    ) as MultiplicativeExpressionContext[]
  }
  public multiplicativeExpression(i: number): MultiplicativeExpressionContext {
    return this.getTypedRuleContext(
      MultiplicativeExpressionContext,
      i,
    ) as MultiplicativeExpressionContext
  }
  public additiveOperator_list(): AdditiveOperatorContext[] {
    return this.getTypedRuleContexts(
      AdditiveOperatorContext,
    ) as AdditiveOperatorContext[]
  }
  public additiveOperator(i: number): AdditiveOperatorContext {
    return this.getTypedRuleContext(
      AdditiveOperatorContext,
      i,
    ) as AdditiveOperatorContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_additiveExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterAdditiveExpression) {
      listener.enterAdditiveExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitAdditiveExpression) {
      listener.exitAdditiveExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitAdditiveExpression) {
      return visitor.visitAdditiveExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class MultiplicativeExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public powerExpression_list(): PowerExpressionContext[] {
    return this.getTypedRuleContexts(
      PowerExpressionContext,
    ) as PowerExpressionContext[]
  }
  public powerExpression(i: number): PowerExpressionContext {
    return this.getTypedRuleContext(
      PowerExpressionContext,
      i,
    ) as PowerExpressionContext
  }
  public multiplicativeOperator_list(): MultiplicativeOperatorContext[] {
    return this.getTypedRuleContexts(
      MultiplicativeOperatorContext,
    ) as MultiplicativeOperatorContext[]
  }
  public multiplicativeOperator(i: number): MultiplicativeOperatorContext {
    return this.getTypedRuleContext(
      MultiplicativeOperatorContext,
      i,
    ) as MultiplicativeOperatorContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_multiplicativeExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterMultiplicativeExpression) {
      listener.enterMultiplicativeExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitMultiplicativeExpression) {
      listener.exitMultiplicativeExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitMultiplicativeExpression) {
      return visitor.visitMultiplicativeExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class PowerExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public asExpression_list(): AsExpressionContext[] {
    return this.getTypedRuleContexts(
      AsExpressionContext,
    ) as AsExpressionContext[]
  }
  public asExpression(i: number): AsExpressionContext {
    return this.getTypedRuleContext(
      AsExpressionContext,
      i,
    ) as AsExpressionContext
  }
  public powerOperator_list(): PowerOperatorContext[] {
    return this.getTypedRuleContexts(
      PowerOperatorContext,
    ) as PowerOperatorContext[]
  }
  public powerOperator(i: number): PowerOperatorContext {
    return this.getTypedRuleContext(
      PowerOperatorContext,
      i,
    ) as PowerOperatorContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_powerExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterPowerExpression) {
      listener.enterPowerExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitPowerExpression) {
      listener.exitPowerExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitPowerExpression) {
      return visitor.visitPowerExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class AsExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public prefixUnaryExpression(): PrefixUnaryExpressionContext {
    return this.getTypedRuleContext(
      PrefixUnaryExpressionContext,
      0,
    ) as PrefixUnaryExpressionContext
  }
  public AS_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.AS)
  }
  public AS(i: number): TerminalNode {
    return this.getToken(FPlusParser.AS, i)
  }
  public type__list(): TypeContext[] {
    return this.getTypedRuleContexts(TypeContext) as TypeContext[]
  }
  public type_(i: number): TypeContext {
    return this.getTypedRuleContext(TypeContext, i) as TypeContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_asExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterAsExpression) {
      listener.enterAsExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitAsExpression) {
      listener.exitAsExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitAsExpression) {
      return visitor.visitAsExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class PrefixUnaryExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public postfixUnaryExpression(): PostfixUnaryExpressionContext {
    return this.getTypedRuleContext(
      PostfixUnaryExpressionContext,
      0,
    ) as PostfixUnaryExpressionContext
  }
  public unaryPrefix_list(): UnaryPrefixContext[] {
    return this.getTypedRuleContexts(UnaryPrefixContext) as UnaryPrefixContext[]
  }
  public unaryPrefix(i: number): UnaryPrefixContext {
    return this.getTypedRuleContext(UnaryPrefixContext, i) as UnaryPrefixContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_prefixUnaryExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterPrefixUnaryExpression) {
      listener.enterPrefixUnaryExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitPrefixUnaryExpression) {
      listener.exitPrefixUnaryExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitPrefixUnaryExpression) {
      return visitor.visitPrefixUnaryExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class UnaryPrefixContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public prefixUnaryOperator(): PrefixUnaryOperatorContext {
    return this.getTypedRuleContext(
      PrefixUnaryOperatorContext,
      0,
    ) as PrefixUnaryOperatorContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_unaryPrefix
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterUnaryPrefix) {
      listener.enterUnaryPrefix(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitUnaryPrefix) {
      listener.exitUnaryPrefix(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitUnaryPrefix) {
      return visitor.visitUnaryPrefix(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class PostfixUnaryExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public primaryExpression(): PrimaryExpressionContext {
    return this.getTypedRuleContext(
      PrimaryExpressionContext,
      0,
    ) as PrimaryExpressionContext
  }
  public postfixUnarySuffix_list(): PostfixUnarySuffixContext[] {
    return this.getTypedRuleContexts(
      PostfixUnarySuffixContext,
    ) as PostfixUnarySuffixContext[]
  }
  public postfixUnarySuffix(i: number): PostfixUnarySuffixContext {
    return this.getTypedRuleContext(
      PostfixUnarySuffixContext,
      i,
    ) as PostfixUnarySuffixContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_postfixUnaryExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterPostfixUnaryExpression) {
      listener.enterPostfixUnaryExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitPostfixUnaryExpression) {
      listener.exitPostfixUnaryExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitPostfixUnaryExpression) {
      return visitor.visitPostfixUnaryExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class PostfixUnarySuffixContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public callSuffix(): CallSuffixContext {
    return this.getTypedRuleContext(CallSuffixContext, 0) as CallSuffixContext
  }
  public indexingSuffix(): IndexingSuffixContext {
    return this.getTypedRuleContext(
      IndexingSuffixContext,
      0,
    ) as IndexingSuffixContext
  }
  public navigationSuffix(): NavigationSuffixContext {
    return this.getTypedRuleContext(
      NavigationSuffixContext,
      0,
    ) as NavigationSuffixContext
  }
  public percentOperator(): PercentOperatorContext {
    return this.getTypedRuleContext(
      PercentOperatorContext,
      0,
    ) as PercentOperatorContext
  }
  public notUndefinedAssertion(): NotUndefinedAssertionContext {
    return this.getTypedRuleContext(
      NotUndefinedAssertionContext,
      0,
    ) as NotUndefinedAssertionContext
  }
  public isDefinedSuffix(): IsDefinedSuffixContext {
    return this.getTypedRuleContext(
      IsDefinedSuffixContext,
      0,
    ) as IsDefinedSuffixContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_postfixUnarySuffix
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterPostfixUnarySuffix) {
      listener.enterPostfixUnarySuffix(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitPostfixUnarySuffix) {
      listener.exitPostfixUnarySuffix(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitPostfixUnarySuffix) {
      return visitor.visitPostfixUnarySuffix(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class IsDefinedSuffixContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public QUEST(): TerminalNode {
    return this.getToken(FPlusParser.QUEST, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_isDefinedSuffix
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterIsDefinedSuffix) {
      listener.enterIsDefinedSuffix(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitIsDefinedSuffix) {
      listener.exitIsDefinedSuffix(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitIsDefinedSuffix) {
      return visitor.visitIsDefinedSuffix(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class IndexingSuffixContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LSQUARE(): TerminalNode {
    return this.getToken(FPlusParser.LSQUARE, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public RSQUARE(): TerminalNode {
    return this.getToken(FPlusParser.RSQUARE, 0)
  }
  public COMMA(): TerminalNode {
    return this.getToken(FPlusParser.COMMA, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_indexingSuffix
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterIndexingSuffix) {
      listener.enterIndexingSuffix(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitIndexingSuffix) {
      listener.exitIndexingSuffix(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitIndexingSuffix) {
      return visitor.visitIndexingSuffix(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class NotUndefinedAssertionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public EXCL(): TerminalNode {
    return this.getToken(FPlusParser.EXCL, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_notUndefinedAssertion
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterNotUndefinedAssertion) {
      listener.enterNotUndefinedAssertion(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitNotUndefinedAssertion) {
      listener.exitNotUndefinedAssertion(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitNotUndefinedAssertion) {
      return visitor.visitNotUndefinedAssertion(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class PercentOperatorContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public PERCENT(): TerminalNode {
    return this.getToken(FPlusParser.PERCENT, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_percentOperator
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterPercentOperator) {
      listener.enterPercentOperator(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitPercentOperator) {
      listener.exitPercentOperator(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitPercentOperator) {
      return visitor.visitPercentOperator(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class NavigationSuffixContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public DOT(): TerminalNode {
    return this.getToken(FPlusParser.DOT, 0)
  }
  public navigationIdentifier(): NavigationIdentifierContext {
    return this.getTypedRuleContext(
      NavigationIdentifierContext,
      0,
    ) as NavigationIdentifierContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_navigationSuffix
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterNavigationSuffix) {
      listener.enterNavigationSuffix(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitNavigationSuffix) {
      listener.exitNavigationSuffix(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitNavigationSuffix) {
      return visitor.visitNavigationSuffix(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class CallSuffixContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public valueArguments(): ValueArgumentsContext {
    return this.getTypedRuleContext(
      ValueArgumentsContext,
      0,
    ) as ValueArgumentsContext
  }
  public typeArgumentsWithoutVariance(): TypeArgumentsWithoutVarianceContext {
    return this.getTypedRuleContext(
      TypeArgumentsWithoutVarianceContext,
      0,
    ) as TypeArgumentsWithoutVarianceContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_callSuffix
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterCallSuffix) {
      listener.enterCallSuffix(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitCallSuffix) {
      listener.exitCallSuffix(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitCallSuffix) {
      return visitor.visitCallSuffix(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class VarianceContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public OUT(): TerminalNode {
    return this.getToken(FPlusParser.OUT, 0)
  }
  public IN(): TerminalNode {
    return this.getToken(FPlusParser.IN, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_variance
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterVariance) {
      listener.enterVariance(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitVariance) {
      listener.exitVariance(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitVariance) {
      return visitor.visitVariance(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class VarianceTypeContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public type_(): TypeContext {
    return this.getTypedRuleContext(TypeContext, 0) as TypeContext
  }
  public variance(): VarianceContext {
    return this.getTypedRuleContext(VarianceContext, 0) as VarianceContext
  }
  public MULT(): TerminalNode {
    return this.getToken(FPlusParser.MULT, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_varianceType
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterVarianceType) {
      listener.enterVarianceType(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitVarianceType) {
      listener.exitVarianceType(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitVarianceType) {
      return visitor.visitVarianceType(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TypeArgumentsContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LANGLE(): TerminalNode {
    return this.getToken(FPlusParser.LANGLE, 0)
  }
  public varianceType_list(): VarianceTypeContext[] {
    return this.getTypedRuleContexts(
      VarianceTypeContext,
    ) as VarianceTypeContext[]
  }
  public varianceType(i: number): VarianceTypeContext {
    return this.getTypedRuleContext(
      VarianceTypeContext,
      i,
    ) as VarianceTypeContext
  }
  public RANGLE(): TerminalNode {
    return this.getToken(FPlusParser.RANGLE, 0)
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_typeArguments
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterTypeArguments) {
      listener.enterTypeArguments(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitTypeArguments) {
      listener.exitTypeArguments(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitTypeArguments) {
      return visitor.visitTypeArguments(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TypeArgumentsWithoutVarianceContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LANGLE(): TerminalNode {
    return this.getToken(FPlusParser.LANGLE, 0)
  }
  public type__list(): TypeContext[] {
    return this.getTypedRuleContexts(TypeContext) as TypeContext[]
  }
  public type_(i: number): TypeContext {
    return this.getTypedRuleContext(TypeContext, i) as TypeContext
  }
  public RANGLE(): TerminalNode {
    return this.getToken(FPlusParser.RANGLE, 0)
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_typeArgumentsWithoutVariance
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterTypeArgumentsWithoutVariance) {
      listener.enterTypeArgumentsWithoutVariance(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitTypeArgumentsWithoutVariance) {
      listener.exitTypeArgumentsWithoutVariance(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitTypeArgumentsWithoutVariance) {
      return visitor.visitTypeArgumentsWithoutVariance(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ValueArgumentsContext extends ParserRuleContext {
  public _endingComma!: Token
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public valueArgument_list(): ValueArgumentContext[] {
    return this.getTypedRuleContexts(
      ValueArgumentContext,
    ) as ValueArgumentContext[]
  }
  public valueArgument(i: number): ValueArgumentContext {
    return this.getTypedRuleContext(
      ValueArgumentContext,
      i,
    ) as ValueArgumentContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_valueArguments
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterValueArguments) {
      listener.enterValueArguments(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitValueArguments) {
      listener.exitValueArguments(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitValueArguments) {
      return visitor.visitValueArguments(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ValueArgumentContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public simpleIdentifier(): SimpleIdentifierContext {
    return this.getTypedRuleContext(
      SimpleIdentifierContext,
      0,
    ) as SimpleIdentifierContext
  }
  public ASSIGNMENT(): TerminalNode {
    return this.getToken(FPlusParser.ASSIGNMENT, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_valueArgument
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterValueArgument) {
      listener.enterValueArgument(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitValueArgument) {
      listener.exitValueArgument(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitValueArgument) {
      return visitor.visitValueArgument(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class PrimaryExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public parenthesizedExpression(): ParenthesizedExpressionContext {
    return this.getTypedRuleContext(
      ParenthesizedExpressionContext,
      0,
    ) as ParenthesizedExpressionContext
  }
  public simpleIdentifier(): SimpleIdentifierContext {
    return this.getTypedRuleContext(
      SimpleIdentifierContext,
      0,
    ) as SimpleIdentifierContext
  }
  public literalConstant(): LiteralConstantContext {
    return this.getTypedRuleContext(
      LiteralConstantContext,
      0,
    ) as LiteralConstantContext
  }
  public stringLiteral(): StringLiteralContext {
    return this.getTypedRuleContext(
      StringLiteralContext,
      0,
    ) as StringLiteralContext
  }
  public listLiteral(): ListLiteralContext {
    return this.getTypedRuleContext(ListLiteralContext, 0) as ListLiteralContext
  }
  public setLiteral(): SetLiteralContext {
    return this.getTypedRuleContext(SetLiteralContext, 0) as SetLiteralContext
  }
  public mapLiteral(): MapLiteralContext {
    return this.getTypedRuleContext(MapLiteralContext, 0) as MapLiteralContext
  }
  public rangeLiteral(): RangeLiteralContext {
    return this.getTypedRuleContext(
      RangeLiteralContext,
      0,
    ) as RangeLiteralContext
  }
  public tupleLiteral(): TupleLiteralContext {
    return this.getTypedRuleContext(
      TupleLiteralContext,
      0,
    ) as TupleLiteralContext
  }
  public implicitVariableLiteral(): ImplicitVariableLiteralContext {
    return this.getTypedRuleContext(
      ImplicitVariableLiteralContext,
      0,
    ) as ImplicitVariableLiteralContext
  }
  public implicitNavigation(): ImplicitNavigationContext {
    return this.getTypedRuleContext(
      ImplicitNavigationContext,
      0,
    ) as ImplicitNavigationContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_primaryExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterPrimaryExpression) {
      listener.enterPrimaryExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitPrimaryExpression) {
      listener.exitPrimaryExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitPrimaryExpression) {
      return visitor.visitPrimaryExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ParenthesizedExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_parenthesizedExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterParenthesizedExpression) {
      listener.enterParenthesizedExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitParenthesizedExpression) {
      listener.exitParenthesizedExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitParenthesizedExpression) {
      return visitor.visitParenthesizedExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class MapPairContext extends ParserRuleContext {
  public _key!: ExpressionContext
  public _value!: ExpressionContext
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public COLON(): TerminalNode {
    return this.getToken(FPlusParser.COLON, 0)
  }
  public expression_list(): ExpressionContext[] {
    return this.getTypedRuleContexts(ExpressionContext) as ExpressionContext[]
  }
  public expression(i: number): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, i) as ExpressionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_mapPair
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterMapPair) {
      listener.enterMapPair(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitMapPair) {
      listener.exitMapPair(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitMapPair) {
      return visitor.visitMapPair(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class MapLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public MAP(): TerminalNode {
    return this.getToken(FPlusParser.MAP, 0)
  }
  public LCURL(): TerminalNode {
    return this.getToken(FPlusParser.LCURL, 0)
  }
  public RCURL(): TerminalNode {
    return this.getToken(FPlusParser.RCURL, 0)
  }
  public mapPair_list(): MapPairContext[] {
    return this.getTypedRuleContexts(MapPairContext) as MapPairContext[]
  }
  public mapPair(i: number): MapPairContext {
    return this.getTypedRuleContext(MapPairContext, i) as MapPairContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_mapLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterMapLiteral) {
      listener.enterMapLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitMapLiteral) {
      listener.exitMapLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitMapLiteral) {
      return visitor.visitMapLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class SetLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LCURL(): TerminalNode {
    return this.getToken(FPlusParser.LCURL, 0)
  }
  public RCURL(): TerminalNode {
    return this.getToken(FPlusParser.RCURL, 0)
  }
  public expression_list(): ExpressionContext[] {
    return this.getTypedRuleContexts(ExpressionContext) as ExpressionContext[]
  }
  public expression(i: number): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, i) as ExpressionContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_setLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterSetLiteral) {
      listener.enterSetLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitSetLiteral) {
      listener.exitSetLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitSetLiteral) {
      return visitor.visitSetLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ListLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LSQUARE(): TerminalNode {
    return this.getToken(FPlusParser.LSQUARE, 0)
  }
  public RSQUARE(): TerminalNode {
    return this.getToken(FPlusParser.RSQUARE, 0)
  }
  public expression_list(): ExpressionContext[] {
    return this.getTypedRuleContexts(ExpressionContext) as ExpressionContext[]
  }
  public expression(i: number): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, i) as ExpressionContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_listLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterListLiteral) {
      listener.enterListLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitListLiteral) {
      listener.exitListLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitListLiteral) {
      return visitor.visitListLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class RangeLiteralContext extends ParserRuleContext {
  public _startInc!: Token
  public _min!: ExpressionContext
  public _max!: ExpressionContext
  public _endInc!: Token
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public RANGE(): TerminalNode {
    return this.getToken(FPlusParser.RANGE, 0)
  }
  public expression_list(): ExpressionContext[] {
    return this.getTypedRuleContexts(ExpressionContext) as ExpressionContext[]
  }
  public expression(i: number): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, i) as ExpressionContext
  }
  public RSQUARE_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.RSQUARE)
  }
  public RSQUARE(i: number): TerminalNode {
    return this.getToken(FPlusParser.RSQUARE, i)
  }
  public LSQUARE_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.LSQUARE)
  }
  public LSQUARE(i: number): TerminalNode {
    return this.getToken(FPlusParser.LSQUARE, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_rangeLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterRangeLiteral) {
      listener.enterRangeLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitRangeLiteral) {
      listener.exitRangeLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitRangeLiteral) {
      return visitor.visitRangeLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TupleLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public expression_list(): ExpressionContext[] {
    return this.getTypedRuleContexts(ExpressionContext) as ExpressionContext[]
  }
  public expression(i: number): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, i) as ExpressionContext
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_tupleLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterTupleLiteral) {
      listener.enterTupleLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitTupleLiteral) {
      listener.exitTupleLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitTupleLiteral) {
      return visitor.visitTupleLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ImplicitVariableLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public UNDERSCORE(): TerminalNode {
    return this.getToken(FPlusParser.UNDERSCORE, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_implicitVariableLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterImplicitVariableLiteral) {
      listener.enterImplicitVariableLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitImplicitVariableLiteral) {
      listener.exitImplicitVariableLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitImplicitVariableLiteral) {
      return visitor.visitImplicitVariableLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ImplicitNavigationContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public DOT(): TerminalNode {
    return this.getToken(FPlusParser.DOT, 0)
  }
  public Identifier(): TerminalNode {
    return this.getToken(FPlusParser.Identifier, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_implicitNavigation
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterImplicitNavigation) {
      listener.enterImplicitNavigation(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitImplicitNavigation) {
      listener.exitImplicitNavigation(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitImplicitNavigation) {
      return visitor.visitImplicitNavigation(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LiteralConstantContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public BooleanLiteral(): TerminalNode {
    return this.getToken(FPlusParser.BooleanLiteral, 0)
  }
  public UndefinedLiteral(): TerminalNode {
    return this.getToken(FPlusParser.UndefinedLiteral, 0)
  }
  public IntegerLiteral(): TerminalNode {
    return this.getToken(FPlusParser.IntegerLiteral, 0)
  }
  public DecimalLiteral(): TerminalNode {
    return this.getToken(FPlusParser.DecimalLiteral, 0)
  }
  public MoneyDecimalLiteral(): TerminalNode {
    return this.getToken(FPlusParser.MoneyDecimalLiteral, 0)
  }
  public MoneyLiteral(): TerminalNode {
    return this.getToken(FPlusParser.MoneyLiteral, 0)
  }
  public DateLiteral(): TerminalNode {
    return this.getToken(FPlusParser.DateLiteral, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_literalConstant
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterLiteralConstant) {
      listener.enterLiteralConstant(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitLiteralConstant) {
      listener.exitLiteralConstant(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitLiteralConstant) {
      return visitor.visitLiteralConstant(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class StringLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public lineStringLiteral(): LineStringLiteralContext {
    return this.getTypedRuleContext(
      LineStringLiteralContext,
      0,
    ) as LineStringLiteralContext
  }
  public multiLineStringLiteral(): MultiLineStringLiteralContext {
    return this.getTypedRuleContext(
      MultiLineStringLiteralContext,
      0,
    ) as MultiLineStringLiteralContext
  }
  public singleQuoteStringLiteral(): SingleQuoteStringLiteralContext {
    return this.getTypedRuleContext(
      SingleQuoteStringLiteralContext,
      0,
    ) as SingleQuoteStringLiteralContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_stringLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterStringLiteral) {
      listener.enterStringLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitStringLiteral) {
      listener.exitStringLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitStringLiteral) {
      return visitor.visitStringLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class SingleQuoteStringLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public SINGLE_QUOTE_OPEN(): TerminalNode {
    return this.getToken(FPlusParser.SINGLE_QUOTE_OPEN, 0)
  }
  public SINGLE_QUOTE_CLOSE(): TerminalNode {
    return this.getToken(FPlusParser.SINGLE_QUOTE_CLOSE, 0)
  }
  public singleLineStringLiteralEntry_list(): SingleLineStringLiteralEntryContext[] {
    return this.getTypedRuleContexts(
      SingleLineStringLiteralEntryContext,
    ) as SingleLineStringLiteralEntryContext[]
  }
  public singleLineStringLiteralEntry(
    i: number,
  ): SingleLineStringLiteralEntryContext {
    return this.getTypedRuleContext(
      SingleLineStringLiteralEntryContext,
      i,
    ) as SingleLineStringLiteralEntryContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_singleQuoteStringLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterSingleQuoteStringLiteral) {
      listener.enterSingleQuoteStringLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitSingleQuoteStringLiteral) {
      listener.exitSingleQuoteStringLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitSingleQuoteStringLiteral) {
      return visitor.visitSingleQuoteStringLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class SingleLineStringLiteralEntryContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public singleLineStringContent(): SingleLineStringContentContext {
    return this.getTypedRuleContext(
      SingleLineStringContentContext,
      0,
    ) as SingleLineStringContentContext
  }
  public singleLineStringExpression(): SingleLineStringExpressionContext {
    return this.getTypedRuleContext(
      SingleLineStringExpressionContext,
      0,
    ) as SingleLineStringExpressionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_singleLineStringLiteralEntry
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterSingleLineStringLiteralEntry) {
      listener.enterSingleLineStringLiteralEntry(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitSingleLineStringLiteralEntry) {
      listener.exitSingleLineStringLiteralEntry(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitSingleLineStringLiteralEntry) {
      return visitor.visitSingleLineStringLiteralEntry(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class SingleLineStringContentContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public SingleLineStrText(): TerminalNode {
    return this.getToken(FPlusParser.SingleLineStrText, 0)
  }
  public SingleLineStrEscapedChar(): TerminalNode {
    return this.getToken(FPlusParser.SingleLineStrEscapedChar, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_singleLineStringContent
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterSingleLineStringContent) {
      listener.enterSingleLineStringContent(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitSingleLineStringContent) {
      listener.exitSingleLineStringContent(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitSingleLineStringContent) {
      return visitor.visitSingleLineStringContent(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class SingleLineStringExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public SingleLineStrExprStart(): TerminalNode {
    return this.getToken(FPlusParser.SingleLineStrExprStart, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public RCURL(): TerminalNode {
    return this.getToken(FPlusParser.RCURL, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_singleLineStringExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterSingleLineStringExpression) {
      listener.enterSingleLineStringExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitSingleLineStringExpression) {
      listener.exitSingleLineStringExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitSingleLineStringExpression) {
      return visitor.visitSingleLineStringExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LineStringLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public QUOTE_OPEN(): TerminalNode {
    return this.getToken(FPlusParser.QUOTE_OPEN, 0)
  }
  public QUOTE_CLOSE(): TerminalNode {
    return this.getToken(FPlusParser.QUOTE_CLOSE, 0)
  }
  public lineStringLiteralEntry_list(): LineStringLiteralEntryContext[] {
    return this.getTypedRuleContexts(
      LineStringLiteralEntryContext,
    ) as LineStringLiteralEntryContext[]
  }
  public lineStringLiteralEntry(i: number): LineStringLiteralEntryContext {
    return this.getTypedRuleContext(
      LineStringLiteralEntryContext,
      i,
    ) as LineStringLiteralEntryContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_lineStringLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterLineStringLiteral) {
      listener.enterLineStringLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitLineStringLiteral) {
      listener.exitLineStringLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitLineStringLiteral) {
      return visitor.visitLineStringLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LineStringLiteralEntryContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public lineStringContent(): LineStringContentContext {
    return this.getTypedRuleContext(
      LineStringContentContext,
      0,
    ) as LineStringContentContext
  }
  public lineStringExpression(): LineStringExpressionContext {
    return this.getTypedRuleContext(
      LineStringExpressionContext,
      0,
    ) as LineStringExpressionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_lineStringLiteralEntry
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterLineStringLiteralEntry) {
      listener.enterLineStringLiteralEntry(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitLineStringLiteralEntry) {
      listener.exitLineStringLiteralEntry(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitLineStringLiteralEntry) {
      return visitor.visitLineStringLiteralEntry(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LineStringContentContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LineStrText(): TerminalNode {
    return this.getToken(FPlusParser.LineStrText, 0)
  }
  public LineStrEscapedChar(): TerminalNode {
    return this.getToken(FPlusParser.LineStrEscapedChar, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_lineStringContent
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterLineStringContent) {
      listener.enterLineStringContent(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitLineStringContent) {
      listener.exitLineStringContent(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitLineStringContent) {
      return visitor.visitLineStringContent(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LineStringExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LineStrExprStart(): TerminalNode {
    return this.getToken(FPlusParser.LineStrExprStart, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public RCURL(): TerminalNode {
    return this.getToken(FPlusParser.RCURL, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_lineStringExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterLineStringExpression) {
      listener.enterLineStringExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitLineStringExpression) {
      listener.exitLineStringExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitLineStringExpression) {
      return visitor.visitLineStringExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class MultiLineStringLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public TRIPLE_QUOTE_OPEN(): TerminalNode {
    return this.getToken(FPlusParser.TRIPLE_QUOTE_OPEN, 0)
  }
  public TRIPLE_QUOTE_CLOSE(): TerminalNode {
    return this.getToken(FPlusParser.TRIPLE_QUOTE_CLOSE, 0)
  }
  public multiLineStringLiteralEntry_list(): MultiLineStringLiteralEntryContext[] {
    return this.getTypedRuleContexts(
      MultiLineStringLiteralEntryContext,
    ) as MultiLineStringLiteralEntryContext[]
  }
  public multiLineStringLiteralEntry(
    i: number,
  ): MultiLineStringLiteralEntryContext {
    return this.getTypedRuleContext(
      MultiLineStringLiteralEntryContext,
      i,
    ) as MultiLineStringLiteralEntryContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_multiLineStringLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterMultiLineStringLiteral) {
      listener.enterMultiLineStringLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitMultiLineStringLiteral) {
      listener.exitMultiLineStringLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitMultiLineStringLiteral) {
      return visitor.visitMultiLineStringLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class MultiLineStringLiteralEntryContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public multiLineStringContent(): MultiLineStringContentContext {
    return this.getTypedRuleContext(
      MultiLineStringContentContext,
      0,
    ) as MultiLineStringContentContext
  }
  public multiLineStringExpression(): MultiLineStringExpressionContext {
    return this.getTypedRuleContext(
      MultiLineStringExpressionContext,
      0,
    ) as MultiLineStringExpressionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_multiLineStringLiteralEntry
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterMultiLineStringLiteralEntry) {
      listener.enterMultiLineStringLiteralEntry(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitMultiLineStringLiteralEntry) {
      listener.exitMultiLineStringLiteralEntry(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitMultiLineStringLiteralEntry) {
      return visitor.visitMultiLineStringLiteralEntry(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class MultiLineStringContentContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public MultiLineStrEscapedChar(): TerminalNode {
    return this.getToken(FPlusParser.MultiLineStrEscapedChar, 0)
  }
  public MultiLineStrText(): TerminalNode {
    return this.getToken(FPlusParser.MultiLineStrText, 0)
  }
  public MultiLineStringQuote(): TerminalNode {
    return this.getToken(FPlusParser.MultiLineStringQuote, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_multiLineStringContent
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterMultiLineStringContent) {
      listener.enterMultiLineStringContent(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitMultiLineStringContent) {
      listener.exitMultiLineStringContent(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitMultiLineStringContent) {
      return visitor.visitMultiLineStringContent(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class MultiLineStringExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public MultiLineStrExprStart(): TerminalNode {
    return this.getToken(FPlusParser.MultiLineStrExprStart, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public RCURL(): TerminalNode {
    return this.getToken(FPlusParser.RCURL, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_multiLineStringExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterMultiLineStringExpression) {
      listener.enterMultiLineStringExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitMultiLineStringExpression) {
      listener.exitMultiLineStringExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitMultiLineStringExpression) {
      return visitor.visitMultiLineStringExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LambdaLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public ARROW(): TerminalNode {
    return this.getToken(FPlusParser.ARROW, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public functionValueParametersWithOptionalType(): FunctionValueParametersWithOptionalTypeContext {
    return this.getTypedRuleContext(
      FunctionValueParametersWithOptionalTypeContext,
      0,
    ) as FunctionValueParametersWithOptionalTypeContext
  }
  public parameterWithOptionalType(): ParameterWithOptionalTypeContext {
    return this.getTypedRuleContext(
      ParameterWithOptionalTypeContext,
      0,
    ) as ParameterWithOptionalTypeContext
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_lambdaLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterLambdaLiteral) {
      listener.enterLambdaLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitLambdaLiteral) {
      listener.exitLambdaLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitLambdaLiteral) {
      return visitor.visitLambdaLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class AnonymousFunctionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public FUN(): TerminalNode {
    return this.getToken(FPlusParser.FUN, 0)
  }
  public functionValueParametersWithOptionalType(): FunctionValueParametersWithOptionalTypeContext {
    return this.getTypedRuleContext(
      FunctionValueParametersWithOptionalTypeContext,
      0,
    ) as FunctionValueParametersWithOptionalTypeContext
  }
  public COLON(): TerminalNode {
    return this.getToken(FPlusParser.COLON, 0)
  }
  public type_(): TypeContext {
    return this.getTypedRuleContext(TypeContext, 0) as TypeContext
  }
  public receiverType(): ReceiverTypeContext {
    return this.getTypedRuleContext(
      ReceiverTypeContext,
      0,
    ) as ReceiverTypeContext
  }
  public DOT(): TerminalNode {
    return this.getToken(FPlusParser.DOT, 0)
  }
  public DOUBLE_ARROW(): TerminalNode {
    return this.getToken(FPlusParser.DOUBLE_ARROW, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_anonymousFunction
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterAnonymousFunction) {
      listener.enterAnonymousFunction(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitAnonymousFunction) {
      listener.exitAnonymousFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitAnonymousFunction) {
      return visitor.visitAnonymousFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class FunctionLiteralContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public lambdaLiteral(): LambdaLiteralContext {
    return this.getTypedRuleContext(
      LambdaLiteralContext,
      0,
    ) as LambdaLiteralContext
  }
  public anonymousFunction(): AnonymousFunctionContext {
    return this.getTypedRuleContext(
      AnonymousFunctionContext,
      0,
    ) as AnonymousFunctionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_functionLiteral
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterFunctionLiteral) {
      listener.enterFunctionLiteral(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitFunctionLiteral) {
      listener.exitFunctionLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitFunctionLiteral) {
      return visitor.visitFunctionLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class IfExpressionContext extends ParserRuleContext {
  public _cond!: ExpressionContext
  public _thenB!: ExpressionContext
  public _elseB!: ExpressionContext
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public IF(): TerminalNode {
    return this.getToken(FPlusParser.IF, 0)
  }
  public THEN(): TerminalNode {
    return this.getToken(FPlusParser.THEN, 0)
  }
  public ELSE(): TerminalNode {
    return this.getToken(FPlusParser.ELSE, 0)
  }
  public expression_list(): ExpressionContext[] {
    return this.getTypedRuleContexts(ExpressionContext) as ExpressionContext[]
  }
  public expression(i: number): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, i) as ExpressionContext
  }
  public SEMICOLON(): TerminalNode {
    return this.getToken(FPlusParser.SEMICOLON, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_ifExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterIfExpression) {
      listener.enterIfExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitIfExpression) {
      listener.exitIfExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitIfExpression) {
      return visitor.visitIfExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class WhenSubjectContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public VAR(): TerminalNode {
    return this.getToken(FPlusParser.VAR, 0)
  }
  public variableDeclaration(): VariableDeclarationContext {
    return this.getTypedRuleContext(
      VariableDeclarationContext,
      0,
    ) as VariableDeclarationContext
  }
  public ASSIGNMENT(): TerminalNode {
    return this.getToken(FPlusParser.ASSIGNMENT, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_whenSubject
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterWhenSubject) {
      listener.enterWhenSubject(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitWhenSubject) {
      listener.exitWhenSubject(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitWhenSubject) {
      return visitor.visitWhenSubject(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class WhenExpressionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public WHEN(): TerminalNode {
    return this.getToken(FPlusParser.WHEN, 0)
  }
  public LCURL(): TerminalNode {
    return this.getToken(FPlusParser.LCURL, 0)
  }
  public whenArrowBody(): WhenArrowBodyContext {
    return this.getTypedRuleContext(
      WhenArrowBodyContext,
      0,
    ) as WhenArrowBodyContext
  }
  public RCURL(): TerminalNode {
    return this.getToken(FPlusParser.RCURL, 0)
  }
  public whenSubject(): WhenSubjectContext {
    return this.getTypedRuleContext(WhenSubjectContext, 0) as WhenSubjectContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_whenExpression
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterWhenExpression) {
      listener.enterWhenExpression(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitWhenExpression) {
      listener.exitWhenExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitWhenExpression) {
      return visitor.visitWhenExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class WhenArrowBodyContext extends ParserRuleContext {
  public _elseC!: ExpressionContext
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public ELSE(): TerminalNode {
    return this.getToken(FPlusParser.ELSE, 0)
  }
  public ARROW(): TerminalNode {
    return this.getToken(FPlusParser.ARROW, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public whenArrowEntry_list(): WhenArrowEntryContext[] {
    return this.getTypedRuleContexts(
      WhenArrowEntryContext,
    ) as WhenArrowEntryContext[]
  }
  public whenArrowEntry(i: number): WhenArrowEntryContext {
    return this.getTypedRuleContext(
      WhenArrowEntryContext,
      i,
    ) as WhenArrowEntryContext
  }
  public commaOrSemicolon_list(): CommaOrSemicolonContext[] {
    return this.getTypedRuleContexts(
      CommaOrSemicolonContext,
    ) as CommaOrSemicolonContext[]
  }
  public commaOrSemicolon(i: number): CommaOrSemicolonContext {
    return this.getTypedRuleContext(
      CommaOrSemicolonContext,
      i,
    ) as CommaOrSemicolonContext
  }
  public semi(): SemiContext {
    return this.getTypedRuleContext(SemiContext, 0) as SemiContext
  }
  public whenColonBody(): WhenColonBodyContext {
    return this.getTypedRuleContext(
      WhenColonBodyContext,
      0,
    ) as WhenColonBodyContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_whenArrowBody
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterWhenArrowBody) {
      listener.enterWhenArrowBody(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitWhenArrowBody) {
      listener.exitWhenArrowBody(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitWhenArrowBody) {
      return visitor.visitWhenArrowBody(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class WhenArrowEntryContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public whenCondition_list(): WhenConditionContext[] {
    return this.getTypedRuleContexts(
      WhenConditionContext,
    ) as WhenConditionContext[]
  }
  public whenCondition(i: number): WhenConditionContext {
    return this.getTypedRuleContext(
      WhenConditionContext,
      i,
    ) as WhenConditionContext
  }
  public ARROW(): TerminalNode {
    return this.getToken(FPlusParser.ARROW, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_whenArrowEntry
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterWhenArrowEntry) {
      listener.enterWhenArrowEntry(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitWhenArrowEntry) {
      listener.exitWhenArrowEntry(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitWhenArrowEntry) {
      return visitor.visitWhenArrowEntry(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class WhenColonBodyContext extends ParserRuleContext {
  public _elseC!: ExpressionContext
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public ELSE(): TerminalNode {
    return this.getToken(FPlusParser.ELSE, 0)
  }
  public COLON(): TerminalNode {
    return this.getToken(FPlusParser.COLON, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public whenColonEntry_list(): WhenColonEntryContext[] {
    return this.getTypedRuleContexts(
      WhenColonEntryContext,
    ) as WhenColonEntryContext[]
  }
  public whenColonEntry(i: number): WhenColonEntryContext {
    return this.getTypedRuleContext(
      WhenColonEntryContext,
      i,
    ) as WhenColonEntryContext
  }
  public commaOrSemicolon_list(): CommaOrSemicolonContext[] {
    return this.getTypedRuleContexts(
      CommaOrSemicolonContext,
    ) as CommaOrSemicolonContext[]
  }
  public commaOrSemicolon(i: number): CommaOrSemicolonContext {
    return this.getTypedRuleContext(
      CommaOrSemicolonContext,
      i,
    ) as CommaOrSemicolonContext
  }
  public semi(): SemiContext {
    return this.getTypedRuleContext(SemiContext, 0) as SemiContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_whenColonBody
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterWhenColonBody) {
      listener.enterWhenColonBody(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitWhenColonBody) {
      listener.exitWhenColonBody(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitWhenColonBody) {
      return visitor.visitWhenColonBody(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class WhenColonEntryContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public whenCondition_list(): WhenConditionContext[] {
    return this.getTypedRuleContexts(
      WhenConditionContext,
    ) as WhenConditionContext[]
  }
  public whenCondition(i: number): WhenConditionContext {
    return this.getTypedRuleContext(
      WhenConditionContext,
      i,
    ) as WhenConditionContext
  }
  public COLON(): TerminalNode {
    return this.getToken(FPlusParser.COLON, 0)
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_whenColonEntry
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterWhenColonEntry) {
      listener.enterWhenColonEntry(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitWhenColonEntry) {
      listener.exitWhenColonEntry(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitWhenColonEntry) {
      return visitor.visitWhenColonEntry(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class WhenConditionContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public tupleTest(): TupleTestContext {
    return this.getTypedRuleContext(TupleTestContext, 0) as TupleTestContext
  }
  public rangeTest(): RangeTestContext {
    return this.getTypedRuleContext(RangeTestContext, 0) as RangeTestContext
  }
  public typeTest(): TypeTestContext {
    return this.getTypedRuleContext(TypeTestContext, 0) as TypeTestContext
  }
  public expressionWithoutFunctionLiteral(): ExpressionWithoutFunctionLiteralContext {
    return this.getTypedRuleContext(
      ExpressionWithoutFunctionLiteralContext,
      0,
    ) as ExpressionWithoutFunctionLiteralContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_whenCondition
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterWhenCondition) {
      listener.enterWhenCondition(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitWhenCondition) {
      listener.exitWhenCondition(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitWhenCondition) {
      return visitor.visitWhenCondition(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TupleTestEntryContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public UNDERSCORE(): TerminalNode {
    return this.getToken(FPlusParser.UNDERSCORE, 0)
  }
  public whenCondition(): WhenConditionContext {
    return this.getTypedRuleContext(
      WhenConditionContext,
      0,
    ) as WhenConditionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_tupleTestEntry
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterTupleTestEntry) {
      listener.enterTupleTestEntry(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitTupleTestEntry) {
      listener.exitTupleTestEntry(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitTupleTestEntry) {
      return visitor.visitTupleTestEntry(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TupleTestContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LPAREN(): TerminalNode {
    return this.getToken(FPlusParser.LPAREN, 0)
  }
  public tupleTestEntry_list(): TupleTestEntryContext[] {
    return this.getTypedRuleContexts(
      TupleTestEntryContext,
    ) as TupleTestEntryContext[]
  }
  public tupleTestEntry(i: number): TupleTestEntryContext {
    return this.getTypedRuleContext(
      TupleTestEntryContext,
      i,
    ) as TupleTestEntryContext
  }
  public RPAREN(): TerminalNode {
    return this.getToken(FPlusParser.RPAREN, 0)
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(FPlusParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(FPlusParser.COMMA, i)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_tupleTest
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterTupleTest) {
      listener.enterTupleTest(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitTupleTest) {
      listener.exitTupleTest(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitTupleTest) {
      return visitor.visitTupleTest(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class RangeTestContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public inOperator(): InOperatorContext {
    return this.getTypedRuleContext(InOperatorContext, 0) as InOperatorContext
  }
  public expression(): ExpressionContext {
    return this.getTypedRuleContext(ExpressionContext, 0) as ExpressionContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_rangeTest
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterRangeTest) {
      listener.enterRangeTest(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitRangeTest) {
      listener.exitRangeTest(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitRangeTest) {
      return visitor.visitRangeTest(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TypeTestContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public isOperator(): IsOperatorContext {
    return this.getTypedRuleContext(IsOperatorContext, 0) as IsOperatorContext
  }
  public type_(): TypeContext {
    return this.getTypedRuleContext(TypeContext, 0) as TypeContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_typeTest
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterTypeTest) {
      listener.enterTypeTest(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitTypeTest) {
      listener.exitTypeTest(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitTypeTest) {
      return visitor.visitTypeTest(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class EqualityOperatorContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public EXCL_EQ(): TerminalNode {
    return this.getToken(FPlusParser.EXCL_EQ, 0)
  }
  public ASSIGNMENT(): TerminalNode {
    return this.getToken(FPlusParser.ASSIGNMENT, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_equalityOperator
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterEqualityOperator) {
      listener.enterEqualityOperator(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitEqualityOperator) {
      listener.exitEqualityOperator(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitEqualityOperator) {
      return visitor.visitEqualityOperator(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ComparisonOperatorContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public LANGLE(): TerminalNode {
    return this.getToken(FPlusParser.LANGLE, 0)
  }
  public RANGLE(): TerminalNode {
    return this.getToken(FPlusParser.RANGLE, 0)
  }
  public LE(): TerminalNode {
    return this.getToken(FPlusParser.LE, 0)
  }
  public GE(): TerminalNode {
    return this.getToken(FPlusParser.GE, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_comparisonOperator
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterComparisonOperator) {
      listener.enterComparisonOperator(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitComparisonOperator) {
      listener.exitComparisonOperator(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitComparisonOperator) {
      return visitor.visitComparisonOperator(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class InOperatorContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public IS_IN(): TerminalNode {
    return this.getToken(FPlusParser.IS_IN, 0)
  }
  public NOT_IN(): TerminalNode {
    return this.getToken(FPlusParser.NOT_IN, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_inOperator
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterInOperator) {
      listener.enterInOperator(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitInOperator) {
      listener.exitInOperator(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitInOperator) {
      return visitor.visitInOperator(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class IsOperatorContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public IS(): TerminalNode {
    return this.getToken(FPlusParser.IS, 0)
  }
  public NOT_IS(): TerminalNode {
    return this.getToken(FPlusParser.NOT_IS, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_isOperator
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterIsOperator) {
      listener.enterIsOperator(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitIsOperator) {
      listener.exitIsOperator(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitIsOperator) {
      return visitor.visitIsOperator(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class AdditiveOperatorContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public ADD(): TerminalNode {
    return this.getToken(FPlusParser.ADD, 0)
  }
  public SUB(): TerminalNode {
    return this.getToken(FPlusParser.SUB, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_additiveOperator
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterAdditiveOperator) {
      listener.enterAdditiveOperator(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitAdditiveOperator) {
      listener.exitAdditiveOperator(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitAdditiveOperator) {
      return visitor.visitAdditiveOperator(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class MultiplicativeOperatorContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public MULT(): TerminalNode {
    return this.getToken(FPlusParser.MULT, 0)
  }
  public DIV(): TerminalNode {
    return this.getToken(FPlusParser.DIV, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_multiplicativeOperator
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterMultiplicativeOperator) {
      listener.enterMultiplicativeOperator(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitMultiplicativeOperator) {
      listener.exitMultiplicativeOperator(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitMultiplicativeOperator) {
      return visitor.visitMultiplicativeOperator(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class PowerOperatorContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public POW(): TerminalNode {
    return this.getToken(FPlusParser.POW, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_powerOperator
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterPowerOperator) {
      listener.enterPowerOperator(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitPowerOperator) {
      listener.exitPowerOperator(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitPowerOperator) {
      return visitor.visitPowerOperator(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class PrefixUnaryOperatorContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public SUB(): TerminalNode {
    return this.getToken(FPlusParser.SUB, 0)
  }
  public excl(): ExclContext {
    return this.getTypedRuleContext(ExclContext, 0) as ExclContext
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_prefixUnaryOperator
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterPrefixUnaryOperator) {
      listener.enterPrefixUnaryOperator(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitPrefixUnaryOperator) {
      listener.exitPrefixUnaryOperator(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitPrefixUnaryOperator) {
      return visitor.visitPrefixUnaryOperator(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ExclContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public NOT(): TerminalNode {
    return this.getToken(FPlusParser.NOT, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_excl
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterExcl) {
      listener.enterExcl(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitExcl) {
      listener.exitExcl(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitExcl) {
      return visitor.visitExcl(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class SimpleIdentifierContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public Identifier(): TerminalNode {
    return this.getToken(FPlusParser.Identifier, 0)
  }
  public WHERE(): TerminalNode {
    return this.getToken(FPlusParser.WHERE, 0)
  }
  public MAP(): TerminalNode {
    return this.getToken(FPlusParser.MAP, 0)
  }
  public ASSERT(): TerminalNode {
    return this.getToken(FPlusParser.ASSERT, 0)
  }
  public IS_IN(): TerminalNode {
    return this.getToken(FPlusParser.IS_IN, 0)
  }
  public NOT_IN(): TerminalNode {
    return this.getToken(FPlusParser.NOT_IN, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_simpleIdentifier
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterSimpleIdentifier) {
      listener.enterSimpleIdentifier(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitSimpleIdentifier) {
      listener.exitSimpleIdentifier(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitSimpleIdentifier) {
      return visitor.visitSimpleIdentifier(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class NavigationIdentifierContext extends ParserRuleContext {
  constructor(
    parser?: FPlusParser,
    parent?: ParserRuleContext,
    invokingState?: number,
  ) {
    super(parent, invokingState)
    this.parser = parser
  }
  public Identifier(): TerminalNode {
    return this.getToken(FPlusParser.Identifier, 0)
  }
  public UndefinedLiteral(): TerminalNode {
    return this.getToken(FPlusParser.UndefinedLiteral, 0)
  }
  public WHERE(): TerminalNode {
    return this.getToken(FPlusParser.WHERE, 0)
  }
  public MAP(): TerminalNode {
    return this.getToken(FPlusParser.MAP, 0)
  }
  public ASSERT(): TerminalNode {
    return this.getToken(FPlusParser.ASSERT, 0)
  }
  public get ruleIndex(): number {
    return FPlusParser.RULE_navigationIdentifier
  }
  public enterRule(listener: FPlusParserListener): void {
    if (listener.enterNavigationIdentifier) {
      listener.enterNavigationIdentifier(this)
    }
  }
  public exitRule(listener: FPlusParserListener): void {
    if (listener.exitNavigationIdentifier) {
      listener.exitNavigationIdentifier(this)
    }
  }
  // @Override
  public accept<Result>(visitor: FPlusParserVisitor<Result>): Result {
    if (visitor.visitNavigationIdentifier) {
      return visitor.visitNavigationIdentifier(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
